var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/types/cancellations/cancellations/index.ts
var cancellations_exports = {};
__export(cancellations_exports, {
  cancellationDeliveryStatusResponseDeliveryStatus: () => cancellationDeliveryStatusResponseDeliveryStatus,
  cancellationStatusResponseStatus: () => cancellationStatusResponseStatus,
  cancellations3StatusesQueryParamsSortBy: () => cancellations3StatusesQueryParamsSortBy,
  cancellations3StatusesQueryParamsStatusIn: () => cancellations3StatusesQueryParamsStatusIn,
  cancellationsRequestAuthenticationMethod: () => cancellationsRequestAuthenticationMethod,
  cancellationsRequestDeliveryMethod: () => cancellationsRequestDeliveryMethod,
  cancellationsRequestViewAuthenticationMethod: () => cancellationsRequestViewAuthenticationMethod,
  phoneNumberCountryCode: () => phoneNumberCountryCode,
  sortingMetadataCancellationsSortOrderAvailableSorts: () => sortingMetadataCancellationsSortOrderAvailableSorts,
  sortingMetadataCancellationsSortOrderCurrentSort: () => sortingMetadataCancellationsSortOrderCurrentSort
});

// src/types/cancellations/cancellations/types/CancellationDeliveryStatusResponse.ts
var cancellationDeliveryStatusResponseDeliveryStatus = {
  "UNKNOWN": "UNKNOWN",
  "FAILED": "FAILED",
  "DELIVERED": "DELIVERED",
  "DEFERRED": "DEFERRED"
};

// src/types/cancellations/cancellations/types/CancellationStatusResponse.ts
var cancellationStatusResponseStatus = {
  "PREPARATION": "PREPARATION",
  "CREATED": "CREATED",
  "PENDING": "PENDING",
  "CLOSED": "CLOSED",
  "CANCELED": "CANCELED",
  "TIMED_OUT": "TIMED_OUT",
  "REJECTED": "REJECTED",
  "DOCUMENT_ERROR": "DOCUMENT_ERROR"
};

// src/types/cancellations/cancellations/types/Cancellations3Statuses.ts
var cancellations3StatusesQueryParamsStatusIn = {
  "PREPARATION": "PREPARATION",
  "CREATED": "CREATED",
  "PENDING": "PENDING",
  "CLOSED": "CLOSED",
  "CANCELED": "CANCELED",
  "TIMED_OUT": "TIMED_OUT",
  "REJECTED": "REJECTED",
  "DOCUMENT_ERROR": "DOCUMENT_ERROR"
};
var cancellations3StatusesQueryParamsSortBy = {
  "CREATED_AT_ASC": "CREATED_AT_ASC",
  "CREATED_AT_DESC": "CREATED_AT_DESC",
  "UPDATED_AT_ASC": "UPDATED_AT_ASC",
  "UPDATED_AT_DESC": "UPDATED_AT_DESC"
};

// src/types/cancellations/cancellations/types/CancellationsRequest.ts
var cancellationsRequestAuthenticationMethod = {
  "BANK_ID": "BANK_ID",
  "STANDARD": "STANDARD"
};
var cancellationsRequestViewAuthenticationMethod = {
  "BANK_ID": "BANK_ID",
  "STANDARD": "STANDARD"
};
var cancellationsRequestDeliveryMethod = {
  "EMAIL": "EMAIL",
  "SMS": "SMS",
  "API": "API"
};

// src/types/cancellations/cancellations/types/PhoneNumber.ts
var phoneNumberCountryCode = {
  "FR": "FR",
  "UK": "UK",
  "DK": "DK",
  "SE": "SE",
  "NO": "NO"
};

// src/types/cancellations/cancellations/types/SortingMetadataCancellationsSortOrder.ts
var sortingMetadataCancellationsSortOrderCurrentSort = {
  "CREATED_AT_ASC": "CREATED_AT_ASC",
  "CREATED_AT_DESC": "CREATED_AT_DESC",
  "UPDATED_AT_ASC": "UPDATED_AT_ASC",
  "UPDATED_AT_DESC": "UPDATED_AT_DESC"
};
var sortingMetadataCancellationsSortOrderAvailableSorts = {
  "CREATED_AT_ASC": "CREATED_AT_ASC",
  "CREATED_AT_DESC": "CREATED_AT_DESC",
  "UPDATED_AT_ASC": "UPDATED_AT_ASC",
  "UPDATED_AT_DESC": "UPDATED_AT_DESC"
};

// src/types/export-api/export-v2023-06-05/index.ts
var export_v2023_06_05_exports = {};

// src/types/export-api/export-v2024-06-01/index.ts
var export_v2024_06_01_exports = {};

// src/types/insurance-api/v3/index.ts
var v3_exports = {};
__export(v3_exports, {
  additionalBuildingBuildingType: () => additionalBuildingBuildingType,
  additionalBuildingCottageBuildingType: () => additionalBuildingCottageBuildingType,
  collection1CollectInfoHeaderParamsInsurelyVersion: () => collection1CollectInfoHeaderParamsInsurelyVersion,
  collection2StatusHeaderParamsInsurelyVersion: () => collection2StatusHeaderParamsInsurelyVersion,
  collection3GetDataHeaderParamsInsurelyLanguage: () => collection3GetDataHeaderParamsInsurelyLanguage,
  collection3GetDataHeaderParamsInsurelyVersion: () => collection3GetDataHeaderParamsInsurelyVersion,
  collection3SupplementInformationHeaderParamsInsurelyVersion: () => collection3SupplementInformationHeaderParamsInsurelyVersion,
  collection4GetParametersHeaderParamsInsurelyLanguage: () => collection4GetParametersHeaderParamsInsurelyLanguage,
  collection4GetParametersHeaderParamsInsurelyVersion: () => collection4GetParametersHeaderParamsInsurelyVersion,
  collection5GetAllParametersHeaderParamsInsurelyLanguage: () => collection5GetAllParametersHeaderParamsInsurelyLanguage,
  collection5GetAllParametersHeaderParamsInsurelyVersion: () => collection5GetAllParametersHeaderParamsInsurelyVersion,
  collectionRequestFilterRuleField: () => collectionRequestFilterRuleField,
  collectionRequestV2LoginMethod: () => collectionRequestV2LoginMethod,
  companyAvailabilityCompanyAndLineOfBusinesses: () => companyAvailabilityCompanyAndLineOfBusinesses,
  companyAvailabilityLoginMethods: () => companyAvailabilityLoginMethods,
  companyAvailabilityNonFunctionalLoginMethods: () => companyAvailabilityNonFunctionalLoginMethods,
  companyAvailabilityReason: () => companyAvailabilityReason,
  companyAvailabilityStatus: () => companyAvailabilityStatus,
  companyLoginConfigPasswordFieldPlaceholder: () => companyLoginConfigPasswordFieldPlaceholder,
  companyLoginConfigPasswordLabel: () => companyLoginConfigPasswordLabel,
  companyLoginConfigUsernameFieldPlaceholder: () => companyLoginConfigUsernameFieldPlaceholder,
  companyLoginConfigUsernameLabel: () => companyLoginConfigUsernameLabel,
  consentRequestInputType: () => consentRequestInputType,
  consentRequirementMethod: () => consentRequirementMethod,
  consentRequirementType: () => consentRequirementType,
  coreInsuranceHomeInsuranceHolderGender: () => coreInsuranceHomeInsuranceHolderGender,
  coreInsuranceHomePaymentMethod: () => coreInsuranceHomePaymentMethod,
  coreInsuranceVillaInsuranceHolderGender: () => coreInsuranceVillaInsuranceHolderGender,
  coreInsuranceVillaPaymentMethod: () => coreInsuranceVillaPaymentMethod,
  coverageParameterValueDeductibleDeductibleType: () => coverageParameterValueDeductibleDeductibleType,
  coverageParameterValueLimitLimitType: () => coverageParameterValueLimitLimitType,
  farmPropertyBuildingType: () => farmPropertyBuildingType,
  frenchInsuranceCarInsuranceHolderGender: () => frenchInsuranceCarInsuranceHolderGender,
  frenchInsuranceCarUsagePurposes: () => frenchInsuranceCarUsagePurposes,
  frenchInsuranceHomeAdditionalAmenities: () => frenchInsuranceHomeAdditionalAmenities,
  frenchInsuranceHomeFloor: () => frenchInsuranceHomeFloor,
  frenchInsuranceHomeInsuranceHolderGender: () => frenchInsuranceHomeInsuranceHolderGender,
  frenchInsuranceHomeOwnershipStatus: () => frenchInsuranceHomeOwnershipStatus,
  frenchInsuranceHomePaymentMethod: () => frenchInsuranceHomePaymentMethod,
  frenchInsuranceHomeResidentialStatus: () => frenchInsuranceHomeResidentialStatus,
  frenchInsuranceHouseContentAdditionalAmenities: () => frenchInsuranceHouseContentAdditionalAmenities,
  frenchInsuranceHouseContentOwnershipStatus: () => frenchInsuranceHouseContentOwnershipStatus,
  frenchInsuranceHouseContentResidentialStatus: () => frenchInsuranceHouseContentResidentialStatus,
  frenchInsuranceInsuranceHolderGender: () => frenchInsuranceInsuranceHolderGender,
  frenchInsuranceVehicleUsagePurposes: () => frenchInsuranceVehicleUsagePurposes,
  frenchInsuranceVillaAdditionalAmenities: () => frenchInsuranceVillaAdditionalAmenities,
  frenchInsuranceVillaInsuranceHolderGender: () => frenchInsuranceVillaInsuranceHolderGender,
  frenchInsuranceVillaOwnershipStatus: () => frenchInsuranceVillaOwnershipStatus,
  frenchInsuranceVillaPaymentMethod: () => frenchInsuranceVillaPaymentMethod,
  frenchInsuranceVillaResidentialStatus: () => frenchInsuranceVillaResidentialStatus,
  frenchParkingLocationParkingLocationType: () => frenchParkingLocationParkingLocationType,
  frenchVehicleOwnershipStatus: () => frenchVehicleOwnershipStatus,
  getCompaniesStatusHeaderParamsInsurelyVersion: () => getCompaniesStatusHeaderParamsInsurelyVersion,
  getParametersRequestInsuranceCompany: () => getParametersRequestInsuranceCompany,
  insuranceAccidentInsuranceHolderGender: () => insuranceAccidentInsuranceHolderGender,
  insuranceAccidentPaymentMethod: () => insuranceAccidentPaymentMethod,
  insuranceAnimalAnimalGender: () => insuranceAnimalAnimalGender,
  insuranceAnimalInsuranceHolderGender: () => insuranceAnimalInsuranceHolderGender,
  insuranceAnimalPaymentMethod: () => insuranceAnimalPaymentMethod,
  insuranceCarCoverage: () => insuranceCarCoverage,
  insuranceCarInsuranceLevel: () => insuranceCarInsuranceLevel,
  insuranceChildInsuranceHolderGender: () => insuranceChildInsuranceHolderGender,
  insuranceChildPaymentMethod: () => insuranceChildPaymentMethod,
  insuranceCompany: () => insuranceCompany,
  insuranceCottageInsuranceHolderGender: () => insuranceCottageInsuranceHolderGender,
  insuranceCottagePaymentMethod: () => insuranceCottagePaymentMethod,
  insuranceFarmInsuranceHolderGender: () => insuranceFarmInsuranceHolderGender,
  insuranceFarmPaymentMethod: () => insuranceFarmPaymentMethod,
  insuranceGeneralInsuranceHolderGender: () => insuranceGeneralInsuranceHolderGender,
  insuranceGeneralPaymentMethod: () => insuranceGeneralPaymentMethod,
  insuranceHouseContentInsuranceHolderGender: () => insuranceHouseContentInsuranceHolderGender,
  insuranceHouseContentPaymentMethod: () => insuranceHouseContentPaymentMethod,
  insuranceIncomeInsuranceHolderGender: () => insuranceIncomeInsuranceHolderGender,
  insuranceIncomePaymentMethod: () => insuranceIncomePaymentMethod,
  insuranceInsuranceHolderGender: () => insuranceInsuranceHolderGender,
  insuranceLifeInsuranceHolderGender: () => insuranceLifeInsuranceHolderGender,
  insuranceLifePaymentMethod: () => insuranceLifePaymentMethod,
  insuranceOtherVehicleInsuranceHolderGender: () => insuranceOtherVehicleInsuranceHolderGender,
  insuranceOtherVehiclePaymentMethod: () => insuranceOtherVehiclePaymentMethod,
  insurancePaymentMethod: () => insurancePaymentMethod,
  insurancePersonInsuranceHolderGender: () => insurancePersonInsuranceHolderGender,
  insurancePersonPaymentMethod: () => insurancePersonPaymentMethod,
  insurancePregnancyInsuranceHolderGender: () => insurancePregnancyInsuranceHolderGender,
  insurancePregnancyPaymentMethod: () => insurancePregnancyPaymentMethod,
  insuranceVehicleInsuranceHolderGender: () => insuranceVehicleInsuranceHolderGender,
  insuranceVehiclePaymentMethod: () => insuranceVehiclePaymentMethod,
  market: () => market,
  monetaryAmountCurrencyCode: () => monetaryAmountCurrencyCode,
  premiumFrequency: () => premiumFrequency,
  premiumTaxation: () => premiumTaxation,
  swedishInsuranceHomeInsuranceHolderGender: () => swedishInsuranceHomeInsuranceHolderGender,
  swedishInsuranceHomePaymentMethod: () => swedishInsuranceHomePaymentMethod,
  swedishInsuranceVillaInsuranceHolderGender: () => swedishInsuranceVillaInsuranceHolderGender,
  swedishInsuranceVillaPaymentMethod: () => swedishInsuranceVillaPaymentMethod
});

// src/types/insurance-api/v3/types/AdditionalBuilding.ts
var additionalBuildingBuildingType = {
  "BARN": "BARN",
  "BOAT_HOUSE": "BOAT_HOUSE",
  "GUEST_HOUSE": "GUEST_HOUSE",
  "CARPORT": "CARPORT",
  "ENCLOSED_PORCH": "ENCLOSED_PORCH",
  "GARAGE": "GARAGE",
  "GAZEBO": "GAZEBO",
  "GREEN_HOUSE": "GREEN_HOUSE",
  "POOL": "POOL",
  "SAUNA": "SAUNA",
  "SHED": "SHED",
  "STABLE": "STABLE",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v3/types/AdditionalBuildingCottage.ts
var additionalBuildingCottageBuildingType = {
  "BARN": "BARN",
  "BOAT_HOUSE": "BOAT_HOUSE",
  "GUEST_HOUSE": "GUEST_HOUSE",
  "CARPORT": "CARPORT",
  "ENCLOSED_PORCH": "ENCLOSED_PORCH",
  "GARAGE": "GARAGE",
  "GAZEBO": "GAZEBO",
  "GREEN_HOUSE": "GREEN_HOUSE",
  "POOL": "POOL",
  "SAUNA": "SAUNA",
  "SHED": "SHED",
  "STABLE": "STABLE",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v3/types/Collection1CollectInfo.ts
var collection1CollectInfoHeaderParamsInsurelyVersion = {
  "2021-01-01": "2021-01-01"
};

// src/types/insurance-api/v3/types/Collection2Status.ts
var collection2StatusHeaderParamsInsurelyVersion = {
  "2021-01-01": "2021-01-01"
};

// src/types/insurance-api/v3/types/Collection3GetData.ts
var collection3GetDataHeaderParamsInsurelyLanguage = {
  "SWEDISH": "SWEDISH",
  "ENGLISH": "ENGLISH",
  "NORWEGIAN": "NORWEGIAN",
  "DANISH": "DANISH",
  "ESTONIAN": "ESTONIAN",
  "FRENCH": "FRENCH"
};
var collection3GetDataHeaderParamsInsurelyVersion = {
  "2021-01-01": "2021-01-01"
};

// src/types/insurance-api/v3/types/Collection3SupplementInformation.ts
var collection3SupplementInformationHeaderParamsInsurelyVersion = {
  "2021-01-01": "2021-01-01"
};

// src/types/insurance-api/v3/types/Collection4GetParameters.ts
var collection4GetParametersHeaderParamsInsurelyLanguage = {
  "SWEDISH": "SWEDISH",
  "ENGLISH": "ENGLISH",
  "NORWEGIAN": "NORWEGIAN",
  "DANISH": "DANISH",
  "ESTONIAN": "ESTONIAN",
  "FRENCH": "FRENCH"
};
var collection4GetParametersHeaderParamsInsurelyVersion = {
  "2021-01-01": "2021-01-01"
};

// src/types/insurance-api/v3/types/Collection5GetAllParameters.ts
var collection5GetAllParametersHeaderParamsInsurelyLanguage = {
  "SWEDISH": "SWEDISH",
  "ENGLISH": "ENGLISH",
  "NORWEGIAN": "NORWEGIAN",
  "DANISH": "DANISH",
  "ESTONIAN": "ESTONIAN",
  "FRENCH": "FRENCH"
};
var collection5GetAllParametersHeaderParamsInsurelyVersion = {
  "2021-01-01": "2021-01-01"
};

// src/types/insurance-api/v3/types/CollectionRequestFilterRule.ts
var collectionRequestFilterRuleField = {
  "registrationNo": "registrationNo"
};

// src/types/insurance-api/v3/types/CollectionRequestV2.ts
var collectionRequestV2LoginMethod = {
  "DANISH_NEMID": "DANISH_NEMID",
  "DANISH_MITID": "DANISH_MITID",
  "DANISH_MITID_SAME_DEVICE": "DANISH_MITID_SAME_DEVICE",
  "ESTONIAN_MOBILE_ID": "ESTONIAN_MOBILE_ID",
  "ESTONIAN_SMART_ID": "ESTONIAN_SMART_ID",
  "ESTONIAN_MOBILE_ID_USERNAME": "ESTONIAN_MOBILE_ID_USERNAME",
  "ESTONIAN_SMART_ID_USERNAME": "ESTONIAN_SMART_ID_USERNAME",
  "LATVIAN_MOBILE_EPARAKSTS": "LATVIAN_MOBILE_EPARAKSTS",
  "LATVIAN_SMART_ID": "LATVIAN_SMART_ID",
  "LATVIAN_MOBILE_EPARAKSTS_USERNAME": "LATVIAN_MOBILE_EPARAKSTS_USERNAME",
  "LATVIAN_SMART_ID_USERNAME": "LATVIAN_SMART_ID_USERNAME",
  "LITHUANIAN_SMART_ID": "LITHUANIAN_SMART_ID",
  "LITHUANIAN_MOBILE_ID": "LITHUANIAN_MOBILE_ID",
  "NORWEGIAN_BANKID_ON_MOBILE": "NORWEGIAN_BANKID_ON_MOBILE",
  "NORWEGIAN_BANKID_ON_MOBILE_FULL_PERSONAL_NUMBER": "NORWEGIAN_BANKID_ON_MOBILE_FULL_PERSONAL_NUMBER",
  "SWEDISH_MOBILE_BANKID_ANY_DEVICE": "SWEDISH_MOBILE_BANKID_ANY_DEVICE",
  "SWEDISH_MOBILE_BANKID_OTHER_DEVICE": "SWEDISH_MOBILE_BANKID_OTHER_DEVICE",
  "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_MOCK": "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_MOCK",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE": "SWEDISH_MOBILE_BANKID_SAME_DEVICE",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION": "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION_MOCK": "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION_MOCK",
  "SWEDISH_MOBILE_BANKID_ANY_DEVICE_TEST": "SWEDISH_MOBILE_BANKID_ANY_DEVICE_TEST",
  "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_TEST": "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_TEST",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE_TEST": "SWEDISH_MOBILE_BANKID_SAME_DEVICE_TEST",
  "SWEDISH_SECURITY_TOKEN": "SWEDISH_SECURITY_TOKEN",
  "UK_DOB_USERNAME_PASSWORD": "UK_DOB_USERNAME_PASSWORD",
  "UK_LASTNAME_MEMBERSHIP_NUMBER": "UK_LASTNAME_MEMBERSHIP_NUMBER",
  "UK_USERNAME_POSTCODE": "UK_USERNAME_POSTCODE",
  "USERNAME_AND_PASSWORD": "USERNAME_AND_PASSWORD",
  "EMAIL": "EMAIL",
  "PDF_UPLOAD": "PDF_UPLOAD"
};

// src/types/insurance-api/v3/types/CompanyAvailability.ts
var companyAvailabilityStatus = {
  "OK": "OK",
  "BETA": "BETA",
  "NOT_IMPLEMENTED": "NOT_IMPLEMENTED"
};
var companyAvailabilityReason = {
  "THIRD_PARTY_ERROR": "THIRD_PARTY_ERROR",
  "THIRD_PARTY_UPDATE": "THIRD_PARTY_UPDATE",
  "INSURELY_ERROR": "INSURELY_ERROR",
  "INSURELY_UPDATE": "INSURELY_UPDATE",
  "RECONSTRUCTION": "RECONSTRUCTION"
};
var companyAvailabilityLoginMethods = {
  "DANISH_NEMID": "DANISH_NEMID",
  "DANISH_MITID": "DANISH_MITID",
  "DANISH_MITID_SAME_DEVICE": "DANISH_MITID_SAME_DEVICE",
  "ESTONIAN_MOBILE_ID": "ESTONIAN_MOBILE_ID",
  "ESTONIAN_SMART_ID": "ESTONIAN_SMART_ID",
  "ESTONIAN_MOBILE_ID_USERNAME": "ESTONIAN_MOBILE_ID_USERNAME",
  "ESTONIAN_SMART_ID_USERNAME": "ESTONIAN_SMART_ID_USERNAME",
  "LATVIAN_MOBILE_EPARAKSTS": "LATVIAN_MOBILE_EPARAKSTS",
  "LATVIAN_SMART_ID": "LATVIAN_SMART_ID",
  "LATVIAN_MOBILE_EPARAKSTS_USERNAME": "LATVIAN_MOBILE_EPARAKSTS_USERNAME",
  "LATVIAN_SMART_ID_USERNAME": "LATVIAN_SMART_ID_USERNAME",
  "LITHUANIAN_SMART_ID": "LITHUANIAN_SMART_ID",
  "LITHUANIAN_MOBILE_ID": "LITHUANIAN_MOBILE_ID",
  "NORWEGIAN_BANKID_ON_MOBILE": "NORWEGIAN_BANKID_ON_MOBILE",
  "NORWEGIAN_BANKID_ON_MOBILE_FULL_PERSONAL_NUMBER": "NORWEGIAN_BANKID_ON_MOBILE_FULL_PERSONAL_NUMBER",
  "SWEDISH_MOBILE_BANKID_ANY_DEVICE": "SWEDISH_MOBILE_BANKID_ANY_DEVICE",
  "SWEDISH_MOBILE_BANKID_OTHER_DEVICE": "SWEDISH_MOBILE_BANKID_OTHER_DEVICE",
  "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_MOCK": "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_MOCK",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE": "SWEDISH_MOBILE_BANKID_SAME_DEVICE",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION": "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION_MOCK": "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION_MOCK",
  "SWEDISH_MOBILE_BANKID_ANY_DEVICE_TEST": "SWEDISH_MOBILE_BANKID_ANY_DEVICE_TEST",
  "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_TEST": "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_TEST",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE_TEST": "SWEDISH_MOBILE_BANKID_SAME_DEVICE_TEST",
  "SWEDISH_SECURITY_TOKEN": "SWEDISH_SECURITY_TOKEN",
  "UK_DOB_USERNAME_PASSWORD": "UK_DOB_USERNAME_PASSWORD",
  "UK_LASTNAME_MEMBERSHIP_NUMBER": "UK_LASTNAME_MEMBERSHIP_NUMBER",
  "UK_USERNAME_POSTCODE": "UK_USERNAME_POSTCODE",
  "USERNAME_AND_PASSWORD": "USERNAME_AND_PASSWORD",
  "EMAIL": "EMAIL",
  "PDF_UPLOAD": "PDF_UPLOAD"
};
var companyAvailabilityNonFunctionalLoginMethods = {
  "DANISH_NEMID": "DANISH_NEMID",
  "DANISH_MITID": "DANISH_MITID",
  "DANISH_MITID_SAME_DEVICE": "DANISH_MITID_SAME_DEVICE",
  "ESTONIAN_MOBILE_ID": "ESTONIAN_MOBILE_ID",
  "ESTONIAN_SMART_ID": "ESTONIAN_SMART_ID",
  "ESTONIAN_MOBILE_ID_USERNAME": "ESTONIAN_MOBILE_ID_USERNAME",
  "ESTONIAN_SMART_ID_USERNAME": "ESTONIAN_SMART_ID_USERNAME",
  "LATVIAN_MOBILE_EPARAKSTS": "LATVIAN_MOBILE_EPARAKSTS",
  "LATVIAN_SMART_ID": "LATVIAN_SMART_ID",
  "LATVIAN_MOBILE_EPARAKSTS_USERNAME": "LATVIAN_MOBILE_EPARAKSTS_USERNAME",
  "LATVIAN_SMART_ID_USERNAME": "LATVIAN_SMART_ID_USERNAME",
  "LITHUANIAN_SMART_ID": "LITHUANIAN_SMART_ID",
  "LITHUANIAN_MOBILE_ID": "LITHUANIAN_MOBILE_ID",
  "NORWEGIAN_BANKID_ON_MOBILE": "NORWEGIAN_BANKID_ON_MOBILE",
  "NORWEGIAN_BANKID_ON_MOBILE_FULL_PERSONAL_NUMBER": "NORWEGIAN_BANKID_ON_MOBILE_FULL_PERSONAL_NUMBER",
  "SWEDISH_MOBILE_BANKID_ANY_DEVICE": "SWEDISH_MOBILE_BANKID_ANY_DEVICE",
  "SWEDISH_MOBILE_BANKID_OTHER_DEVICE": "SWEDISH_MOBILE_BANKID_OTHER_DEVICE",
  "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_MOCK": "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_MOCK",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE": "SWEDISH_MOBILE_BANKID_SAME_DEVICE",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION": "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION_MOCK": "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION_MOCK",
  "SWEDISH_MOBILE_BANKID_ANY_DEVICE_TEST": "SWEDISH_MOBILE_BANKID_ANY_DEVICE_TEST",
  "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_TEST": "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_TEST",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE_TEST": "SWEDISH_MOBILE_BANKID_SAME_DEVICE_TEST",
  "SWEDISH_SECURITY_TOKEN": "SWEDISH_SECURITY_TOKEN",
  "UK_DOB_USERNAME_PASSWORD": "UK_DOB_USERNAME_PASSWORD",
  "UK_LASTNAME_MEMBERSHIP_NUMBER": "UK_LASTNAME_MEMBERSHIP_NUMBER",
  "UK_USERNAME_POSTCODE": "UK_USERNAME_POSTCODE",
  "USERNAME_AND_PASSWORD": "USERNAME_AND_PASSWORD",
  "EMAIL": "EMAIL",
  "PDF_UPLOAD": "PDF_UPLOAD"
};
var companyAvailabilityCompanyAndLineOfBusinesses = {
  "EE_SWEDBANK": "EE_SWEDBANK",
  "FR_ALLIANZ_HOME": "FR_ALLIANZ_HOME",
  "FR_ALLIANZ_VEHICLE": "FR_ALLIANZ_VEHICLE",
  "FR_ANIMAUXSANTE_HOME": "FR_ANIMAUXSANTE_HOME",
  "FR_ASSUR_OPOIL_ANIMAL": "FR_ASSUR_OPOIL_ANIMAL",
  "FR_AXA_HOME": "FR_AXA_HOME",
  "FR_AXA_VEHICLE": "FR_AXA_VEHICLE",
  "FR_AXA_GENERAL": "FR_AXA_GENERAL",
  "FR_BANQUE_POPULAIRE_HOME": "FR_BANQUE_POPULAIRE_HOME",
  "FR_BULLE_BLEUE_HOME": "FR_BULLE_BLEUE_HOME",
  "FR_CAISSE_DEPARGNE_HOME": "FR_CAISSE_DEPARGNE_HOME",
  "FR_CARDIF_HOME": "FR_CARDIF_HOME",
  "FR_CREDIT_AGRICOLE_HOME": "FR_CREDIT_AGRICOLE_HOME",
  "FR_CREDIT_AGRICOLE_VEHICLE": "FR_CREDIT_AGRICOLE_VEHICLE",
  "FR_CREDIT_MUTUEL_HOME": "FR_CREDIT_MUTUEL_HOME",
  "FR_CREDIT_MUTUEL_VEHICLE": "FR_CREDIT_MUTUEL_VEHICLE",
  "FR_DEMO_HOME": "FR_DEMO_HOME",
  "FR_DEMO_VEHICLE": "FR_DEMO_VEHICLE",
  "FR_DIRECT_ASSURANCE_HOME": "FR_DIRECT_ASSURANCE_HOME",
  "FR_DIRECT_ASSURANCE_VEHICLE": "FR_DIRECT_ASSURANCE_VEHICLE",
  "FR_ECA_HOME": "FR_ECA_HOME",
  "FR_ECA_ANIMAL": "FR_ECA_ANIMAL",
  "FR_GENERALI_HOME": "FR_GENERALI_HOME",
  "FR_GENERALI_VEHICLE": "FR_GENERALI_VEHICLE",
  "FR_GMF_HOME": "FR_GMF_HOME",
  "FR_GMF_VEHICLE": "FR_GMF_VEHICLE",
  "FR_GROUPAMA_HOME": "FR_GROUPAMA_HOME",
  "FR_GROUPAMA_VEHICLE": "FR_GROUPAMA_VEHICLE",
  "FR_LUKO_HOME": "FR_LUKO_HOME",
  "FR_MAAF_HOME": "FR_MAAF_HOME",
  "FR_MAAF_VEHICLE": "FR_MAAF_VEHICLE",
  "FR_MACIF_HOME": "FR_MACIF_HOME",
  "FR_MACIF_VEHICLE": "FR_MACIF_VEHICLE",
  "FR_MAIF_HOME": "FR_MAIF_HOME",
  "FR_MAIF_VEHICLE": "FR_MAIF_VEHICLE",
  "FR_MATMUT_HOME": "FR_MATMUT_HOME",
  "FR_MMA_HOME": "FR_MMA_HOME",
  "FR_MMA_VEHICLE": "FR_MMA_VEHICLE",
  "FR_SANTEVET_HOME": "FR_SANTEVET_HOME",
  "SE_IF_VEHICLE": "SE_IF_VEHICLE",
  "SE_FOLKSAM_VEHICLE": "SE_FOLKSAM_VEHICLE",
  "SE_LANSFORSAKRINGAR_HOME": "SE_LANSFORSAKRINGAR_HOME",
  "SE_PAYDRIVE_VEHICLE": "SE_PAYDRIVE_VEHICLE",
  "SE_SVEDEA_VEHICLE": "SE_SVEDEA_VEHICLE",
  "SE_VOLVIA_VEHICLE": "SE_VOLVIA_VEHICLE",
  "SE_BLIWA_ACCIDENT": "SE_BLIWA_ACCIDENT",
  "UK_AXA_HOME": "UK_AXA_HOME",
  "UK_AXA_VEHICLE": "UK_AXA_VEHICLE",
  "UK_HASTINGS_DIRECT_HOME": "UK_HASTINGS_DIRECT_HOME",
  "UK_HASTINGS_DIRECT_VEHICLE": "UK_HASTINGS_DIRECT_VEHICLE",
  "UK_POLICYEXPERT_HOME": "UK_POLICYEXPERT_HOME",
  "UK_POLICYEXPERT_VEHICLE": "UK_POLICYEXPERT_VEHICLE",
  "UK_POST_OFFICE_HOME": "UK_POST_OFFICE_HOME",
  "UK_THE_AA_HOME": "UK_THE_AA_HOME",
  "UK_THE_AA_VEHICLE": "UK_THE_AA_VEHICLE",
  "UK_URBAN_JUNGLE_HOME": "UK_URBAN_JUNGLE_HOME",
  "FR_AXA_PERSON": "FR_AXA_PERSON",
  "FR_ACHEEL_HOME": "FR_ACHEEL_HOME"
};

// src/types/insurance-api/v3/types/CompanyLoginConfig.ts
var companyLoginConfigUsernameLabel = {
  "EMAIL": "EMAIL",
  "USERNAME": "USERNAME"
};
var companyLoginConfigUsernameFieldPlaceholder = {
  "EMAIL": "EMAIL",
  "IDENTIFICATION_NUMBER_11": "IDENTIFICATION_NUMBER_11",
  "IDENTIFICATION_CHARACTERS_8": "IDENTIFICATION_CHARACTERS_8",
  "EMAIL_MOBILE_MUTUAL_MEMBER": "EMAIL_MOBILE_MUTUAL_MEMBER",
  "EMAIL_MOBILE_CLIENT": "EMAIL_MOBILE_CLIENT",
  "EMAIL_MUTUAL_OR_REGULAR_MEMBER": "EMAIL_MUTUAL_OR_REGULAR_MEMBER",
  "EMAIL_MOBILE_CONTRACT": "EMAIL_MOBILE_CONTRACT",
  "EMAIL_OR_MEMBER": "EMAIL_OR_MEMBER"
};
var companyLoginConfigPasswordLabel = {
  "PASSWORD": "PASSWORD",
  "CONFIDENTIAL_CODE": "CONFIDENTIAL_CODE",
  "PERSONAL_CODE": "PERSONAL_CODE"
};
var companyLoginConfigPasswordFieldPlaceholder = {
  "PASSWORD": "PASSWORD",
  "CONFIDENTIAL_CODE": "CONFIDENTIAL_CODE",
  "PERSONAL_CODE": "PERSONAL_CODE"
};

// src/types/insurance-api/v3/types/ConsentRequestInput.ts
var consentRequestInputType = {
  "TRADE_UNION_MEMBERSHIP": "TRADE_UNION_MEMBERSHIP"
};

// src/types/insurance-api/v3/types/ConsentRequirement.ts
var consentRequirementType = {
  "TRADE_UNION_MEMBERSHIP": "TRADE_UNION_MEMBERSHIP"
};
var consentRequirementMethod = {
  "NONE": "NONE",
  "NOTICE": "NOTICE",
  "ACTIVE": "ACTIVE"
};

// src/types/insurance-api/v3/types/CoreInsuranceHome.ts
var coreInsuranceHomePaymentMethod = {
  "UNDEFINED": "UNDEFINED",
  "AUTOGIRO": "AUTOGIRO",
  "PAPER_INVOICE": "PAPER_INVOICE",
  "ELECTRONIC_INVOICE": "ELECTRONIC_INVOICE",
  "GENERIC_INVOICE": "GENERIC_INVOICE",
  "ONE_TIME_PAYMENT": "ONE_TIME_PAYMENT",
  "EMPLOYER_PAID": "EMPLOYER_PAID",
  "CREDIT_CARD": "CREDIT_CARD"
};
var coreInsuranceHomeInsuranceHolderGender = {
  "MALE": "MALE",
  "FEMALE": "FEMALE",
  "OTHER": "OTHER",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v3/types/CoreInsuranceVilla.ts
var coreInsuranceVillaPaymentMethod = {
  "UNDEFINED": "UNDEFINED",
  "AUTOGIRO": "AUTOGIRO",
  "PAPER_INVOICE": "PAPER_INVOICE",
  "ELECTRONIC_INVOICE": "ELECTRONIC_INVOICE",
  "GENERIC_INVOICE": "GENERIC_INVOICE",
  "ONE_TIME_PAYMENT": "ONE_TIME_PAYMENT",
  "EMPLOYER_PAID": "EMPLOYER_PAID",
  "CREDIT_CARD": "CREDIT_CARD"
};
var coreInsuranceVillaInsuranceHolderGender = {
  "MALE": "MALE",
  "FEMALE": "FEMALE",
  "OTHER": "OTHER",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v3/types/CoverageParameterValueDeductible.ts
var coverageParameterValueDeductibleDeductibleType = {
  "amount": "amount",
  "complex": "complex",
  "general": "general",
  "not-applicable": "not-applicable"
};

// src/types/insurance-api/v3/types/CoverageParameterValueLimit.ts
var coverageParameterValueLimitLimitType = {
  "amount": "amount",
  "complex": "complex",
  "full-value": "full-value",
  "no-limit": "no-limit",
  "not-applicable": "not-applicable"
};

// src/types/insurance-api/v3/types/FarmProperty.ts
var farmPropertyBuildingType = {
  "BARN": "BARN",
  "STABLE": "STABLE",
  "LOG_CABIN": "LOG_CABIN",
  "MACHINE_HALL": "MACHINE_HALL",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v3/types/FrenchInsurance.ts
var frenchInsuranceInsuranceHolderGender = {
  "MALE": "MALE",
  "FEMALE": "FEMALE",
  "OTHER": "OTHER",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v3/types/FrenchInsuranceCar.ts
var frenchInsuranceCarInsuranceHolderGender = {
  "MALE": "MALE",
  "FEMALE": "FEMALE",
  "OTHER": "OTHER",
  "UNKNOWN": "UNKNOWN"
};
var frenchInsuranceCarUsagePurposes = {
  "PRIVATE": "PRIVATE",
  "COMMUTING": "COMMUTING",
  "WORK": "WORK"
};

// src/types/insurance-api/v3/types/FrenchInsuranceHome.ts
var frenchInsuranceHomePaymentMethod = {
  "UNDEFINED": "UNDEFINED",
  "AUTOGIRO": "AUTOGIRO",
  "PAPER_INVOICE": "PAPER_INVOICE",
  "ELECTRONIC_INVOICE": "ELECTRONIC_INVOICE",
  "GENERIC_INVOICE": "GENERIC_INVOICE",
  "ONE_TIME_PAYMENT": "ONE_TIME_PAYMENT",
  "EMPLOYER_PAID": "EMPLOYER_PAID",
  "CREDIT_CARD": "CREDIT_CARD"
};
var frenchInsuranceHomeInsuranceHolderGender = {
  "MALE": "MALE",
  "FEMALE": "FEMALE",
  "OTHER": "OTHER",
  "UNKNOWN": "UNKNOWN"
};
var frenchInsuranceHomeFloor = {
  "GROUND_FLOOR": "GROUND_FLOOR",
  "COURTYARD": "COURTYARD",
  "INTERMEDIATE_FLOOR": "INTERMEDIATE_FLOOR",
  "TOP_FLOOR": "TOP_FLOOR",
  "UNKNOWN": "UNKNOWN"
};
var frenchInsuranceHomeAdditionalAmenities = {
  "FIREPLACE": "FIREPLACE",
  "POOL": "POOL",
  "GARDEN": "GARDEN"
};
var frenchInsuranceHomeOwnershipStatus = {
  "OWNER": "OWNER",
  "TENANT": "TENANT",
  "SECONDARY_TENANT": "SECONDARY_TENANT",
  "UNKNOWN": "UNKNOWN"
};
var frenchInsuranceHomeResidentialStatus = {
  "PRIMARY_RESIDENCE": "PRIMARY_RESIDENCE",
  "SECONDARY_RESIDENCE": "SECONDARY_RESIDENCE",
  "RENTAL_RESIDENCE": "RENTAL_RESIDENCE",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v3/types/FrenchInsuranceHouseContent.ts
var frenchInsuranceHouseContentAdditionalAmenities = {
  "FIREPLACE": "FIREPLACE",
  "POOL": "POOL",
  "GARDEN": "GARDEN"
};
var frenchInsuranceHouseContentOwnershipStatus = {
  "OWNER": "OWNER",
  "TENANT": "TENANT",
  "SECONDARY_TENANT": "SECONDARY_TENANT",
  "UNKNOWN": "UNKNOWN"
};
var frenchInsuranceHouseContentResidentialStatus = {
  "PRIMARY_RESIDENCE": "PRIMARY_RESIDENCE",
  "SECONDARY_RESIDENCE": "SECONDARY_RESIDENCE",
  "RENTAL_RESIDENCE": "RENTAL_RESIDENCE",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v3/types/FrenchInsuranceVehicle.ts
var frenchInsuranceVehicleUsagePurposes = {
  "PRIVATE": "PRIVATE",
  "COMMUTING": "COMMUTING",
  "WORK": "WORK"
};

// src/types/insurance-api/v3/types/FrenchInsuranceVilla.ts
var frenchInsuranceVillaPaymentMethod = {
  "UNDEFINED": "UNDEFINED",
  "AUTOGIRO": "AUTOGIRO",
  "PAPER_INVOICE": "PAPER_INVOICE",
  "ELECTRONIC_INVOICE": "ELECTRONIC_INVOICE",
  "GENERIC_INVOICE": "GENERIC_INVOICE",
  "ONE_TIME_PAYMENT": "ONE_TIME_PAYMENT",
  "EMPLOYER_PAID": "EMPLOYER_PAID",
  "CREDIT_CARD": "CREDIT_CARD"
};
var frenchInsuranceVillaInsuranceHolderGender = {
  "MALE": "MALE",
  "FEMALE": "FEMALE",
  "OTHER": "OTHER",
  "UNKNOWN": "UNKNOWN"
};
var frenchInsuranceVillaAdditionalAmenities = {
  "FIREPLACE": "FIREPLACE",
  "POOL": "POOL",
  "GARDEN": "GARDEN"
};
var frenchInsuranceVillaOwnershipStatus = {
  "OWNER": "OWNER",
  "TENANT": "TENANT",
  "SECONDARY_TENANT": "SECONDARY_TENANT",
  "UNKNOWN": "UNKNOWN"
};
var frenchInsuranceVillaResidentialStatus = {
  "PRIMARY_RESIDENCE": "PRIMARY_RESIDENCE",
  "SECONDARY_RESIDENCE": "SECONDARY_RESIDENCE",
  "RENTAL_RESIDENCE": "RENTAL_RESIDENCE",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v3/types/FrenchParkingLocation.ts
var frenchParkingLocationParkingLocationType = {
  "STREET": "STREET",
  "COMMON_GARAGE": "COMMON_GARAGE",
  "INDIVIDUAL_GARAGE": "INDIVIDUAL_GARAGE",
  "PRIVATE_PROPERTY": "PRIVATE_PROPERTY",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v3/types/FrenchVehicleOwnership.ts
var frenchVehicleOwnershipStatus = {
  "OWNED": "OWNED",
  "LEASING": "LEASING",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v3/types/GetCompaniesStatus.ts
var getCompaniesStatusHeaderParamsInsurelyVersion = {
  "2021-01-01": "2021-01-01"
};

// src/types/insurance-api/v3/types/GetParametersRequest.ts
var getParametersRequestInsuranceCompany = {
  "se-agria": "se-agria",
  "se-alecta": "se-alecta",
  "se-amf": "se-amf",
  "se-avanza": "se-avanza",
  "se-demo": "se-demo",
  "se-demo-two": "se-demo-two",
  "se-demo-three": "se-demo-three",
  "se-demo-four": "se-demo-four",
  "se-bliwa": "se-bliwa",
  "se-danske-bank": "se-danske-bank",
  "se-dina": "se-dina",
  "se-euroaccident": "se-euroaccident",
  "se-evidentlife": "se-evidentlife",
  "se-folksam": "se-folksam",
  "se-futur": "se-futur",
  "se-gjensidige": "se-gjensidige",
  "se-handelsbanken": "se-handelsbanken",
  "se-hedvig": "se-hedvig",
  "se-ica": "se-ica",
  "se-ica-bank": "se-ica-bank",
  "se-if": "se-if",
  "se-if-mercedes": "se-if-mercedes",
  "se-kpa": "se-kpa",
  "se-lansforsakringar": "se-lansforsakringar",
  "se-lassie": "se-lassie",
  "se-manypets": "se-manypets",
  "se-moderna": "se-moderna",
  "se-movestic": "se-movestic",
  "se-nordea": "se-nordea",
  "se-nordnet": "se-nordnet",
  "se-seb": "se-seb",
  "se-seb-bank": "se-seb-bank",
  "se-skandia": "se-skandia",
  "se-spp": "se-spp",
  "se-svedea": "se-svedea",
  "se-trekronor": "se-trekronor",
  "se-trygg-hansa": "se-trygg-hansa",
  "se-volvia": "se-volvia",
  "se-paydrive": "se-paydrive",
  "se-sveland": "se-sveland",
  "se-svenska-fribrevsbolaget": "se-svenska-fribrevsbolaget",
  "se-swedbank": "se-swedbank",
  "se-leaky": "se-leaky",
  "se-watercircles": "se-watercircles",
  "se-sensor": "se-sensor",
  "se-soderberg-partners": "se-soderberg-partners",
  "se-lf-alvsborg": "se-lf-alvsborg",
  "se-lf-bergslagen": "se-lf-bergslagen",
  "se-lf-blekinge": "se-lf-blekinge",
  "se-lf-dalarna": "se-lf-dalarna",
  "se-lf-goteborg-bohuslan": "se-lf-goteborg-bohuslan",
  "se-lf-goinge-kristianstad": "se-lf-goinge-kristianstad",
  "se-lf-gotland": "se-lf-gotland",
  "se-lf-gavleborg": "se-lf-gavleborg",
  "se-lf-halland": "se-lf-halland",
  "se-lf-jamtland": "se-lf-jamtland",
  "se-lf-jonkoping": "se-lf-jonkoping",
  "se-lf-norrbotten": "se-lf-norrbotten",
  "se-lf-ostgota": "se-lf-ostgota",
  "se-lf-kalmar": "se-lf-kalmar",
  "se-lf-kronoberg": "se-lf-kronoberg",
  "se-lf-stockholm": "se-lf-stockholm",
  "se-lf-sormland": "se-lf-sormland",
  "se-lf-skane": "se-lf-skane",
  "se-lf-skaraborg": "se-lf-skaraborg",
  "se-lf-uppsala": "se-lf-uppsala",
  "se-lf-varmland": "se-lf-varmland",
  "se-lf-vasterbotten": "se-lf-vasterbotten",
  "se-lf-vasternorrland": "se-lf-vasternorrland",
  "no-demo": "no-demo",
  "no-eika": "no-eika",
  "no-frende": "no-frende",
  "no-gjensidige": "no-gjensidige",
  "no-if": "no-if",
  "no-sparebank1": "no-sparebank1",
  "no-tryg": "no-tryg",
  "dk-alka": "dk-alka",
  "dk-almbrand": "dk-almbrand",
  "dk-bauta": "dk-bauta",
  "dk-codan": "dk-codan",
  "dk-demo": "dk-demo",
  "dk-fdm": "dk-fdm",
  "dk-gfforsikring": "dk-gfforsikring",
  "dk-gjensidige": "dk-gjensidige",
  "dk-ida": "dk-ida",
  "dk-if": "dk-if",
  "dk-lb": "dk-lb",
  "dk-lbforsikringpfa": "dk-lbforsikringpfa",
  "dk-runa": "dk-runa",
  "dk-tjm": "dk-tjm",
  "dk-topdanmark": "dk-topdanmark",
  "dk-tryg": "dk-tryg",
  "uk-aa": "uk-aa",
  "uk-admiral": "uk-admiral",
  "uk-animalfriends": "uk-animalfriends",
  "uk-axa": "uk-axa",
  "uk-axa-vehicle": "uk-axa-vehicle",
  "uk-aviva": "uk-aviva",
  "uk-barclays": "uk-barclays",
  "uk-manypets": "uk-manypets",
  "uk-churchill": "uk-churchill",
  "uk-demo": "uk-demo",
  "uk-natwest": "uk-natwest",
  "uk-directline": "uk-directline",
  "uk-halifax": "uk-halifax",
  "uk-hastings-direct": "uk-hastings-direct",
  "uk-john-lewis-home": "uk-john-lewis-home",
  "uk-lv": "uk-lv",
  "uk-morethan-home": "uk-morethan-home",
  "uk-onecall": "uk-onecall",
  "uk-petplan": "uk-petplan",
  "uk-policyexpert-home": "uk-policyexpert-home",
  "uk-policyexpert-vehicle": "uk-policyexpert-vehicle",
  "uk-postoffice": "uk-postoffice",
  "uk-privilege": "uk-privilege",
  "uk-rac": "uk-rac",
  "uk-saga": "uk-saga",
  "uk-sainsburys": "uk-sainsburys",
  "uk-sainsburys-pet": "uk-sainsburys-pet",
  "uk-sheilaswheels": "uk-sheilaswheels",
  "uk-sosure": "uk-sosure",
  "uk-swinton": "uk-swinton",
  "uk-tesco": "uk-tesco",
  "uk-urbanjungle": "uk-urbanjungle",
  "uk-waggel": "uk-waggel",
  "ee-bta": "ee-bta",
  "ee-demo": "ee-demo",
  "ee-ergo": "ee-ergo",
  "ee-gjensidige": "ee-gjensidige",
  "ee-if": "ee-if",
  "ee-pzu": "ee-pzu",
  "ee-salva": "ee-salva",
  "ee-seesam": "ee-seesam",
  "ee-swedbank": "ee-swedbank",
  "ee-lhv": "ee-lhv",
  "es-mapfre": "es-mapfre",
  "es-demo": "es-demo",
  "fr-acheel": "fr-acheel",
  "fr-allianz": "fr-allianz",
  "fr-animauxsante": "fr-animauxsante",
  "fr-assur-opoil": "fr-assur-opoil",
  "fr-axa": "fr-axa",
  "fr-bred": "fr-bred",
  "fr-bulle-bleue": "fr-bulle-bleue",
  "fr-cardif": "fr-cardif",
  "fr-credit-agricole": "fr-credit-agricole",
  "fr-credit-mutuel": "fr-credit-mutuel",
  "fr-dalma": "fr-dalma",
  "fr-demo": "fr-demo",
  "fr-eca": "fr-eca",
  "fr-generali": "fr-generali",
  "fr-gmf": "fr-gmf",
  "fr-groupama": "fr-groupama",
  "fr-luko": "fr-luko",
  "fr-kozoo": "fr-kozoo",
  "fr-maaf": "fr-maaf",
  "fr-macif": "fr-macif",
  "fr-matmut": "fr-matmut",
  "fr-maif": "fr-maif",
  "fr-mma": "fr-mma",
  "fr-santevet": "fr-santevet",
  "fr-lolivier": "fr-lolivier",
  "fr-caisse-depargne": "fr-caisse-depargne",
  "fr-banque-populaire": "fr-banque-populaire",
  "fr-mobilize": "fr-mobilize",
  "fr-direct-assurance": "fr-direct-assurance",
  "lv-balta": "lv-balta",
  "lv-ban": "lv-ban",
  "lv-bta": "lv-bta",
  "lv-compensa": "lv-compensa",
  "lv-demo": "lv-demo",
  "lv-ergo": "lv-ergo",
  "lv-gjensidige": "lv-gjensidige",
  "lv-if": "lv-if",
  "lv-luminor": "lv-luminor",
  "lv-seb": "lv-seb",
  "lv-swedbank": "lv-swedbank",
  "lt-demo": "lt-demo",
  "lt-gjensidige": "lt-gjensidige",
  "xx-loadtest-scrape": "xx-loadtest-scrape",
  "xx-loadtest-api": "xx-loadtest-api",
  "xx-docs": "xx-docs"
};

// src/types/insurance-api/v3/types/Insurance.ts
var insurancePaymentMethod = {
  "UNDEFINED": "UNDEFINED",
  "AUTOGIRO": "AUTOGIRO",
  "PAPER_INVOICE": "PAPER_INVOICE",
  "ELECTRONIC_INVOICE": "ELECTRONIC_INVOICE",
  "GENERIC_INVOICE": "GENERIC_INVOICE",
  "ONE_TIME_PAYMENT": "ONE_TIME_PAYMENT",
  "EMPLOYER_PAID": "EMPLOYER_PAID",
  "CREDIT_CARD": "CREDIT_CARD"
};
var insuranceInsuranceHolderGender = {
  "MALE": "MALE",
  "FEMALE": "FEMALE",
  "OTHER": "OTHER",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v3/types/InsuranceAccident.ts
var insuranceAccidentPaymentMethod = {
  "UNDEFINED": "UNDEFINED",
  "AUTOGIRO": "AUTOGIRO",
  "PAPER_INVOICE": "PAPER_INVOICE",
  "ELECTRONIC_INVOICE": "ELECTRONIC_INVOICE",
  "GENERIC_INVOICE": "GENERIC_INVOICE",
  "ONE_TIME_PAYMENT": "ONE_TIME_PAYMENT",
  "EMPLOYER_PAID": "EMPLOYER_PAID",
  "CREDIT_CARD": "CREDIT_CARD"
};
var insuranceAccidentInsuranceHolderGender = {
  "MALE": "MALE",
  "FEMALE": "FEMALE",
  "OTHER": "OTHER",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v3/types/InsuranceAnimal.ts
var insuranceAnimalAnimalGender = {
  "MALE": "MALE",
  "FEMALE": "FEMALE",
  "CASTRATED_MALE": "CASTRATED_MALE",
  "CASTRATED_FEMALE": "CASTRATED_FEMALE",
  "UNKNOWN": "UNKNOWN"
};
var insuranceAnimalPaymentMethod = {
  "UNDEFINED": "UNDEFINED",
  "AUTOGIRO": "AUTOGIRO",
  "PAPER_INVOICE": "PAPER_INVOICE",
  "ELECTRONIC_INVOICE": "ELECTRONIC_INVOICE",
  "GENERIC_INVOICE": "GENERIC_INVOICE",
  "ONE_TIME_PAYMENT": "ONE_TIME_PAYMENT",
  "EMPLOYER_PAID": "EMPLOYER_PAID",
  "CREDIT_CARD": "CREDIT_CARD"
};
var insuranceAnimalInsuranceHolderGender = {
  "MALE": "MALE",
  "FEMALE": "FEMALE",
  "OTHER": "OTHER",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v3/types/InsuranceCar.ts
var insuranceCarCoverage = {
  "UNDEFINED": "UNDEFINED",
  "FULL_WITH_CHASSI": "FULL_WITH_CHASSI",
  "FULL_WITHOUT_CHASSI": "FULL_WITHOUT_CHASSI",
  "TRAFFIC": "TRAFFIC",
  "NOT_IN_TRAFFIC": "NOT_IN_TRAFFIC",
  "COMPREHENSIVE": "COMPREHENSIVE",
  "CASCO": "CASCO",
  "MTPL": "MTPL"
};
var insuranceCarInsuranceLevel = {
  "BASE": "BASE",
  "PLUS": "PLUS",
  "UNDEFINED": "UNDEFINED"
};

// src/types/insurance-api/v3/types/InsuranceChild.ts
var insuranceChildPaymentMethod = {
  "UNDEFINED": "UNDEFINED",
  "AUTOGIRO": "AUTOGIRO",
  "PAPER_INVOICE": "PAPER_INVOICE",
  "ELECTRONIC_INVOICE": "ELECTRONIC_INVOICE",
  "GENERIC_INVOICE": "GENERIC_INVOICE",
  "ONE_TIME_PAYMENT": "ONE_TIME_PAYMENT",
  "EMPLOYER_PAID": "EMPLOYER_PAID",
  "CREDIT_CARD": "CREDIT_CARD"
};
var insuranceChildInsuranceHolderGender = {
  "MALE": "MALE",
  "FEMALE": "FEMALE",
  "OTHER": "OTHER",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v3/types/InsuranceCompany.ts
var insuranceCompany = {
  "se-agria": "se-agria",
  "se-alecta": "se-alecta",
  "se-amf": "se-amf",
  "se-avanza": "se-avanza",
  "se-demo": "se-demo",
  "se-demo-two": "se-demo-two",
  "se-demo-three": "se-demo-three",
  "se-demo-four": "se-demo-four",
  "se-bliwa": "se-bliwa",
  "se-danske-bank": "se-danske-bank",
  "se-dina": "se-dina",
  "se-euroaccident": "se-euroaccident",
  "se-evidentlife": "se-evidentlife",
  "se-folksam": "se-folksam",
  "se-futur": "se-futur",
  "se-gjensidige": "se-gjensidige",
  "se-handelsbanken": "se-handelsbanken",
  "se-hedvig": "se-hedvig",
  "se-ica": "se-ica",
  "se-ica-bank": "se-ica-bank",
  "se-if": "se-if",
  "se-if-mercedes": "se-if-mercedes",
  "se-kpa": "se-kpa",
  "se-lansforsakringar": "se-lansforsakringar",
  "se-lassie": "se-lassie",
  "se-manypets": "se-manypets",
  "se-moderna": "se-moderna",
  "se-movestic": "se-movestic",
  "se-nordea": "se-nordea",
  "se-nordnet": "se-nordnet",
  "se-seb": "se-seb",
  "se-seb-bank": "se-seb-bank",
  "se-skandia": "se-skandia",
  "se-spp": "se-spp",
  "se-svedea": "se-svedea",
  "se-trekronor": "se-trekronor",
  "se-trygg-hansa": "se-trygg-hansa",
  "se-volvia": "se-volvia",
  "se-paydrive": "se-paydrive",
  "se-sveland": "se-sveland",
  "se-svenska-fribrevsbolaget": "se-svenska-fribrevsbolaget",
  "se-swedbank": "se-swedbank",
  "se-leaky": "se-leaky",
  "se-watercircles": "se-watercircles",
  "se-sensor": "se-sensor",
  "se-soderberg-partners": "se-soderberg-partners",
  "no-demo": "no-demo",
  "no-eika": "no-eika",
  "no-frende": "no-frende",
  "no-gjensidige": "no-gjensidige",
  "no-if": "no-if",
  "no-sparebank1": "no-sparebank1",
  "no-tryg": "no-tryg",
  "dk-alka": "dk-alka",
  "dk-almbrand": "dk-almbrand",
  "dk-bauta": "dk-bauta",
  "dk-codan": "dk-codan",
  "dk-demo": "dk-demo",
  "dk-fdm": "dk-fdm",
  "dk-gfforsikring": "dk-gfforsikring",
  "dk-gjensidige": "dk-gjensidige",
  "dk-ida": "dk-ida",
  "dk-if": "dk-if",
  "dk-lb": "dk-lb",
  "dk-lbforsikringpfa": "dk-lbforsikringpfa",
  "dk-runa": "dk-runa",
  "dk-tjm": "dk-tjm",
  "dk-topdanmark": "dk-topdanmark",
  "dk-tryg": "dk-tryg",
  "uk-aa": "uk-aa",
  "uk-admiral": "uk-admiral",
  "uk-animalfriends": "uk-animalfriends",
  "uk-axa": "uk-axa",
  "uk-axa-vehicle": "uk-axa-vehicle",
  "uk-aviva": "uk-aviva",
  "uk-barclays": "uk-barclays",
  "uk-manypets": "uk-manypets",
  "uk-churchill": "uk-churchill",
  "uk-demo": "uk-demo",
  "uk-natwest": "uk-natwest",
  "uk-directline": "uk-directline",
  "uk-halifax": "uk-halifax",
  "uk-hastings-direct": "uk-hastings-direct",
  "uk-john-lewis-home": "uk-john-lewis-home",
  "uk-lv": "uk-lv",
  "uk-morethan-home": "uk-morethan-home",
  "uk-onecall": "uk-onecall",
  "uk-petplan": "uk-petplan",
  "uk-policyexpert-home": "uk-policyexpert-home",
  "uk-policyexpert-vehicle": "uk-policyexpert-vehicle",
  "uk-postoffice": "uk-postoffice",
  "uk-privilege": "uk-privilege",
  "uk-rac": "uk-rac",
  "uk-saga": "uk-saga",
  "uk-sainsburys": "uk-sainsburys",
  "uk-sainsburys-pet": "uk-sainsburys-pet",
  "uk-sheilaswheels": "uk-sheilaswheels",
  "uk-sosure": "uk-sosure",
  "uk-swinton": "uk-swinton",
  "uk-tesco": "uk-tesco",
  "uk-urbanjungle": "uk-urbanjungle",
  "uk-waggel": "uk-waggel",
  "ee-bta": "ee-bta",
  "ee-demo": "ee-demo",
  "ee-ergo": "ee-ergo",
  "ee-gjensidige": "ee-gjensidige",
  "ee-if": "ee-if",
  "ee-pzu": "ee-pzu",
  "ee-salva": "ee-salva",
  "ee-seesam": "ee-seesam",
  "ee-swedbank": "ee-swedbank",
  "ee-lhv": "ee-lhv",
  "es-mapfre": "es-mapfre",
  "es-demo": "es-demo",
  "fr-acheel": "fr-acheel",
  "fr-allianz": "fr-allianz",
  "fr-animauxsante": "fr-animauxsante",
  "fr-assur-opoil": "fr-assur-opoil",
  "fr-axa": "fr-axa",
  "fr-bulle-bleue": "fr-bulle-bleue",
  "fr-cardif": "fr-cardif",
  "fr-credit-agricole": "fr-credit-agricole",
  "fr-credit-mutuel": "fr-credit-mutuel",
  "fr-dalma": "fr-dalma",
  "fr-demo": "fr-demo",
  "fr-eca": "fr-eca",
  "fr-generali": "fr-generali",
  "fr-gmf": "fr-gmf",
  "fr-groupama": "fr-groupama",
  "fr-luko": "fr-luko",
  "fr-kozoo": "fr-kozoo",
  "fr-maaf": "fr-maaf",
  "fr-macif": "fr-macif",
  "fr-matmut": "fr-matmut",
  "fr-maif": "fr-maif",
  "fr-mma": "fr-mma",
  "fr-santevet": "fr-santevet",
  "fr-lolivier": "fr-lolivier",
  "fr-caisse-depargne": "fr-caisse-depargne",
  "fr-banque-populaire": "fr-banque-populaire",
  "fr-bred": "fr-bred",
  "fr-direct-assurance": "fr-direct-assurance",
  "lv-balta": "lv-balta",
  "lv-ban": "lv-ban",
  "lv-bta": "lv-bta",
  "lv-compensa": "lv-compensa",
  "lv-demo": "lv-demo",
  "lv-ergo": "lv-ergo",
  "lv-gjensidige": "lv-gjensidige",
  "lv-if": "lv-if",
  "lv-luminor": "lv-luminor",
  "lv-seb": "lv-seb",
  "lv-swedbank": "lv-swedbank",
  "lt-demo": "lt-demo",
  "lt-gjensidige": "lt-gjensidige",
  "xx-loadtest-scrape": "xx-loadtest-scrape",
  "xx-loadtest-api": "xx-loadtest-api",
  "xx-docs": "xx-docs"
};

// src/types/insurance-api/v3/types/InsuranceCottage.ts
var insuranceCottagePaymentMethod = {
  "UNDEFINED": "UNDEFINED",
  "AUTOGIRO": "AUTOGIRO",
  "PAPER_INVOICE": "PAPER_INVOICE",
  "ELECTRONIC_INVOICE": "ELECTRONIC_INVOICE",
  "GENERIC_INVOICE": "GENERIC_INVOICE",
  "ONE_TIME_PAYMENT": "ONE_TIME_PAYMENT",
  "EMPLOYER_PAID": "EMPLOYER_PAID",
  "CREDIT_CARD": "CREDIT_CARD"
};
var insuranceCottageInsuranceHolderGender = {
  "MALE": "MALE",
  "FEMALE": "FEMALE",
  "OTHER": "OTHER",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v3/types/InsuranceFarm.ts
var insuranceFarmPaymentMethod = {
  "UNDEFINED": "UNDEFINED",
  "AUTOGIRO": "AUTOGIRO",
  "PAPER_INVOICE": "PAPER_INVOICE",
  "ELECTRONIC_INVOICE": "ELECTRONIC_INVOICE",
  "GENERIC_INVOICE": "GENERIC_INVOICE",
  "ONE_TIME_PAYMENT": "ONE_TIME_PAYMENT",
  "EMPLOYER_PAID": "EMPLOYER_PAID",
  "CREDIT_CARD": "CREDIT_CARD"
};
var insuranceFarmInsuranceHolderGender = {
  "MALE": "MALE",
  "FEMALE": "FEMALE",
  "OTHER": "OTHER",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v3/types/InsuranceGeneral.ts
var insuranceGeneralPaymentMethod = {
  "UNDEFINED": "UNDEFINED",
  "AUTOGIRO": "AUTOGIRO",
  "PAPER_INVOICE": "PAPER_INVOICE",
  "ELECTRONIC_INVOICE": "ELECTRONIC_INVOICE",
  "GENERIC_INVOICE": "GENERIC_INVOICE",
  "ONE_TIME_PAYMENT": "ONE_TIME_PAYMENT",
  "EMPLOYER_PAID": "EMPLOYER_PAID",
  "CREDIT_CARD": "CREDIT_CARD"
};
var insuranceGeneralInsuranceHolderGender = {
  "MALE": "MALE",
  "FEMALE": "FEMALE",
  "OTHER": "OTHER",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v3/types/InsuranceHouseContent.ts
var insuranceHouseContentPaymentMethod = {
  "UNDEFINED": "UNDEFINED",
  "AUTOGIRO": "AUTOGIRO",
  "PAPER_INVOICE": "PAPER_INVOICE",
  "ELECTRONIC_INVOICE": "ELECTRONIC_INVOICE",
  "GENERIC_INVOICE": "GENERIC_INVOICE",
  "ONE_TIME_PAYMENT": "ONE_TIME_PAYMENT",
  "EMPLOYER_PAID": "EMPLOYER_PAID",
  "CREDIT_CARD": "CREDIT_CARD"
};
var insuranceHouseContentInsuranceHolderGender = {
  "MALE": "MALE",
  "FEMALE": "FEMALE",
  "OTHER": "OTHER",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v3/types/InsuranceIncome.ts
var insuranceIncomePaymentMethod = {
  "UNDEFINED": "UNDEFINED",
  "AUTOGIRO": "AUTOGIRO",
  "PAPER_INVOICE": "PAPER_INVOICE",
  "ELECTRONIC_INVOICE": "ELECTRONIC_INVOICE",
  "GENERIC_INVOICE": "GENERIC_INVOICE",
  "ONE_TIME_PAYMENT": "ONE_TIME_PAYMENT",
  "EMPLOYER_PAID": "EMPLOYER_PAID",
  "CREDIT_CARD": "CREDIT_CARD"
};
var insuranceIncomeInsuranceHolderGender = {
  "MALE": "MALE",
  "FEMALE": "FEMALE",
  "OTHER": "OTHER",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v3/types/InsuranceLife.ts
var insuranceLifePaymentMethod = {
  "UNDEFINED": "UNDEFINED",
  "AUTOGIRO": "AUTOGIRO",
  "PAPER_INVOICE": "PAPER_INVOICE",
  "ELECTRONIC_INVOICE": "ELECTRONIC_INVOICE",
  "GENERIC_INVOICE": "GENERIC_INVOICE",
  "ONE_TIME_PAYMENT": "ONE_TIME_PAYMENT",
  "EMPLOYER_PAID": "EMPLOYER_PAID",
  "CREDIT_CARD": "CREDIT_CARD"
};
var insuranceLifeInsuranceHolderGender = {
  "MALE": "MALE",
  "FEMALE": "FEMALE",
  "OTHER": "OTHER",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v3/types/InsuranceOtherVehicle.ts
var insuranceOtherVehiclePaymentMethod = {
  "UNDEFINED": "UNDEFINED",
  "AUTOGIRO": "AUTOGIRO",
  "PAPER_INVOICE": "PAPER_INVOICE",
  "ELECTRONIC_INVOICE": "ELECTRONIC_INVOICE",
  "GENERIC_INVOICE": "GENERIC_INVOICE",
  "ONE_TIME_PAYMENT": "ONE_TIME_PAYMENT",
  "EMPLOYER_PAID": "EMPLOYER_PAID",
  "CREDIT_CARD": "CREDIT_CARD"
};
var insuranceOtherVehicleInsuranceHolderGender = {
  "MALE": "MALE",
  "FEMALE": "FEMALE",
  "OTHER": "OTHER",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v3/types/InsurancePerson.ts
var insurancePersonPaymentMethod = {
  "UNDEFINED": "UNDEFINED",
  "AUTOGIRO": "AUTOGIRO",
  "PAPER_INVOICE": "PAPER_INVOICE",
  "ELECTRONIC_INVOICE": "ELECTRONIC_INVOICE",
  "GENERIC_INVOICE": "GENERIC_INVOICE",
  "ONE_TIME_PAYMENT": "ONE_TIME_PAYMENT",
  "EMPLOYER_PAID": "EMPLOYER_PAID",
  "CREDIT_CARD": "CREDIT_CARD"
};
var insurancePersonInsuranceHolderGender = {
  "MALE": "MALE",
  "FEMALE": "FEMALE",
  "OTHER": "OTHER",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v3/types/InsurancePregnancy.ts
var insurancePregnancyPaymentMethod = {
  "UNDEFINED": "UNDEFINED",
  "AUTOGIRO": "AUTOGIRO",
  "PAPER_INVOICE": "PAPER_INVOICE",
  "ELECTRONIC_INVOICE": "ELECTRONIC_INVOICE",
  "GENERIC_INVOICE": "GENERIC_INVOICE",
  "ONE_TIME_PAYMENT": "ONE_TIME_PAYMENT",
  "EMPLOYER_PAID": "EMPLOYER_PAID",
  "CREDIT_CARD": "CREDIT_CARD"
};
var insurancePregnancyInsuranceHolderGender = {
  "MALE": "MALE",
  "FEMALE": "FEMALE",
  "OTHER": "OTHER",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v3/types/InsuranceVehicle.ts
var insuranceVehiclePaymentMethod = {
  "UNDEFINED": "UNDEFINED",
  "AUTOGIRO": "AUTOGIRO",
  "PAPER_INVOICE": "PAPER_INVOICE",
  "ELECTRONIC_INVOICE": "ELECTRONIC_INVOICE",
  "GENERIC_INVOICE": "GENERIC_INVOICE",
  "ONE_TIME_PAYMENT": "ONE_TIME_PAYMENT",
  "EMPLOYER_PAID": "EMPLOYER_PAID",
  "CREDIT_CARD": "CREDIT_CARD"
};
var insuranceVehicleInsuranceHolderGender = {
  "MALE": "MALE",
  "FEMALE": "FEMALE",
  "OTHER": "OTHER",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v3/types/Market.ts
var market = {
  "dk": "dk",
  "ee": "ee",
  "lv": "lv",
  "lt": "lt",
  "fr": "fr",
  "no": "no",
  "se": "se",
  "uk": "uk",
  "es": "es",
  "core": "core"
};

// src/types/insurance-api/v3/types/MonetaryAmount.ts
var monetaryAmountCurrencyCode = {
  "DKK": "DKK",
  "EUR": "EUR",
  "GBP": "GBP",
  "NOK": "NOK",
  "SEK": "SEK"
};

// src/types/insurance-api/v3/types/Premium.ts
var premiumFrequency = {
  "YEARLY_PREMIUM_FREQUENCY": "YEARLY_PREMIUM_FREQUENCY",
  "UNKNOWN_PREMIUM_FREQUENCY": "UNKNOWN_PREMIUM_FREQUENCY"
};
var premiumTaxation = {
  "INCLUSIVE_TAXATION": "INCLUSIVE_TAXATION",
  "EXCLUSIVE_TAXATION": "EXCLUSIVE_TAXATION",
  "UNKNOWN_TAXATION": "UNKNOWN_TAXATION"
};

// src/types/insurance-api/v3/types/SwedishInsuranceHome.ts
var swedishInsuranceHomePaymentMethod = {
  "UNDEFINED": "UNDEFINED",
  "AUTOGIRO": "AUTOGIRO",
  "PAPER_INVOICE": "PAPER_INVOICE",
  "ELECTRONIC_INVOICE": "ELECTRONIC_INVOICE",
  "GENERIC_INVOICE": "GENERIC_INVOICE",
  "ONE_TIME_PAYMENT": "ONE_TIME_PAYMENT",
  "EMPLOYER_PAID": "EMPLOYER_PAID",
  "CREDIT_CARD": "CREDIT_CARD"
};
var swedishInsuranceHomeInsuranceHolderGender = {
  "MALE": "MALE",
  "FEMALE": "FEMALE",
  "OTHER": "OTHER",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v3/types/SwedishInsuranceVilla.ts
var swedishInsuranceVillaPaymentMethod = {
  "UNDEFINED": "UNDEFINED",
  "AUTOGIRO": "AUTOGIRO",
  "PAPER_INVOICE": "PAPER_INVOICE",
  "ELECTRONIC_INVOICE": "ELECTRONIC_INVOICE",
  "GENERIC_INVOICE": "GENERIC_INVOICE",
  "ONE_TIME_PAYMENT": "ONE_TIME_PAYMENT",
  "EMPLOYER_PAID": "EMPLOYER_PAID",
  "CREDIT_CARD": "CREDIT_CARD"
};
var swedishInsuranceVillaInsuranceHolderGender = {
  "MALE": "MALE",
  "FEMALE": "FEMALE",
  "OTHER": "OTHER",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v4/index.ts
var v4_exports = {};
__export(v4_exports, {
  additionalBuildingBuildingType: () => additionalBuildingBuildingType2,
  additionalBuildingCottageBuildingType: () => additionalBuildingCottageBuildingType2,
  collection1CollectInfoHeaderParamsInsurelyVersion: () => collection1CollectInfoHeaderParamsInsurelyVersion2,
  collection2StatusHeaderParamsInsurelyVersion: () => collection2StatusHeaderParamsInsurelyVersion2,
  collection3GetDataHeaderParamsInsurelyLanguage: () => collection3GetDataHeaderParamsInsurelyLanguage2,
  collection3GetDataHeaderParamsInsurelyVersion: () => collection3GetDataHeaderParamsInsurelyVersion2,
  collection3GetPolicyDocumentHeaderParamsInsurelyVersion: () => collection3GetPolicyDocumentHeaderParamsInsurelyVersion,
  collection3SupplementInformationHeaderParamsInsurelyVersion: () => collection3SupplementInformationHeaderParamsInsurelyVersion2,
  collection4GetParametersHeaderParamsInsurelyLanguage: () => collection4GetParametersHeaderParamsInsurelyLanguage2,
  collection4GetParametersHeaderParamsInsurelyVersion: () => collection4GetParametersHeaderParamsInsurelyVersion2,
  collection5GetAllParametersHeaderParamsInsurelyLanguage: () => collection5GetAllParametersHeaderParamsInsurelyLanguage2,
  collection5GetAllParametersHeaderParamsInsurelyVersion: () => collection5GetAllParametersHeaderParamsInsurelyVersion2,
  collectionItemStatus: () => collectionItemStatus,
  collectionRequestFilterRuleField: () => collectionRequestFilterRuleField2,
  collectionRequestV2LoginMethod: () => collectionRequestV2LoginMethod2,
  collectionStatusInformationMapRequiredInputTypes: () => collectionStatusInformationMapRequiredInputTypes,
  companyAvailabilityCompanyAndLineOfBusinesses: () => companyAvailabilityCompanyAndLineOfBusinesses2,
  companyAvailabilityLoginMethods: () => companyAvailabilityLoginMethods2,
  companyAvailabilityNonFunctionalLoginMethods: () => companyAvailabilityNonFunctionalLoginMethods2,
  companyAvailabilityReason: () => companyAvailabilityReason2,
  companyAvailabilityStatus: () => companyAvailabilityStatus2,
  companyLoginConfigPasswordFieldPlaceholder: () => companyLoginConfigPasswordFieldPlaceholder2,
  companyLoginConfigPasswordLabel: () => companyLoginConfigPasswordLabel2,
  companyLoginConfigUsernameFieldPlaceholder: () => companyLoginConfigUsernameFieldPlaceholder2,
  companyLoginConfigUsernameLabel: () => companyLoginConfigUsernameLabel2,
  consentRequestInputType: () => consentRequestInputType2,
  consentRequirementMethod: () => consentRequirementMethod2,
  consentRequirementType: () => consentRequirementType2,
  coreInsuranceHomeInsuranceHolderGender: () => coreInsuranceHomeInsuranceHolderGender2,
  coreInsuranceHomePaymentMethod: () => coreInsuranceHomePaymentMethod2,
  coreInsuranceVillaInsuranceHolderGender: () => coreInsuranceVillaInsuranceHolderGender2,
  coreInsuranceVillaPaymentMethod: () => coreInsuranceVillaPaymentMethod2,
  coverageParameterValueDeductibleDeductibleType: () => coverageParameterValueDeductibleDeductibleType2,
  coverageParameterValueLimitLimitType: () => coverageParameterValueLimitLimitType2,
  coveragePolicyDataOwnershipStatus: () => coveragePolicyDataOwnershipStatus,
  coveragePolicyDataResidentialStatus: () => coveragePolicyDataResidentialStatus,
  farmPropertyBuildingType: () => farmPropertyBuildingType2,
  frenchInsuranceCarInsuranceHolderGender: () => frenchInsuranceCarInsuranceHolderGender2,
  frenchInsuranceCarUsagePurposes: () => frenchInsuranceCarUsagePurposes2,
  frenchInsuranceHomeAdditionalAmenities: () => frenchInsuranceHomeAdditionalAmenities2,
  frenchInsuranceHomeFloor: () => frenchInsuranceHomeFloor2,
  frenchInsuranceHomeInsuranceHolderGender: () => frenchInsuranceHomeInsuranceHolderGender2,
  frenchInsuranceHomeOwnershipStatus: () => frenchInsuranceHomeOwnershipStatus2,
  frenchInsuranceHomePaymentMethod: () => frenchInsuranceHomePaymentMethod2,
  frenchInsuranceHomeResidentialStatus: () => frenchInsuranceHomeResidentialStatus2,
  frenchInsuranceHouseContentAdditionalAmenities: () => frenchInsuranceHouseContentAdditionalAmenities2,
  frenchInsuranceHouseContentOwnershipStatus: () => frenchInsuranceHouseContentOwnershipStatus2,
  frenchInsuranceHouseContentResidentialStatus: () => frenchInsuranceHouseContentResidentialStatus2,
  frenchInsuranceInsuranceHolderGender: () => frenchInsuranceInsuranceHolderGender2,
  frenchInsuranceVehicleUsagePurposes: () => frenchInsuranceVehicleUsagePurposes2,
  frenchInsuranceVillaAdditionalAmenities: () => frenchInsuranceVillaAdditionalAmenities2,
  frenchInsuranceVillaInsuranceHolderGender: () => frenchInsuranceVillaInsuranceHolderGender2,
  frenchInsuranceVillaOwnershipStatus: () => frenchInsuranceVillaOwnershipStatus2,
  frenchInsuranceVillaPaymentMethod: () => frenchInsuranceVillaPaymentMethod2,
  frenchInsuranceVillaResidentialStatus: () => frenchInsuranceVillaResidentialStatus2,
  frenchParkingLocationParkingLocationType: () => frenchParkingLocationParkingLocationType2,
  frenchVehicleOwnershipStatus: () => frenchVehicleOwnershipStatus2,
  getCompaniesStatusHeaderParamsInsurelyVersion: () => getCompaniesStatusHeaderParamsInsurelyVersion2,
  getParametersRequestInsuranceCompany: () => getParametersRequestInsuranceCompany2,
  getParametersRequestInsuranceSubType: () => getParametersRequestInsuranceSubType,
  getParametersRequestInsuranceType: () => getParametersRequestInsuranceType,
  insuranceAccidentInsuranceHolderGender: () => insuranceAccidentInsuranceHolderGender2,
  insuranceAccidentPaymentMethod: () => insuranceAccidentPaymentMethod2,
  insuranceAnimalAnimalGender: () => insuranceAnimalAnimalGender2,
  insuranceAnimalInsuranceHolderGender: () => insuranceAnimalInsuranceHolderGender2,
  insuranceAnimalPaymentMethod: () => insuranceAnimalPaymentMethod2,
  insuranceCarCoverage: () => insuranceCarCoverage2,
  insuranceCarInsuranceLevel: () => insuranceCarInsuranceLevel2,
  insuranceChildInsuranceHolderGender: () => insuranceChildInsuranceHolderGender2,
  insuranceChildPaymentMethod: () => insuranceChildPaymentMethod2,
  insuranceCompany: () => insuranceCompany2,
  insuranceCottageInsuranceHolderGender: () => insuranceCottageInsuranceHolderGender2,
  insuranceCottagePaymentMethod: () => insuranceCottagePaymentMethod2,
  insuranceFarmInsuranceHolderGender: () => insuranceFarmInsuranceHolderGender2,
  insuranceFarmPaymentMethod: () => insuranceFarmPaymentMethod2,
  insuranceGeneralInsuranceHolderGender: () => insuranceGeneralInsuranceHolderGender2,
  insuranceGeneralPaymentMethod: () => insuranceGeneralPaymentMethod2,
  insuranceHouseContentInsuranceHolderGender: () => insuranceHouseContentInsuranceHolderGender2,
  insuranceHouseContentPaymentMethod: () => insuranceHouseContentPaymentMethod2,
  insuranceIncomeInsuranceHolderGender: () => insuranceIncomeInsuranceHolderGender2,
  insuranceIncomePaymentMethod: () => insuranceIncomePaymentMethod2,
  insuranceInsuranceHolderGender: () => insuranceInsuranceHolderGender2,
  insuranceLifeInsuranceHolderGender: () => insuranceLifeInsuranceHolderGender2,
  insuranceLifePaymentMethod: () => insuranceLifePaymentMethod2,
  insuranceOtherVehicleInsuranceHolderGender: () => insuranceOtherVehicleInsuranceHolderGender2,
  insuranceOtherVehiclePaymentMethod: () => insuranceOtherVehiclePaymentMethod2,
  insurancePaymentMethod: () => insurancePaymentMethod2,
  insurancePersonInsuranceHolderGender: () => insurancePersonInsuranceHolderGender2,
  insurancePersonPaymentMethod: () => insurancePersonPaymentMethod2,
  insurancePregnancyInsuranceHolderGender: () => insurancePregnancyInsuranceHolderGender2,
  insurancePregnancyPaymentMethod: () => insurancePregnancyPaymentMethod2,
  insuranceVehicleInsuranceHolderGender: () => insuranceVehicleInsuranceHolderGender2,
  insuranceVehiclePaymentMethod: () => insuranceVehiclePaymentMethod2,
  market: () => market2,
  monetaryAmountCurrencyCode: () => monetaryAmountCurrencyCode2,
  premiumFrequency: () => premiumFrequency2,
  premiumTaxation: () => premiumTaxation2,
  responseObjectType: () => responseObjectType,
  supplementInformationType: () => supplementInformationType,
  swedishInsuranceHomeInsuranceHolderGender: () => swedishInsuranceHomeInsuranceHolderGender2,
  swedishInsuranceHomePaymentMethod: () => swedishInsuranceHomePaymentMethod2,
  swedishInsuranceVillaInsuranceHolderGender: () => swedishInsuranceVillaInsuranceHolderGender2,
  swedishInsuranceVillaPaymentMethod: () => swedishInsuranceVillaPaymentMethod2,
  twoFactorAuthenticationInstructionResponseType: () => twoFactorAuthenticationInstructionResponseType,
  twoFactorCodeType: () => twoFactorCodeType
});

// src/types/insurance-api/v4/types/AdditionalBuilding.ts
var additionalBuildingBuildingType2 = {
  "BARN": "BARN",
  "BOAT_HOUSE": "BOAT_HOUSE",
  "GUEST_HOUSE": "GUEST_HOUSE",
  "CARPORT": "CARPORT",
  "ENCLOSED_PORCH": "ENCLOSED_PORCH",
  "GARAGE": "GARAGE",
  "GAZEBO": "GAZEBO",
  "GREEN_HOUSE": "GREEN_HOUSE",
  "POOL": "POOL",
  "SAUNA": "SAUNA",
  "SHED": "SHED",
  "STABLE": "STABLE",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v4/types/AdditionalBuildingCottage.ts
var additionalBuildingCottageBuildingType2 = {
  "BARN": "BARN",
  "BOAT_HOUSE": "BOAT_HOUSE",
  "GUEST_HOUSE": "GUEST_HOUSE",
  "CARPORT": "CARPORT",
  "ENCLOSED_PORCH": "ENCLOSED_PORCH",
  "GARAGE": "GARAGE",
  "GAZEBO": "GAZEBO",
  "GREEN_HOUSE": "GREEN_HOUSE",
  "POOL": "POOL",
  "SAUNA": "SAUNA",
  "SHED": "SHED",
  "STABLE": "STABLE",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v4/types/Collection1CollectInfo.ts
var collection1CollectInfoHeaderParamsInsurelyVersion2 = {
  "2023-03-15": "2023-03-15"
};

// src/types/insurance-api/v4/types/Collection2Status.ts
var collection2StatusHeaderParamsInsurelyVersion2 = {
  "2023-03-15": "2023-03-15"
};

// src/types/insurance-api/v4/types/Collection3GetData.ts
var collection3GetDataHeaderParamsInsurelyLanguage2 = {
  "SWEDISH": "SWEDISH",
  "ENGLISH": "ENGLISH",
  "NORWEGIAN": "NORWEGIAN",
  "DANISH": "DANISH",
  "ESTONIAN": "ESTONIAN",
  "FRENCH": "FRENCH"
};
var collection3GetDataHeaderParamsInsurelyVersion2 = {
  "2023-03-15": "2023-03-15"
};

// src/types/insurance-api/v4/types/Collection3GetPolicyDocument.ts
var collection3GetPolicyDocumentHeaderParamsInsurelyVersion = {
  "2023-03-15": "2023-03-15"
};

// src/types/insurance-api/v4/types/Collection3SupplementInformation.ts
var collection3SupplementInformationHeaderParamsInsurelyVersion2 = {
  "2023-03-15": "2023-03-15"
};

// src/types/insurance-api/v4/types/Collection4GetParameters.ts
var collection4GetParametersHeaderParamsInsurelyLanguage2 = {
  "SWEDISH": "SWEDISH",
  "ENGLISH": "ENGLISH",
  "NORWEGIAN": "NORWEGIAN",
  "DANISH": "DANISH",
  "ESTONIAN": "ESTONIAN",
  "FRENCH": "FRENCH"
};
var collection4GetParametersHeaderParamsInsurelyVersion2 = {
  "2023-03-15": "2023-03-15"
};

// src/types/insurance-api/v4/types/Collection5GetAllParameters.ts
var collection5GetAllParametersHeaderParamsInsurelyLanguage2 = {
  "SWEDISH": "SWEDISH",
  "ENGLISH": "ENGLISH",
  "NORWEGIAN": "NORWEGIAN",
  "DANISH": "DANISH",
  "ESTONIAN": "ESTONIAN",
  "FRENCH": "FRENCH"
};
var collection5GetAllParametersHeaderParamsInsurelyVersion2 = {
  "2023-03-15": "2023-03-15"
};

// src/types/insurance-api/v4/types/CollectionItem.ts
var collectionItemStatus = {
  "NOT_STARTED": "NOT_STARTED",
  "COMPLETED": "COMPLETED",
  "COLLECTING": "COLLECTING",
  "FAILED": "FAILED",
  "NOT_COLLECTED": "NOT_COLLECTED"
};

// src/types/insurance-api/v4/types/CollectionRequestFilterRule.ts
var collectionRequestFilterRuleField2 = {
  "registrationNo": "registrationNo"
};

// src/types/insurance-api/v4/types/CollectionRequestV2.ts
var collectionRequestV2LoginMethod2 = {
  "DANISH_NEMID": "DANISH_NEMID",
  "DANISH_MITID": "DANISH_MITID",
  "DANISH_MITID_SAME_DEVICE": "DANISH_MITID_SAME_DEVICE",
  "ESTONIAN_MOBILE_ID": "ESTONIAN_MOBILE_ID",
  "ESTONIAN_SMART_ID": "ESTONIAN_SMART_ID",
  "ESTONIAN_MOBILE_ID_USERNAME": "ESTONIAN_MOBILE_ID_USERNAME",
  "ESTONIAN_SMART_ID_USERNAME": "ESTONIAN_SMART_ID_USERNAME",
  "LATVIAN_MOBILE_EPARAKSTS": "LATVIAN_MOBILE_EPARAKSTS",
  "LATVIAN_SMART_ID": "LATVIAN_SMART_ID",
  "LATVIAN_MOBILE_EPARAKSTS_USERNAME": "LATVIAN_MOBILE_EPARAKSTS_USERNAME",
  "LATVIAN_SMART_ID_USERNAME": "LATVIAN_SMART_ID_USERNAME",
  "LITHUANIAN_SMART_ID": "LITHUANIAN_SMART_ID",
  "LITHUANIAN_MOBILE_ID": "LITHUANIAN_MOBILE_ID",
  "NORWEGIAN_BANKID_ON_MOBILE": "NORWEGIAN_BANKID_ON_MOBILE",
  "NORWEGIAN_BANKID_ON_MOBILE_FULL_PERSONAL_NUMBER": "NORWEGIAN_BANKID_ON_MOBILE_FULL_PERSONAL_NUMBER",
  "SWEDISH_MOBILE_BANKID_ANY_DEVICE": "SWEDISH_MOBILE_BANKID_ANY_DEVICE",
  "SWEDISH_MOBILE_BANKID_OTHER_DEVICE": "SWEDISH_MOBILE_BANKID_OTHER_DEVICE",
  "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_MOCK": "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_MOCK",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE": "SWEDISH_MOBILE_BANKID_SAME_DEVICE",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION": "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION_MOCK": "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION_MOCK",
  "SWEDISH_MOBILE_BANKID_ANY_DEVICE_TEST": "SWEDISH_MOBILE_BANKID_ANY_DEVICE_TEST",
  "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_TEST": "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_TEST",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE_TEST": "SWEDISH_MOBILE_BANKID_SAME_DEVICE_TEST",
  "SWEDISH_SECURITY_TOKEN": "SWEDISH_SECURITY_TOKEN",
  "UK_DOB_USERNAME_PASSWORD": "UK_DOB_USERNAME_PASSWORD",
  "UK_LASTNAME_MEMBERSHIP_NUMBER": "UK_LASTNAME_MEMBERSHIP_NUMBER",
  "UK_USERNAME_POSTCODE": "UK_USERNAME_POSTCODE",
  "USERNAME_AND_PASSWORD": "USERNAME_AND_PASSWORD",
  "EMAIL": "EMAIL",
  "PDF_UPLOAD": "PDF_UPLOAD"
};

// src/types/insurance-api/v4/types/CollectionStatusInformationMap.ts
var collectionStatusInformationMapRequiredInputTypes = {
  "EMAIL": "EMAIL",
  "MOBILE_PHONE_NUMBER": "MOBILE_PHONE_NUMBER"
};

// src/types/insurance-api/v4/types/CompanyAvailability.ts
var companyAvailabilityStatus2 = {
  "OK": "OK",
  "BETA": "BETA",
  "NOT_IMPLEMENTED": "NOT_IMPLEMENTED"
};
var companyAvailabilityReason2 = {
  "THIRD_PARTY_ERROR": "THIRD_PARTY_ERROR",
  "THIRD_PARTY_UPDATE": "THIRD_PARTY_UPDATE",
  "INSURELY_ERROR": "INSURELY_ERROR",
  "INSURELY_UPDATE": "INSURELY_UPDATE",
  "RECONSTRUCTION": "RECONSTRUCTION"
};
var companyAvailabilityLoginMethods2 = {
  "DANISH_NEMID": "DANISH_NEMID",
  "DANISH_MITID": "DANISH_MITID",
  "DANISH_MITID_SAME_DEVICE": "DANISH_MITID_SAME_DEVICE",
  "ESTONIAN_MOBILE_ID": "ESTONIAN_MOBILE_ID",
  "ESTONIAN_SMART_ID": "ESTONIAN_SMART_ID",
  "ESTONIAN_MOBILE_ID_USERNAME": "ESTONIAN_MOBILE_ID_USERNAME",
  "ESTONIAN_SMART_ID_USERNAME": "ESTONIAN_SMART_ID_USERNAME",
  "LATVIAN_MOBILE_EPARAKSTS": "LATVIAN_MOBILE_EPARAKSTS",
  "LATVIAN_SMART_ID": "LATVIAN_SMART_ID",
  "LATVIAN_MOBILE_EPARAKSTS_USERNAME": "LATVIAN_MOBILE_EPARAKSTS_USERNAME",
  "LATVIAN_SMART_ID_USERNAME": "LATVIAN_SMART_ID_USERNAME",
  "LITHUANIAN_SMART_ID": "LITHUANIAN_SMART_ID",
  "LITHUANIAN_MOBILE_ID": "LITHUANIAN_MOBILE_ID",
  "NORWEGIAN_BANKID_ON_MOBILE": "NORWEGIAN_BANKID_ON_MOBILE",
  "NORWEGIAN_BANKID_ON_MOBILE_FULL_PERSONAL_NUMBER": "NORWEGIAN_BANKID_ON_MOBILE_FULL_PERSONAL_NUMBER",
  "SWEDISH_MOBILE_BANKID_ANY_DEVICE": "SWEDISH_MOBILE_BANKID_ANY_DEVICE",
  "SWEDISH_MOBILE_BANKID_OTHER_DEVICE": "SWEDISH_MOBILE_BANKID_OTHER_DEVICE",
  "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_MOCK": "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_MOCK",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE": "SWEDISH_MOBILE_BANKID_SAME_DEVICE",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION": "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION_MOCK": "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION_MOCK",
  "SWEDISH_MOBILE_BANKID_ANY_DEVICE_TEST": "SWEDISH_MOBILE_BANKID_ANY_DEVICE_TEST",
  "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_TEST": "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_TEST",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE_TEST": "SWEDISH_MOBILE_BANKID_SAME_DEVICE_TEST",
  "SWEDISH_SECURITY_TOKEN": "SWEDISH_SECURITY_TOKEN",
  "UK_DOB_USERNAME_PASSWORD": "UK_DOB_USERNAME_PASSWORD",
  "UK_LASTNAME_MEMBERSHIP_NUMBER": "UK_LASTNAME_MEMBERSHIP_NUMBER",
  "UK_USERNAME_POSTCODE": "UK_USERNAME_POSTCODE",
  "USERNAME_AND_PASSWORD": "USERNAME_AND_PASSWORD",
  "EMAIL": "EMAIL",
  "PDF_UPLOAD": "PDF_UPLOAD"
};
var companyAvailabilityNonFunctionalLoginMethods2 = {
  "DANISH_NEMID": "DANISH_NEMID",
  "DANISH_MITID": "DANISH_MITID",
  "DANISH_MITID_SAME_DEVICE": "DANISH_MITID_SAME_DEVICE",
  "ESTONIAN_MOBILE_ID": "ESTONIAN_MOBILE_ID",
  "ESTONIAN_SMART_ID": "ESTONIAN_SMART_ID",
  "ESTONIAN_MOBILE_ID_USERNAME": "ESTONIAN_MOBILE_ID_USERNAME",
  "ESTONIAN_SMART_ID_USERNAME": "ESTONIAN_SMART_ID_USERNAME",
  "LATVIAN_MOBILE_EPARAKSTS": "LATVIAN_MOBILE_EPARAKSTS",
  "LATVIAN_SMART_ID": "LATVIAN_SMART_ID",
  "LATVIAN_MOBILE_EPARAKSTS_USERNAME": "LATVIAN_MOBILE_EPARAKSTS_USERNAME",
  "LATVIAN_SMART_ID_USERNAME": "LATVIAN_SMART_ID_USERNAME",
  "LITHUANIAN_SMART_ID": "LITHUANIAN_SMART_ID",
  "LITHUANIAN_MOBILE_ID": "LITHUANIAN_MOBILE_ID",
  "NORWEGIAN_BANKID_ON_MOBILE": "NORWEGIAN_BANKID_ON_MOBILE",
  "NORWEGIAN_BANKID_ON_MOBILE_FULL_PERSONAL_NUMBER": "NORWEGIAN_BANKID_ON_MOBILE_FULL_PERSONAL_NUMBER",
  "SWEDISH_MOBILE_BANKID_ANY_DEVICE": "SWEDISH_MOBILE_BANKID_ANY_DEVICE",
  "SWEDISH_MOBILE_BANKID_OTHER_DEVICE": "SWEDISH_MOBILE_BANKID_OTHER_DEVICE",
  "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_MOCK": "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_MOCK",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE": "SWEDISH_MOBILE_BANKID_SAME_DEVICE",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION": "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION_MOCK": "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION_MOCK",
  "SWEDISH_MOBILE_BANKID_ANY_DEVICE_TEST": "SWEDISH_MOBILE_BANKID_ANY_DEVICE_TEST",
  "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_TEST": "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_TEST",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE_TEST": "SWEDISH_MOBILE_BANKID_SAME_DEVICE_TEST",
  "SWEDISH_SECURITY_TOKEN": "SWEDISH_SECURITY_TOKEN",
  "UK_DOB_USERNAME_PASSWORD": "UK_DOB_USERNAME_PASSWORD",
  "UK_LASTNAME_MEMBERSHIP_NUMBER": "UK_LASTNAME_MEMBERSHIP_NUMBER",
  "UK_USERNAME_POSTCODE": "UK_USERNAME_POSTCODE",
  "USERNAME_AND_PASSWORD": "USERNAME_AND_PASSWORD",
  "EMAIL": "EMAIL",
  "PDF_UPLOAD": "PDF_UPLOAD"
};
var companyAvailabilityCompanyAndLineOfBusinesses2 = {
  "EE_SWEDBANK": "EE_SWEDBANK",
  "FR_ALLIANZ_HOME": "FR_ALLIANZ_HOME",
  "FR_ALLIANZ_VEHICLE": "FR_ALLIANZ_VEHICLE",
  "FR_ANIMAUXSANTE_HOME": "FR_ANIMAUXSANTE_HOME",
  "FR_ASSUR_OPOIL_ANIMAL": "FR_ASSUR_OPOIL_ANIMAL",
  "FR_AXA_HOME": "FR_AXA_HOME",
  "FR_AXA_VEHICLE": "FR_AXA_VEHICLE",
  "FR_AXA_GENERAL": "FR_AXA_GENERAL",
  "FR_BANQUE_POPULAIRE_HOME": "FR_BANQUE_POPULAIRE_HOME",
  "FR_BULLE_BLEUE_HOME": "FR_BULLE_BLEUE_HOME",
  "FR_CAISSE_DEPARGNE_HOME": "FR_CAISSE_DEPARGNE_HOME",
  "FR_CARDIF_HOME": "FR_CARDIF_HOME",
  "FR_CREDIT_AGRICOLE_HOME": "FR_CREDIT_AGRICOLE_HOME",
  "FR_CREDIT_AGRICOLE_VEHICLE": "FR_CREDIT_AGRICOLE_VEHICLE",
  "FR_CREDIT_MUTUEL_HOME": "FR_CREDIT_MUTUEL_HOME",
  "FR_CREDIT_MUTUEL_VEHICLE": "FR_CREDIT_MUTUEL_VEHICLE",
  "FR_DEMO_HOME": "FR_DEMO_HOME",
  "FR_DEMO_VEHICLE": "FR_DEMO_VEHICLE",
  "FR_DIRECT_ASSURANCE_HOME": "FR_DIRECT_ASSURANCE_HOME",
  "FR_DIRECT_ASSURANCE_VEHICLE": "FR_DIRECT_ASSURANCE_VEHICLE",
  "FR_ECA_HOME": "FR_ECA_HOME",
  "FR_ECA_ANIMAL": "FR_ECA_ANIMAL",
  "FR_GENERALI_HOME": "FR_GENERALI_HOME",
  "FR_GENERALI_VEHICLE": "FR_GENERALI_VEHICLE",
  "FR_GMF_HOME": "FR_GMF_HOME",
  "FR_GMF_VEHICLE": "FR_GMF_VEHICLE",
  "FR_GROUPAMA_HOME": "FR_GROUPAMA_HOME",
  "FR_GROUPAMA_VEHICLE": "FR_GROUPAMA_VEHICLE",
  "FR_LUKO_HOME": "FR_LUKO_HOME",
  "FR_MAAF_HOME": "FR_MAAF_HOME",
  "FR_MAAF_VEHICLE": "FR_MAAF_VEHICLE",
  "FR_MACIF_HOME": "FR_MACIF_HOME",
  "FR_MACIF_VEHICLE": "FR_MACIF_VEHICLE",
  "FR_MAIF_HOME": "FR_MAIF_HOME",
  "FR_MAIF_VEHICLE": "FR_MAIF_VEHICLE",
  "FR_MATMUT_HOME": "FR_MATMUT_HOME",
  "FR_MMA_HOME": "FR_MMA_HOME",
  "FR_MMA_VEHICLE": "FR_MMA_VEHICLE",
  "FR_SANTEVET_HOME": "FR_SANTEVET_HOME",
  "SE_IF_VEHICLE": "SE_IF_VEHICLE",
  "SE_FOLKSAM_VEHICLE": "SE_FOLKSAM_VEHICLE",
  "SE_LANSFORSAKRINGAR_HOME": "SE_LANSFORSAKRINGAR_HOME",
  "SE_PAYDRIVE_VEHICLE": "SE_PAYDRIVE_VEHICLE",
  "SE_SVEDEA_VEHICLE": "SE_SVEDEA_VEHICLE",
  "SE_VOLVIA_VEHICLE": "SE_VOLVIA_VEHICLE",
  "SE_BLIWA_ACCIDENT": "SE_BLIWA_ACCIDENT",
  "UK_AXA_HOME": "UK_AXA_HOME",
  "UK_AXA_VEHICLE": "UK_AXA_VEHICLE",
  "UK_HASTINGS_DIRECT_HOME": "UK_HASTINGS_DIRECT_HOME",
  "UK_HASTINGS_DIRECT_VEHICLE": "UK_HASTINGS_DIRECT_VEHICLE",
  "UK_POLICYEXPERT_HOME": "UK_POLICYEXPERT_HOME",
  "UK_POLICYEXPERT_VEHICLE": "UK_POLICYEXPERT_VEHICLE",
  "UK_POST_OFFICE_HOME": "UK_POST_OFFICE_HOME",
  "UK_THE_AA_HOME": "UK_THE_AA_HOME",
  "UK_THE_AA_VEHICLE": "UK_THE_AA_VEHICLE",
  "UK_URBAN_JUNGLE_HOME": "UK_URBAN_JUNGLE_HOME",
  "FR_AXA_PERSON": "FR_AXA_PERSON",
  "FR_ACHEEL_HOME": "FR_ACHEEL_HOME"
};

// src/types/insurance-api/v4/types/CompanyLoginConfig.ts
var companyLoginConfigUsernameLabel2 = {
  "EMAIL": "EMAIL",
  "USERNAME": "USERNAME"
};
var companyLoginConfigUsernameFieldPlaceholder2 = {
  "EMAIL": "EMAIL",
  "IDENTIFICATION_NUMBER_11": "IDENTIFICATION_NUMBER_11",
  "IDENTIFICATION_CHARACTERS_8": "IDENTIFICATION_CHARACTERS_8",
  "EMAIL_MOBILE_MUTUAL_MEMBER": "EMAIL_MOBILE_MUTUAL_MEMBER",
  "EMAIL_MOBILE_CLIENT": "EMAIL_MOBILE_CLIENT",
  "EMAIL_MUTUAL_OR_REGULAR_MEMBER": "EMAIL_MUTUAL_OR_REGULAR_MEMBER",
  "EMAIL_MOBILE_CONTRACT": "EMAIL_MOBILE_CONTRACT",
  "EMAIL_OR_MEMBER": "EMAIL_OR_MEMBER"
};
var companyLoginConfigPasswordLabel2 = {
  "PASSWORD": "PASSWORD",
  "CONFIDENTIAL_CODE": "CONFIDENTIAL_CODE",
  "PERSONAL_CODE": "PERSONAL_CODE"
};
var companyLoginConfigPasswordFieldPlaceholder2 = {
  "PASSWORD": "PASSWORD",
  "CONFIDENTIAL_CODE": "CONFIDENTIAL_CODE",
  "PERSONAL_CODE": "PERSONAL_CODE"
};

// src/types/insurance-api/v4/types/ConsentRequestInput.ts
var consentRequestInputType2 = {
  "TRADE_UNION_MEMBERSHIP": "TRADE_UNION_MEMBERSHIP"
};

// src/types/insurance-api/v4/types/ConsentRequirement.ts
var consentRequirementType2 = {
  "TRADE_UNION_MEMBERSHIP": "TRADE_UNION_MEMBERSHIP"
};
var consentRequirementMethod2 = {
  "NONE": "NONE",
  "NOTICE": "NOTICE",
  "ACTIVE": "ACTIVE"
};

// src/types/insurance-api/v4/types/CoreInsuranceHome.ts
var coreInsuranceHomePaymentMethod2 = {
  "UNDEFINED": "UNDEFINED",
  "AUTOGIRO": "AUTOGIRO",
  "PAPER_INVOICE": "PAPER_INVOICE",
  "ELECTRONIC_INVOICE": "ELECTRONIC_INVOICE",
  "GENERIC_INVOICE": "GENERIC_INVOICE",
  "ONE_TIME_PAYMENT": "ONE_TIME_PAYMENT",
  "EMPLOYER_PAID": "EMPLOYER_PAID",
  "CREDIT_CARD": "CREDIT_CARD"
};
var coreInsuranceHomeInsuranceHolderGender2 = {
  "MALE": "MALE",
  "FEMALE": "FEMALE",
  "OTHER": "OTHER",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v4/types/CoreInsuranceVilla.ts
var coreInsuranceVillaPaymentMethod2 = {
  "UNDEFINED": "UNDEFINED",
  "AUTOGIRO": "AUTOGIRO",
  "PAPER_INVOICE": "PAPER_INVOICE",
  "ELECTRONIC_INVOICE": "ELECTRONIC_INVOICE",
  "GENERIC_INVOICE": "GENERIC_INVOICE",
  "ONE_TIME_PAYMENT": "ONE_TIME_PAYMENT",
  "EMPLOYER_PAID": "EMPLOYER_PAID",
  "CREDIT_CARD": "CREDIT_CARD"
};
var coreInsuranceVillaInsuranceHolderGender2 = {
  "MALE": "MALE",
  "FEMALE": "FEMALE",
  "OTHER": "OTHER",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v4/types/CoverageParameterValueDeductible.ts
var coverageParameterValueDeductibleDeductibleType2 = {
  "amount": "amount",
  "complex": "complex",
  "general": "general",
  "not-applicable": "not-applicable"
};

// src/types/insurance-api/v4/types/CoverageParameterValueLimit.ts
var coverageParameterValueLimitLimitType2 = {
  "amount": "amount",
  "complex": "complex",
  "full-value": "full-value",
  "no-limit": "no-limit",
  "not-applicable": "not-applicable"
};

// src/types/insurance-api/v4/types/CoveragePolicyData.ts
var coveragePolicyDataResidentialStatus = {
  "PRIMARY_RESIDENCE": "PRIMARY_RESIDENCE",
  "SECONDARY_RESIDENCE": "SECONDARY_RESIDENCE",
  "RENTAL_RESIDENCE": "RENTAL_RESIDENCE",
  "UNKNOWN": "UNKNOWN"
};
var coveragePolicyDataOwnershipStatus = {
  "OWNER": "OWNER",
  "TENANT": "TENANT",
  "SECONDARY_TENANT": "SECONDARY_TENANT",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v4/types/FarmProperty.ts
var farmPropertyBuildingType2 = {
  "BARN": "BARN",
  "STABLE": "STABLE",
  "LOG_CABIN": "LOG_CABIN",
  "MACHINE_HALL": "MACHINE_HALL",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v4/types/FrenchInsurance.ts
var frenchInsuranceInsuranceHolderGender2 = {
  "MALE": "MALE",
  "FEMALE": "FEMALE",
  "OTHER": "OTHER",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v4/types/FrenchInsuranceCar.ts
var frenchInsuranceCarInsuranceHolderGender2 = {
  "MALE": "MALE",
  "FEMALE": "FEMALE",
  "OTHER": "OTHER",
  "UNKNOWN": "UNKNOWN"
};
var frenchInsuranceCarUsagePurposes2 = {
  "PRIVATE": "PRIVATE",
  "COMMUTING": "COMMUTING",
  "WORK": "WORK"
};

// src/types/insurance-api/v4/types/FrenchInsuranceHome.ts
var frenchInsuranceHomePaymentMethod2 = {
  "UNDEFINED": "UNDEFINED",
  "AUTOGIRO": "AUTOGIRO",
  "PAPER_INVOICE": "PAPER_INVOICE",
  "ELECTRONIC_INVOICE": "ELECTRONIC_INVOICE",
  "GENERIC_INVOICE": "GENERIC_INVOICE",
  "ONE_TIME_PAYMENT": "ONE_TIME_PAYMENT",
  "EMPLOYER_PAID": "EMPLOYER_PAID",
  "CREDIT_CARD": "CREDIT_CARD"
};
var frenchInsuranceHomeInsuranceHolderGender2 = {
  "MALE": "MALE",
  "FEMALE": "FEMALE",
  "OTHER": "OTHER",
  "UNKNOWN": "UNKNOWN"
};
var frenchInsuranceHomeFloor2 = {
  "GROUND_FLOOR": "GROUND_FLOOR",
  "COURTYARD": "COURTYARD",
  "INTERMEDIATE_FLOOR": "INTERMEDIATE_FLOOR",
  "TOP_FLOOR": "TOP_FLOOR",
  "UNKNOWN": "UNKNOWN"
};
var frenchInsuranceHomeAdditionalAmenities2 = {
  "FIREPLACE": "FIREPLACE",
  "POOL": "POOL",
  "GARDEN": "GARDEN"
};
var frenchInsuranceHomeOwnershipStatus2 = {
  "OWNER": "OWNER",
  "TENANT": "TENANT",
  "SECONDARY_TENANT": "SECONDARY_TENANT",
  "UNKNOWN": "UNKNOWN"
};
var frenchInsuranceHomeResidentialStatus2 = {
  "PRIMARY_RESIDENCE": "PRIMARY_RESIDENCE",
  "SECONDARY_RESIDENCE": "SECONDARY_RESIDENCE",
  "RENTAL_RESIDENCE": "RENTAL_RESIDENCE",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v4/types/FrenchInsuranceHouseContent.ts
var frenchInsuranceHouseContentAdditionalAmenities2 = {
  "FIREPLACE": "FIREPLACE",
  "POOL": "POOL",
  "GARDEN": "GARDEN"
};
var frenchInsuranceHouseContentOwnershipStatus2 = {
  "OWNER": "OWNER",
  "TENANT": "TENANT",
  "SECONDARY_TENANT": "SECONDARY_TENANT",
  "UNKNOWN": "UNKNOWN"
};
var frenchInsuranceHouseContentResidentialStatus2 = {
  "PRIMARY_RESIDENCE": "PRIMARY_RESIDENCE",
  "SECONDARY_RESIDENCE": "SECONDARY_RESIDENCE",
  "RENTAL_RESIDENCE": "RENTAL_RESIDENCE",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v4/types/FrenchInsuranceVehicle.ts
var frenchInsuranceVehicleUsagePurposes2 = {
  "PRIVATE": "PRIVATE",
  "COMMUTING": "COMMUTING",
  "WORK": "WORK"
};

// src/types/insurance-api/v4/types/FrenchInsuranceVilla.ts
var frenchInsuranceVillaPaymentMethod2 = {
  "UNDEFINED": "UNDEFINED",
  "AUTOGIRO": "AUTOGIRO",
  "PAPER_INVOICE": "PAPER_INVOICE",
  "ELECTRONIC_INVOICE": "ELECTRONIC_INVOICE",
  "GENERIC_INVOICE": "GENERIC_INVOICE",
  "ONE_TIME_PAYMENT": "ONE_TIME_PAYMENT",
  "EMPLOYER_PAID": "EMPLOYER_PAID",
  "CREDIT_CARD": "CREDIT_CARD"
};
var frenchInsuranceVillaInsuranceHolderGender2 = {
  "MALE": "MALE",
  "FEMALE": "FEMALE",
  "OTHER": "OTHER",
  "UNKNOWN": "UNKNOWN"
};
var frenchInsuranceVillaAdditionalAmenities2 = {
  "FIREPLACE": "FIREPLACE",
  "POOL": "POOL",
  "GARDEN": "GARDEN"
};
var frenchInsuranceVillaOwnershipStatus2 = {
  "OWNER": "OWNER",
  "TENANT": "TENANT",
  "SECONDARY_TENANT": "SECONDARY_TENANT",
  "UNKNOWN": "UNKNOWN"
};
var frenchInsuranceVillaResidentialStatus2 = {
  "PRIMARY_RESIDENCE": "PRIMARY_RESIDENCE",
  "SECONDARY_RESIDENCE": "SECONDARY_RESIDENCE",
  "RENTAL_RESIDENCE": "RENTAL_RESIDENCE",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v4/types/FrenchParkingLocation.ts
var frenchParkingLocationParkingLocationType2 = {
  "STREET": "STREET",
  "COMMON_GARAGE": "COMMON_GARAGE",
  "INDIVIDUAL_GARAGE": "INDIVIDUAL_GARAGE",
  "PRIVATE_PROPERTY": "PRIVATE_PROPERTY",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v4/types/FrenchVehicleOwnership.ts
var frenchVehicleOwnershipStatus2 = {
  "OWNED": "OWNED",
  "LEASING": "LEASING",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v4/types/GetCompaniesStatus.ts
var getCompaniesStatusHeaderParamsInsurelyVersion2 = {
  "2023-03-15": "2023-03-15"
};

// src/types/insurance-api/v4/types/GetParametersRequest.ts
var getParametersRequestInsuranceType = {
  "VEHICLE_INSURANCE": "VEHICLE_INSURANCE",
  "HOUSECONTENT_INSURANCE": "HOUSECONTENT_INSURANCE",
  "PERSON_INSURANCE": "PERSON_INSURANCE",
  "ANIMAL_INSURANCE": "ANIMAL_INSURANCE",
  "GROUP_INSURANCE": "GROUP_INSURANCE",
  "GENERAL_INSURANCE": "GENERAL_INSURANCE",
  "INCOME_INSURANCE": "INCOME_INSURANCE"
};
var getParametersRequestInsuranceSubType = {
  "CAR_INSURANCE": "CAR_INSURANCE",
  "BOAT_INSURANCE": "BOAT_INSURANCE",
  "TRAILER_INSURANCE": "TRAILER_INSURANCE",
  "MOTORCYCLE_INSURANCE": "MOTORCYCLE_INSURANCE",
  "MOPED_INSURANCE": "MOPED_INSURANCE",
  "CARAVAN_INSURANCE": "CARAVAN_INSURANCE",
  "MOTORHOME_INSURANCE": "MOTORHOME_INSURANCE",
  "OTHERVEHICLE_INSURANCE": "OTHERVEHICLE_INSURANCE",
  "CHILD_INSURANCE": "CHILD_INSURANCE",
  "PREGNANCY_INSURANCE": "PREGNANCY_INSURANCE",
  "LIFE_INSURANCE": "LIFE_INSURANCE",
  "HEALTH_INSURANCE": "HEALTH_INSURANCE",
  "ACCIDENT_INSURANCE": "ACCIDENT_INSURANCE",
  "TRAVEL_INSURANCE": "TRAVEL_INSURANCE",
  "CONDO_INSURANCE": "CONDO_INSURANCE",
  "CONTENTS_INSURANCE": "CONTENTS_INSURANCE",
  "VILLA_INSURANCE": "VILLA_INSURANCE",
  "COTTAGE_INSURANCE": "COTTAGE_INSURANCE",
  "FARM_INSURANCE": "FARM_INSURANCE",
  "CAT_INSURANCE": "CAT_INSURANCE",
  "DOG_INSURANCE": "DOG_INSURANCE",
  "HORSE_INSURANCE": "HORSE_INSURANCE",
  "OTHERANIMAL_INSURANCE": "OTHERANIMAL_INSURANCE",
  "GENERIC_INSURANCE": "GENERIC_INSURANCE",
  "GROUP_INSURANCE": "GROUP_INSURANCE",
  "INCOME_INSURANCE": "INCOME_INSURANCE",
  "SICKNESS_INSURANCE": "SICKNESS_INSURANCE",
  "LOAN_INSURANCE": "LOAN_INSURANCE"
};
var getParametersRequestInsuranceCompany2 = {
  "se-agria": "se-agria",
  "se-alecta": "se-alecta",
  "se-amf": "se-amf",
  "se-avanza": "se-avanza",
  "se-demo": "se-demo",
  "se-demo-two": "se-demo-two",
  "se-demo-three": "se-demo-three",
  "se-demo-four": "se-demo-four",
  "se-bliwa": "se-bliwa",
  "se-danske-bank": "se-danske-bank",
  "se-dina": "se-dina",
  "se-euroaccident": "se-euroaccident",
  "se-evidentlife": "se-evidentlife",
  "se-folksam": "se-folksam",
  "se-futur": "se-futur",
  "se-gjensidige": "se-gjensidige",
  "se-handelsbanken": "se-handelsbanken",
  "se-hedvig": "se-hedvig",
  "se-ica": "se-ica",
  "se-ica-bank": "se-ica-bank",
  "se-if": "se-if",
  "se-if-mercedes": "se-if-mercedes",
  "se-kpa": "se-kpa",
  "se-lansforsakringar": "se-lansforsakringar",
  "se-lassie": "se-lassie",
  "se-manypets": "se-manypets",
  "se-moderna": "se-moderna",
  "se-movestic": "se-movestic",
  "se-nordea": "se-nordea",
  "se-nordnet": "se-nordnet",
  "se-seb": "se-seb",
  "se-seb-bank": "se-seb-bank",
  "se-skandia": "se-skandia",
  "se-spp": "se-spp",
  "se-svedea": "se-svedea",
  "se-trekronor": "se-trekronor",
  "se-trygg-hansa": "se-trygg-hansa",
  "se-volvia": "se-volvia",
  "se-paydrive": "se-paydrive",
  "se-sveland": "se-sveland",
  "se-svenska-fribrevsbolaget": "se-svenska-fribrevsbolaget",
  "se-swedbank": "se-swedbank",
  "se-leaky": "se-leaky",
  "se-watercircles": "se-watercircles",
  "se-sensor": "se-sensor",
  "se-soderberg-partners": "se-soderberg-partners",
  "se-lf-alvsborg": "se-lf-alvsborg",
  "se-lf-bergslagen": "se-lf-bergslagen",
  "se-lf-blekinge": "se-lf-blekinge",
  "se-lf-dalarna": "se-lf-dalarna",
  "se-lf-goteborg-bohuslan": "se-lf-goteborg-bohuslan",
  "se-lf-goinge-kristianstad": "se-lf-goinge-kristianstad",
  "se-lf-gotland": "se-lf-gotland",
  "se-lf-gavleborg": "se-lf-gavleborg",
  "se-lf-halland": "se-lf-halland",
  "se-lf-jamtland": "se-lf-jamtland",
  "se-lf-jonkoping": "se-lf-jonkoping",
  "se-lf-norrbotten": "se-lf-norrbotten",
  "se-lf-ostgota": "se-lf-ostgota",
  "se-lf-kalmar": "se-lf-kalmar",
  "se-lf-kronoberg": "se-lf-kronoberg",
  "se-lf-stockholm": "se-lf-stockholm",
  "se-lf-sormland": "se-lf-sormland",
  "se-lf-skane": "se-lf-skane",
  "se-lf-skaraborg": "se-lf-skaraborg",
  "se-lf-uppsala": "se-lf-uppsala",
  "se-lf-varmland": "se-lf-varmland",
  "se-lf-vasterbotten": "se-lf-vasterbotten",
  "se-lf-vasternorrland": "se-lf-vasternorrland",
  "no-demo": "no-demo",
  "no-eika": "no-eika",
  "no-frende": "no-frende",
  "no-gjensidige": "no-gjensidige",
  "no-if": "no-if",
  "no-sparebank1": "no-sparebank1",
  "no-tryg": "no-tryg",
  "dk-alka": "dk-alka",
  "dk-almbrand": "dk-almbrand",
  "dk-bauta": "dk-bauta",
  "dk-codan": "dk-codan",
  "dk-demo": "dk-demo",
  "dk-fdm": "dk-fdm",
  "dk-gfforsikring": "dk-gfforsikring",
  "dk-gjensidige": "dk-gjensidige",
  "dk-ida": "dk-ida",
  "dk-if": "dk-if",
  "dk-lb": "dk-lb",
  "dk-lbforsikringpfa": "dk-lbforsikringpfa",
  "dk-runa": "dk-runa",
  "dk-tjm": "dk-tjm",
  "dk-topdanmark": "dk-topdanmark",
  "dk-tryg": "dk-tryg",
  "uk-aa": "uk-aa",
  "uk-admiral": "uk-admiral",
  "uk-animalfriends": "uk-animalfriends",
  "uk-axa": "uk-axa",
  "uk-axa-vehicle": "uk-axa-vehicle",
  "uk-aviva": "uk-aviva",
  "uk-barclays": "uk-barclays",
  "uk-manypets": "uk-manypets",
  "uk-churchill": "uk-churchill",
  "uk-demo": "uk-demo",
  "uk-natwest": "uk-natwest",
  "uk-directline": "uk-directline",
  "uk-halifax": "uk-halifax",
  "uk-hastings-direct": "uk-hastings-direct",
  "uk-john-lewis-home": "uk-john-lewis-home",
  "uk-lv": "uk-lv",
  "uk-morethan-home": "uk-morethan-home",
  "uk-onecall": "uk-onecall",
  "uk-petplan": "uk-petplan",
  "uk-policyexpert-home": "uk-policyexpert-home",
  "uk-policyexpert-vehicle": "uk-policyexpert-vehicle",
  "uk-postoffice": "uk-postoffice",
  "uk-privilege": "uk-privilege",
  "uk-rac": "uk-rac",
  "uk-saga": "uk-saga",
  "uk-sainsburys": "uk-sainsburys",
  "uk-sainsburys-pet": "uk-sainsburys-pet",
  "uk-sheilaswheels": "uk-sheilaswheels",
  "uk-sosure": "uk-sosure",
  "uk-swinton": "uk-swinton",
  "uk-tesco": "uk-tesco",
  "uk-urbanjungle": "uk-urbanjungle",
  "uk-waggel": "uk-waggel",
  "ee-bta": "ee-bta",
  "ee-demo": "ee-demo",
  "ee-ergo": "ee-ergo",
  "ee-gjensidige": "ee-gjensidige",
  "ee-if": "ee-if",
  "ee-pzu": "ee-pzu",
  "ee-salva": "ee-salva",
  "ee-seesam": "ee-seesam",
  "ee-swedbank": "ee-swedbank",
  "ee-lhv": "ee-lhv",
  "es-mapfre": "es-mapfre",
  "es-demo": "es-demo",
  "fr-acheel": "fr-acheel",
  "fr-allianz": "fr-allianz",
  "fr-animauxsante": "fr-animauxsante",
  "fr-assur-opoil": "fr-assur-opoil",
  "fr-axa": "fr-axa",
  "fr-bred": "fr-bred",
  "fr-bulle-bleue": "fr-bulle-bleue",
  "fr-cardif": "fr-cardif",
  "fr-credit-agricole": "fr-credit-agricole",
  "fr-credit-mutuel": "fr-credit-mutuel",
  "fr-dalma": "fr-dalma",
  "fr-demo": "fr-demo",
  "fr-eca": "fr-eca",
  "fr-generali": "fr-generali",
  "fr-gmf": "fr-gmf",
  "fr-groupama": "fr-groupama",
  "fr-luko": "fr-luko",
  "fr-kozoo": "fr-kozoo",
  "fr-maaf": "fr-maaf",
  "fr-macif": "fr-macif",
  "fr-matmut": "fr-matmut",
  "fr-maif": "fr-maif",
  "fr-mma": "fr-mma",
  "fr-santevet": "fr-santevet",
  "fr-lolivier": "fr-lolivier",
  "fr-caisse-depargne": "fr-caisse-depargne",
  "fr-banque-populaire": "fr-banque-populaire",
  "fr-mobilize": "fr-mobilize",
  "fr-direct-assurance": "fr-direct-assurance",
  "lv-balta": "lv-balta",
  "lv-ban": "lv-ban",
  "lv-bta": "lv-bta",
  "lv-compensa": "lv-compensa",
  "lv-demo": "lv-demo",
  "lv-ergo": "lv-ergo",
  "lv-gjensidige": "lv-gjensidige",
  "lv-if": "lv-if",
  "lv-luminor": "lv-luminor",
  "lv-seb": "lv-seb",
  "lv-swedbank": "lv-swedbank",
  "lt-demo": "lt-demo",
  "lt-gjensidige": "lt-gjensidige",
  "xx-loadtest-scrape": "xx-loadtest-scrape",
  "xx-loadtest-api": "xx-loadtest-api",
  "xx-docs": "xx-docs"
};

// src/types/insurance-api/v4/types/Insurance.ts
var insurancePaymentMethod2 = {
  "UNDEFINED": "UNDEFINED",
  "AUTOGIRO": "AUTOGIRO",
  "PAPER_INVOICE": "PAPER_INVOICE",
  "ELECTRONIC_INVOICE": "ELECTRONIC_INVOICE",
  "GENERIC_INVOICE": "GENERIC_INVOICE",
  "ONE_TIME_PAYMENT": "ONE_TIME_PAYMENT",
  "EMPLOYER_PAID": "EMPLOYER_PAID",
  "CREDIT_CARD": "CREDIT_CARD"
};
var insuranceInsuranceHolderGender2 = {
  "MALE": "MALE",
  "FEMALE": "FEMALE",
  "OTHER": "OTHER",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v4/types/InsuranceAccident.ts
var insuranceAccidentPaymentMethod2 = {
  "UNDEFINED": "UNDEFINED",
  "AUTOGIRO": "AUTOGIRO",
  "PAPER_INVOICE": "PAPER_INVOICE",
  "ELECTRONIC_INVOICE": "ELECTRONIC_INVOICE",
  "GENERIC_INVOICE": "GENERIC_INVOICE",
  "ONE_TIME_PAYMENT": "ONE_TIME_PAYMENT",
  "EMPLOYER_PAID": "EMPLOYER_PAID",
  "CREDIT_CARD": "CREDIT_CARD"
};
var insuranceAccidentInsuranceHolderGender2 = {
  "MALE": "MALE",
  "FEMALE": "FEMALE",
  "OTHER": "OTHER",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v4/types/InsuranceAnimal.ts
var insuranceAnimalAnimalGender2 = {
  "MALE": "MALE",
  "FEMALE": "FEMALE",
  "CASTRATED_MALE": "CASTRATED_MALE",
  "CASTRATED_FEMALE": "CASTRATED_FEMALE",
  "UNKNOWN": "UNKNOWN"
};
var insuranceAnimalPaymentMethod2 = {
  "UNDEFINED": "UNDEFINED",
  "AUTOGIRO": "AUTOGIRO",
  "PAPER_INVOICE": "PAPER_INVOICE",
  "ELECTRONIC_INVOICE": "ELECTRONIC_INVOICE",
  "GENERIC_INVOICE": "GENERIC_INVOICE",
  "ONE_TIME_PAYMENT": "ONE_TIME_PAYMENT",
  "EMPLOYER_PAID": "EMPLOYER_PAID",
  "CREDIT_CARD": "CREDIT_CARD"
};
var insuranceAnimalInsuranceHolderGender2 = {
  "MALE": "MALE",
  "FEMALE": "FEMALE",
  "OTHER": "OTHER",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v4/types/InsuranceCar.ts
var insuranceCarCoverage2 = {
  "UNDEFINED": "UNDEFINED",
  "FULL_WITH_CHASSI": "FULL_WITH_CHASSI",
  "FULL_WITHOUT_CHASSI": "FULL_WITHOUT_CHASSI",
  "TRAFFIC": "TRAFFIC",
  "NOT_IN_TRAFFIC": "NOT_IN_TRAFFIC",
  "COMPREHENSIVE": "COMPREHENSIVE",
  "CASCO": "CASCO",
  "MTPL": "MTPL"
};
var insuranceCarInsuranceLevel2 = {
  "BASE": "BASE",
  "PLUS": "PLUS",
  "UNDEFINED": "UNDEFINED"
};

// src/types/insurance-api/v4/types/InsuranceChild.ts
var insuranceChildPaymentMethod2 = {
  "UNDEFINED": "UNDEFINED",
  "AUTOGIRO": "AUTOGIRO",
  "PAPER_INVOICE": "PAPER_INVOICE",
  "ELECTRONIC_INVOICE": "ELECTRONIC_INVOICE",
  "GENERIC_INVOICE": "GENERIC_INVOICE",
  "ONE_TIME_PAYMENT": "ONE_TIME_PAYMENT",
  "EMPLOYER_PAID": "EMPLOYER_PAID",
  "CREDIT_CARD": "CREDIT_CARD"
};
var insuranceChildInsuranceHolderGender2 = {
  "MALE": "MALE",
  "FEMALE": "FEMALE",
  "OTHER": "OTHER",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v4/types/InsuranceCompany.ts
var insuranceCompany2 = {
  "se-agria": "se-agria",
  "se-alecta": "se-alecta",
  "se-amf": "se-amf",
  "se-avanza": "se-avanza",
  "se-demo": "se-demo",
  "se-demo-two": "se-demo-two",
  "se-demo-three": "se-demo-three",
  "se-demo-four": "se-demo-four",
  "se-bliwa": "se-bliwa",
  "se-danske-bank": "se-danske-bank",
  "se-dina": "se-dina",
  "se-euroaccident": "se-euroaccident",
  "se-evidentlife": "se-evidentlife",
  "se-folksam": "se-folksam",
  "se-futur": "se-futur",
  "se-gjensidige": "se-gjensidige",
  "se-handelsbanken": "se-handelsbanken",
  "se-hedvig": "se-hedvig",
  "se-ica": "se-ica",
  "se-ica-bank": "se-ica-bank",
  "se-if": "se-if",
  "se-if-mercedes": "se-if-mercedes",
  "se-kpa": "se-kpa",
  "se-lansforsakringar": "se-lansforsakringar",
  "se-lassie": "se-lassie",
  "se-manypets": "se-manypets",
  "se-moderna": "se-moderna",
  "se-movestic": "se-movestic",
  "se-nordea": "se-nordea",
  "se-nordnet": "se-nordnet",
  "se-seb": "se-seb",
  "se-seb-bank": "se-seb-bank",
  "se-skandia": "se-skandia",
  "se-spp": "se-spp",
  "se-svedea": "se-svedea",
  "se-trekronor": "se-trekronor",
  "se-trygg-hansa": "se-trygg-hansa",
  "se-volvia": "se-volvia",
  "se-paydrive": "se-paydrive",
  "se-sveland": "se-sveland",
  "se-svenska-fribrevsbolaget": "se-svenska-fribrevsbolaget",
  "se-swedbank": "se-swedbank",
  "se-leaky": "se-leaky",
  "se-watercircles": "se-watercircles",
  "se-sensor": "se-sensor",
  "se-soderberg-partners": "se-soderberg-partners",
  "no-demo": "no-demo",
  "no-eika": "no-eika",
  "no-frende": "no-frende",
  "no-gjensidige": "no-gjensidige",
  "no-if": "no-if",
  "no-sparebank1": "no-sparebank1",
  "no-tryg": "no-tryg",
  "dk-alka": "dk-alka",
  "dk-almbrand": "dk-almbrand",
  "dk-bauta": "dk-bauta",
  "dk-codan": "dk-codan",
  "dk-demo": "dk-demo",
  "dk-fdm": "dk-fdm",
  "dk-gfforsikring": "dk-gfforsikring",
  "dk-gjensidige": "dk-gjensidige",
  "dk-ida": "dk-ida",
  "dk-if": "dk-if",
  "dk-lb": "dk-lb",
  "dk-lbforsikringpfa": "dk-lbforsikringpfa",
  "dk-runa": "dk-runa",
  "dk-tjm": "dk-tjm",
  "dk-topdanmark": "dk-topdanmark",
  "dk-tryg": "dk-tryg",
  "uk-aa": "uk-aa",
  "uk-admiral": "uk-admiral",
  "uk-animalfriends": "uk-animalfriends",
  "uk-axa": "uk-axa",
  "uk-axa-vehicle": "uk-axa-vehicle",
  "uk-aviva": "uk-aviva",
  "uk-barclays": "uk-barclays",
  "uk-manypets": "uk-manypets",
  "uk-churchill": "uk-churchill",
  "uk-demo": "uk-demo",
  "uk-natwest": "uk-natwest",
  "uk-directline": "uk-directline",
  "uk-halifax": "uk-halifax",
  "uk-hastings-direct": "uk-hastings-direct",
  "uk-john-lewis-home": "uk-john-lewis-home",
  "uk-lv": "uk-lv",
  "uk-morethan-home": "uk-morethan-home",
  "uk-onecall": "uk-onecall",
  "uk-petplan": "uk-petplan",
  "uk-policyexpert-home": "uk-policyexpert-home",
  "uk-policyexpert-vehicle": "uk-policyexpert-vehicle",
  "uk-postoffice": "uk-postoffice",
  "uk-privilege": "uk-privilege",
  "uk-rac": "uk-rac",
  "uk-saga": "uk-saga",
  "uk-sainsburys": "uk-sainsburys",
  "uk-sainsburys-pet": "uk-sainsburys-pet",
  "uk-sheilaswheels": "uk-sheilaswheels",
  "uk-sosure": "uk-sosure",
  "uk-swinton": "uk-swinton",
  "uk-tesco": "uk-tesco",
  "uk-urbanjungle": "uk-urbanjungle",
  "uk-waggel": "uk-waggel",
  "ee-bta": "ee-bta",
  "ee-demo": "ee-demo",
  "ee-ergo": "ee-ergo",
  "ee-gjensidige": "ee-gjensidige",
  "ee-if": "ee-if",
  "ee-pzu": "ee-pzu",
  "ee-salva": "ee-salva",
  "ee-seesam": "ee-seesam",
  "ee-swedbank": "ee-swedbank",
  "ee-lhv": "ee-lhv",
  "es-mapfre": "es-mapfre",
  "es-demo": "es-demo",
  "fr-acheel": "fr-acheel",
  "fr-allianz": "fr-allianz",
  "fr-animauxsante": "fr-animauxsante",
  "fr-assur-opoil": "fr-assur-opoil",
  "fr-axa": "fr-axa",
  "fr-bulle-bleue": "fr-bulle-bleue",
  "fr-cardif": "fr-cardif",
  "fr-credit-agricole": "fr-credit-agricole",
  "fr-credit-mutuel": "fr-credit-mutuel",
  "fr-dalma": "fr-dalma",
  "fr-demo": "fr-demo",
  "fr-eca": "fr-eca",
  "fr-generali": "fr-generali",
  "fr-gmf": "fr-gmf",
  "fr-groupama": "fr-groupama",
  "fr-luko": "fr-luko",
  "fr-kozoo": "fr-kozoo",
  "fr-maaf": "fr-maaf",
  "fr-macif": "fr-macif",
  "fr-matmut": "fr-matmut",
  "fr-maif": "fr-maif",
  "fr-mma": "fr-mma",
  "fr-santevet": "fr-santevet",
  "fr-lolivier": "fr-lolivier",
  "fr-caisse-depargne": "fr-caisse-depargne",
  "fr-banque-populaire": "fr-banque-populaire",
  "fr-bred": "fr-bred",
  "fr-direct-assurance": "fr-direct-assurance",
  "lv-balta": "lv-balta",
  "lv-ban": "lv-ban",
  "lv-bta": "lv-bta",
  "lv-compensa": "lv-compensa",
  "lv-demo": "lv-demo",
  "lv-ergo": "lv-ergo",
  "lv-gjensidige": "lv-gjensidige",
  "lv-if": "lv-if",
  "lv-luminor": "lv-luminor",
  "lv-seb": "lv-seb",
  "lv-swedbank": "lv-swedbank",
  "lt-demo": "lt-demo",
  "lt-gjensidige": "lt-gjensidige",
  "xx-loadtest-scrape": "xx-loadtest-scrape",
  "xx-loadtest-api": "xx-loadtest-api",
  "xx-docs": "xx-docs"
};

// src/types/insurance-api/v4/types/InsuranceCottage.ts
var insuranceCottagePaymentMethod2 = {
  "UNDEFINED": "UNDEFINED",
  "AUTOGIRO": "AUTOGIRO",
  "PAPER_INVOICE": "PAPER_INVOICE",
  "ELECTRONIC_INVOICE": "ELECTRONIC_INVOICE",
  "GENERIC_INVOICE": "GENERIC_INVOICE",
  "ONE_TIME_PAYMENT": "ONE_TIME_PAYMENT",
  "EMPLOYER_PAID": "EMPLOYER_PAID",
  "CREDIT_CARD": "CREDIT_CARD"
};
var insuranceCottageInsuranceHolderGender2 = {
  "MALE": "MALE",
  "FEMALE": "FEMALE",
  "OTHER": "OTHER",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v4/types/InsuranceFarm.ts
var insuranceFarmPaymentMethod2 = {
  "UNDEFINED": "UNDEFINED",
  "AUTOGIRO": "AUTOGIRO",
  "PAPER_INVOICE": "PAPER_INVOICE",
  "ELECTRONIC_INVOICE": "ELECTRONIC_INVOICE",
  "GENERIC_INVOICE": "GENERIC_INVOICE",
  "ONE_TIME_PAYMENT": "ONE_TIME_PAYMENT",
  "EMPLOYER_PAID": "EMPLOYER_PAID",
  "CREDIT_CARD": "CREDIT_CARD"
};
var insuranceFarmInsuranceHolderGender2 = {
  "MALE": "MALE",
  "FEMALE": "FEMALE",
  "OTHER": "OTHER",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v4/types/InsuranceGeneral.ts
var insuranceGeneralPaymentMethod2 = {
  "UNDEFINED": "UNDEFINED",
  "AUTOGIRO": "AUTOGIRO",
  "PAPER_INVOICE": "PAPER_INVOICE",
  "ELECTRONIC_INVOICE": "ELECTRONIC_INVOICE",
  "GENERIC_INVOICE": "GENERIC_INVOICE",
  "ONE_TIME_PAYMENT": "ONE_TIME_PAYMENT",
  "EMPLOYER_PAID": "EMPLOYER_PAID",
  "CREDIT_CARD": "CREDIT_CARD"
};
var insuranceGeneralInsuranceHolderGender2 = {
  "MALE": "MALE",
  "FEMALE": "FEMALE",
  "OTHER": "OTHER",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v4/types/InsuranceHouseContent.ts
var insuranceHouseContentPaymentMethod2 = {
  "UNDEFINED": "UNDEFINED",
  "AUTOGIRO": "AUTOGIRO",
  "PAPER_INVOICE": "PAPER_INVOICE",
  "ELECTRONIC_INVOICE": "ELECTRONIC_INVOICE",
  "GENERIC_INVOICE": "GENERIC_INVOICE",
  "ONE_TIME_PAYMENT": "ONE_TIME_PAYMENT",
  "EMPLOYER_PAID": "EMPLOYER_PAID",
  "CREDIT_CARD": "CREDIT_CARD"
};
var insuranceHouseContentInsuranceHolderGender2 = {
  "MALE": "MALE",
  "FEMALE": "FEMALE",
  "OTHER": "OTHER",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v4/types/InsuranceIncome.ts
var insuranceIncomePaymentMethod2 = {
  "UNDEFINED": "UNDEFINED",
  "AUTOGIRO": "AUTOGIRO",
  "PAPER_INVOICE": "PAPER_INVOICE",
  "ELECTRONIC_INVOICE": "ELECTRONIC_INVOICE",
  "GENERIC_INVOICE": "GENERIC_INVOICE",
  "ONE_TIME_PAYMENT": "ONE_TIME_PAYMENT",
  "EMPLOYER_PAID": "EMPLOYER_PAID",
  "CREDIT_CARD": "CREDIT_CARD"
};
var insuranceIncomeInsuranceHolderGender2 = {
  "MALE": "MALE",
  "FEMALE": "FEMALE",
  "OTHER": "OTHER",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v4/types/InsuranceLife.ts
var insuranceLifePaymentMethod2 = {
  "UNDEFINED": "UNDEFINED",
  "AUTOGIRO": "AUTOGIRO",
  "PAPER_INVOICE": "PAPER_INVOICE",
  "ELECTRONIC_INVOICE": "ELECTRONIC_INVOICE",
  "GENERIC_INVOICE": "GENERIC_INVOICE",
  "ONE_TIME_PAYMENT": "ONE_TIME_PAYMENT",
  "EMPLOYER_PAID": "EMPLOYER_PAID",
  "CREDIT_CARD": "CREDIT_CARD"
};
var insuranceLifeInsuranceHolderGender2 = {
  "MALE": "MALE",
  "FEMALE": "FEMALE",
  "OTHER": "OTHER",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v4/types/InsuranceOtherVehicle.ts
var insuranceOtherVehiclePaymentMethod2 = {
  "UNDEFINED": "UNDEFINED",
  "AUTOGIRO": "AUTOGIRO",
  "PAPER_INVOICE": "PAPER_INVOICE",
  "ELECTRONIC_INVOICE": "ELECTRONIC_INVOICE",
  "GENERIC_INVOICE": "GENERIC_INVOICE",
  "ONE_TIME_PAYMENT": "ONE_TIME_PAYMENT",
  "EMPLOYER_PAID": "EMPLOYER_PAID",
  "CREDIT_CARD": "CREDIT_CARD"
};
var insuranceOtherVehicleInsuranceHolderGender2 = {
  "MALE": "MALE",
  "FEMALE": "FEMALE",
  "OTHER": "OTHER",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v4/types/InsurancePerson.ts
var insurancePersonPaymentMethod2 = {
  "UNDEFINED": "UNDEFINED",
  "AUTOGIRO": "AUTOGIRO",
  "PAPER_INVOICE": "PAPER_INVOICE",
  "ELECTRONIC_INVOICE": "ELECTRONIC_INVOICE",
  "GENERIC_INVOICE": "GENERIC_INVOICE",
  "ONE_TIME_PAYMENT": "ONE_TIME_PAYMENT",
  "EMPLOYER_PAID": "EMPLOYER_PAID",
  "CREDIT_CARD": "CREDIT_CARD"
};
var insurancePersonInsuranceHolderGender2 = {
  "MALE": "MALE",
  "FEMALE": "FEMALE",
  "OTHER": "OTHER",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v4/types/InsurancePregnancy.ts
var insurancePregnancyPaymentMethod2 = {
  "UNDEFINED": "UNDEFINED",
  "AUTOGIRO": "AUTOGIRO",
  "PAPER_INVOICE": "PAPER_INVOICE",
  "ELECTRONIC_INVOICE": "ELECTRONIC_INVOICE",
  "GENERIC_INVOICE": "GENERIC_INVOICE",
  "ONE_TIME_PAYMENT": "ONE_TIME_PAYMENT",
  "EMPLOYER_PAID": "EMPLOYER_PAID",
  "CREDIT_CARD": "CREDIT_CARD"
};
var insurancePregnancyInsuranceHolderGender2 = {
  "MALE": "MALE",
  "FEMALE": "FEMALE",
  "OTHER": "OTHER",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v4/types/InsuranceVehicle.ts
var insuranceVehiclePaymentMethod2 = {
  "UNDEFINED": "UNDEFINED",
  "AUTOGIRO": "AUTOGIRO",
  "PAPER_INVOICE": "PAPER_INVOICE",
  "ELECTRONIC_INVOICE": "ELECTRONIC_INVOICE",
  "GENERIC_INVOICE": "GENERIC_INVOICE",
  "ONE_TIME_PAYMENT": "ONE_TIME_PAYMENT",
  "EMPLOYER_PAID": "EMPLOYER_PAID",
  "CREDIT_CARD": "CREDIT_CARD"
};
var insuranceVehicleInsuranceHolderGender2 = {
  "MALE": "MALE",
  "FEMALE": "FEMALE",
  "OTHER": "OTHER",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v4/types/Market.ts
var market2 = {
  "dk": "dk",
  "ee": "ee",
  "lv": "lv",
  "lt": "lt",
  "fr": "fr",
  "no": "no",
  "se": "se",
  "uk": "uk",
  "es": "es",
  "core": "core"
};

// src/types/insurance-api/v4/types/MonetaryAmount.ts
var monetaryAmountCurrencyCode2 = {
  "DKK": "DKK",
  "EUR": "EUR",
  "GBP": "GBP",
  "NOK": "NOK",
  "SEK": "SEK"
};

// src/types/insurance-api/v4/types/Premium.ts
var premiumFrequency2 = {
  "YEARLY_PREMIUM_FREQUENCY": "YEARLY_PREMIUM_FREQUENCY",
  "UNKNOWN_PREMIUM_FREQUENCY": "UNKNOWN_PREMIUM_FREQUENCY"
};
var premiumTaxation2 = {
  "INCLUSIVE_TAXATION": "INCLUSIVE_TAXATION",
  "EXCLUSIVE_TAXATION": "EXCLUSIVE_TAXATION",
  "UNKNOWN_TAXATION": "UNKNOWN_TAXATION"
};

// src/types/insurance-api/v4/types/ResponseObject.ts
var responseObjectType = {
  "RESPONSE_OBJECT": "RESPONSE_OBJECT"
};

// src/types/insurance-api/v4/types/SupplementInformation.ts
var supplementInformationType = {
  "TWO_FACTOR_CODE": "TWO_FACTOR_CODE",
  "RESPONSE_OBJECT": "RESPONSE_OBJECT"
};

// src/types/insurance-api/v4/types/SwedishInsuranceHome.ts
var swedishInsuranceHomePaymentMethod2 = {
  "UNDEFINED": "UNDEFINED",
  "AUTOGIRO": "AUTOGIRO",
  "PAPER_INVOICE": "PAPER_INVOICE",
  "ELECTRONIC_INVOICE": "ELECTRONIC_INVOICE",
  "GENERIC_INVOICE": "GENERIC_INVOICE",
  "ONE_TIME_PAYMENT": "ONE_TIME_PAYMENT",
  "EMPLOYER_PAID": "EMPLOYER_PAID",
  "CREDIT_CARD": "CREDIT_CARD"
};
var swedishInsuranceHomeInsuranceHolderGender2 = {
  "MALE": "MALE",
  "FEMALE": "FEMALE",
  "OTHER": "OTHER",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v4/types/SwedishInsuranceVilla.ts
var swedishInsuranceVillaPaymentMethod2 = {
  "UNDEFINED": "UNDEFINED",
  "AUTOGIRO": "AUTOGIRO",
  "PAPER_INVOICE": "PAPER_INVOICE",
  "ELECTRONIC_INVOICE": "ELECTRONIC_INVOICE",
  "GENERIC_INVOICE": "GENERIC_INVOICE",
  "ONE_TIME_PAYMENT": "ONE_TIME_PAYMENT",
  "EMPLOYER_PAID": "EMPLOYER_PAID",
  "CREDIT_CARD": "CREDIT_CARD"
};
var swedishInsuranceVillaInsuranceHolderGender2 = {
  "MALE": "MALE",
  "FEMALE": "FEMALE",
  "OTHER": "OTHER",
  "UNKNOWN": "UNKNOWN"
};

// src/types/insurance-api/v4/types/TwoFactorAuthenticationInstruction.ts
var twoFactorAuthenticationInstructionResponseType = {
  "NUMBER_CODE": "NUMBER_CODE",
  "NO_RESPONSE": "NO_RESPONSE"
};

// src/types/insurance-api/v4/types/TwoFactorCode.ts
var twoFactorCodeType = {
  "TWO_FACTOR_CODE": "TWO_FACTOR_CODE"
};

// src/types/pension-api/pension-v2/index.ts
var pension_v2_exports = {};
__export(pension_v2_exports, {
  collectionRequestFilterRuleField: () => collectionRequestFilterRuleField3,
  collectionRequestV2LoginMethod: () => collectionRequestV2LoginMethod3,
  companyAvailabilityCompanyAndLineOfBusinesses: () => companyAvailabilityCompanyAndLineOfBusinesses3,
  companyAvailabilityLoginMethods: () => companyAvailabilityLoginMethods3,
  companyAvailabilityNonFunctionalLoginMethods: () => companyAvailabilityNonFunctionalLoginMethods3,
  companyAvailabilityReason: () => companyAvailabilityReason3,
  companyAvailabilityStatus: () => companyAvailabilityStatus3,
  companyLoginConfigPasswordFieldPlaceholder: () => companyLoginConfigPasswordFieldPlaceholder3,
  companyLoginConfigPasswordLabel: () => companyLoginConfigPasswordLabel3,
  companyLoginConfigUsernameFieldPlaceholder: () => companyLoginConfigUsernameFieldPlaceholder3,
  companyLoginConfigUsernameLabel: () => companyLoginConfigUsernameLabel3,
  consentRequestInputType: () => consentRequestInputType3,
  consentRequirementMethod: () => consentRequirementMethod3,
  consentRequirementType: () => consentRequirementType3,
  pensionDataPensionType: () => pensionDataPensionType
});

// src/types/pension-api/pension-v2/types/CollectionRequestFilterRule.ts
var collectionRequestFilterRuleField3 = {
  "registrationNo": "registrationNo"
};

// src/types/pension-api/pension-v2/types/CollectionRequestV2.ts
var collectionRequestV2LoginMethod3 = {
  "DANISH_NEMID": "DANISH_NEMID",
  "DANISH_MITID": "DANISH_MITID",
  "DANISH_MITID_SAME_DEVICE": "DANISH_MITID_SAME_DEVICE",
  "ESTONIAN_MOBILE_ID": "ESTONIAN_MOBILE_ID",
  "ESTONIAN_SMART_ID": "ESTONIAN_SMART_ID",
  "ESTONIAN_MOBILE_ID_USERNAME": "ESTONIAN_MOBILE_ID_USERNAME",
  "ESTONIAN_SMART_ID_USERNAME": "ESTONIAN_SMART_ID_USERNAME",
  "LATVIAN_MOBILE_EPARAKSTS": "LATVIAN_MOBILE_EPARAKSTS",
  "LATVIAN_SMART_ID": "LATVIAN_SMART_ID",
  "LATVIAN_MOBILE_EPARAKSTS_USERNAME": "LATVIAN_MOBILE_EPARAKSTS_USERNAME",
  "LATVIAN_SMART_ID_USERNAME": "LATVIAN_SMART_ID_USERNAME",
  "LITHUANIAN_SMART_ID": "LITHUANIAN_SMART_ID",
  "LITHUANIAN_MOBILE_ID": "LITHUANIAN_MOBILE_ID",
  "NORWEGIAN_BANKID_ON_MOBILE": "NORWEGIAN_BANKID_ON_MOBILE",
  "NORWEGIAN_BANKID_ON_MOBILE_FULL_PERSONAL_NUMBER": "NORWEGIAN_BANKID_ON_MOBILE_FULL_PERSONAL_NUMBER",
  "SWEDISH_MOBILE_BANKID_ANY_DEVICE": "SWEDISH_MOBILE_BANKID_ANY_DEVICE",
  "SWEDISH_MOBILE_BANKID_OTHER_DEVICE": "SWEDISH_MOBILE_BANKID_OTHER_DEVICE",
  "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_MOCK": "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_MOCK",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE": "SWEDISH_MOBILE_BANKID_SAME_DEVICE",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION": "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION_MOCK": "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION_MOCK",
  "SWEDISH_MOBILE_BANKID_ANY_DEVICE_TEST": "SWEDISH_MOBILE_BANKID_ANY_DEVICE_TEST",
  "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_TEST": "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_TEST",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE_TEST": "SWEDISH_MOBILE_BANKID_SAME_DEVICE_TEST",
  "SWEDISH_SECURITY_TOKEN": "SWEDISH_SECURITY_TOKEN",
  "UK_DOB_USERNAME_PASSWORD": "UK_DOB_USERNAME_PASSWORD",
  "UK_LASTNAME_MEMBERSHIP_NUMBER": "UK_LASTNAME_MEMBERSHIP_NUMBER",
  "UK_USERNAME_POSTCODE": "UK_USERNAME_POSTCODE",
  "USERNAME_AND_PASSWORD": "USERNAME_AND_PASSWORD",
  "EMAIL": "EMAIL",
  "PDF_UPLOAD": "PDF_UPLOAD"
};

// src/types/pension-api/pension-v2/types/CompanyAvailability.ts
var companyAvailabilityStatus3 = {
  "OK": "OK",
  "BETA": "BETA",
  "NOT_IMPLEMENTED": "NOT_IMPLEMENTED"
};
var companyAvailabilityReason3 = {
  "THIRD_PARTY_ERROR": "THIRD_PARTY_ERROR",
  "THIRD_PARTY_UPDATE": "THIRD_PARTY_UPDATE",
  "INSURELY_ERROR": "INSURELY_ERROR",
  "INSURELY_UPDATE": "INSURELY_UPDATE",
  "RECONSTRUCTION": "RECONSTRUCTION"
};
var companyAvailabilityLoginMethods3 = {
  "DANISH_NEMID": "DANISH_NEMID",
  "DANISH_MITID": "DANISH_MITID",
  "DANISH_MITID_SAME_DEVICE": "DANISH_MITID_SAME_DEVICE",
  "ESTONIAN_MOBILE_ID": "ESTONIAN_MOBILE_ID",
  "ESTONIAN_SMART_ID": "ESTONIAN_SMART_ID",
  "ESTONIAN_MOBILE_ID_USERNAME": "ESTONIAN_MOBILE_ID_USERNAME",
  "ESTONIAN_SMART_ID_USERNAME": "ESTONIAN_SMART_ID_USERNAME",
  "LATVIAN_MOBILE_EPARAKSTS": "LATVIAN_MOBILE_EPARAKSTS",
  "LATVIAN_SMART_ID": "LATVIAN_SMART_ID",
  "LATVIAN_MOBILE_EPARAKSTS_USERNAME": "LATVIAN_MOBILE_EPARAKSTS_USERNAME",
  "LATVIAN_SMART_ID_USERNAME": "LATVIAN_SMART_ID_USERNAME",
  "LITHUANIAN_SMART_ID": "LITHUANIAN_SMART_ID",
  "LITHUANIAN_MOBILE_ID": "LITHUANIAN_MOBILE_ID",
  "NORWEGIAN_BANKID_ON_MOBILE": "NORWEGIAN_BANKID_ON_MOBILE",
  "NORWEGIAN_BANKID_ON_MOBILE_FULL_PERSONAL_NUMBER": "NORWEGIAN_BANKID_ON_MOBILE_FULL_PERSONAL_NUMBER",
  "SWEDISH_MOBILE_BANKID_ANY_DEVICE": "SWEDISH_MOBILE_BANKID_ANY_DEVICE",
  "SWEDISH_MOBILE_BANKID_OTHER_DEVICE": "SWEDISH_MOBILE_BANKID_OTHER_DEVICE",
  "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_MOCK": "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_MOCK",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE": "SWEDISH_MOBILE_BANKID_SAME_DEVICE",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION": "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION_MOCK": "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION_MOCK",
  "SWEDISH_MOBILE_BANKID_ANY_DEVICE_TEST": "SWEDISH_MOBILE_BANKID_ANY_DEVICE_TEST",
  "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_TEST": "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_TEST",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE_TEST": "SWEDISH_MOBILE_BANKID_SAME_DEVICE_TEST",
  "SWEDISH_SECURITY_TOKEN": "SWEDISH_SECURITY_TOKEN",
  "UK_DOB_USERNAME_PASSWORD": "UK_DOB_USERNAME_PASSWORD",
  "UK_LASTNAME_MEMBERSHIP_NUMBER": "UK_LASTNAME_MEMBERSHIP_NUMBER",
  "UK_USERNAME_POSTCODE": "UK_USERNAME_POSTCODE",
  "USERNAME_AND_PASSWORD": "USERNAME_AND_PASSWORD",
  "EMAIL": "EMAIL",
  "PDF_UPLOAD": "PDF_UPLOAD"
};
var companyAvailabilityNonFunctionalLoginMethods3 = {
  "DANISH_NEMID": "DANISH_NEMID",
  "DANISH_MITID": "DANISH_MITID",
  "DANISH_MITID_SAME_DEVICE": "DANISH_MITID_SAME_DEVICE",
  "ESTONIAN_MOBILE_ID": "ESTONIAN_MOBILE_ID",
  "ESTONIAN_SMART_ID": "ESTONIAN_SMART_ID",
  "ESTONIAN_MOBILE_ID_USERNAME": "ESTONIAN_MOBILE_ID_USERNAME",
  "ESTONIAN_SMART_ID_USERNAME": "ESTONIAN_SMART_ID_USERNAME",
  "LATVIAN_MOBILE_EPARAKSTS": "LATVIAN_MOBILE_EPARAKSTS",
  "LATVIAN_SMART_ID": "LATVIAN_SMART_ID",
  "LATVIAN_MOBILE_EPARAKSTS_USERNAME": "LATVIAN_MOBILE_EPARAKSTS_USERNAME",
  "LATVIAN_SMART_ID_USERNAME": "LATVIAN_SMART_ID_USERNAME",
  "LITHUANIAN_SMART_ID": "LITHUANIAN_SMART_ID",
  "LITHUANIAN_MOBILE_ID": "LITHUANIAN_MOBILE_ID",
  "NORWEGIAN_BANKID_ON_MOBILE": "NORWEGIAN_BANKID_ON_MOBILE",
  "NORWEGIAN_BANKID_ON_MOBILE_FULL_PERSONAL_NUMBER": "NORWEGIAN_BANKID_ON_MOBILE_FULL_PERSONAL_NUMBER",
  "SWEDISH_MOBILE_BANKID_ANY_DEVICE": "SWEDISH_MOBILE_BANKID_ANY_DEVICE",
  "SWEDISH_MOBILE_BANKID_OTHER_DEVICE": "SWEDISH_MOBILE_BANKID_OTHER_DEVICE",
  "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_MOCK": "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_MOCK",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE": "SWEDISH_MOBILE_BANKID_SAME_DEVICE",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION": "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION_MOCK": "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION_MOCK",
  "SWEDISH_MOBILE_BANKID_ANY_DEVICE_TEST": "SWEDISH_MOBILE_BANKID_ANY_DEVICE_TEST",
  "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_TEST": "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_TEST",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE_TEST": "SWEDISH_MOBILE_BANKID_SAME_DEVICE_TEST",
  "SWEDISH_SECURITY_TOKEN": "SWEDISH_SECURITY_TOKEN",
  "UK_DOB_USERNAME_PASSWORD": "UK_DOB_USERNAME_PASSWORD",
  "UK_LASTNAME_MEMBERSHIP_NUMBER": "UK_LASTNAME_MEMBERSHIP_NUMBER",
  "UK_USERNAME_POSTCODE": "UK_USERNAME_POSTCODE",
  "USERNAME_AND_PASSWORD": "USERNAME_AND_PASSWORD",
  "EMAIL": "EMAIL",
  "PDF_UPLOAD": "PDF_UPLOAD"
};
var companyAvailabilityCompanyAndLineOfBusinesses3 = {
  "EE_SWEDBANK": "EE_SWEDBANK",
  "FR_ALLIANZ_HOME": "FR_ALLIANZ_HOME",
  "FR_ALLIANZ_VEHICLE": "FR_ALLIANZ_VEHICLE",
  "FR_ANIMAUXSANTE_HOME": "FR_ANIMAUXSANTE_HOME",
  "FR_ASSUR_OPOIL_ANIMAL": "FR_ASSUR_OPOIL_ANIMAL",
  "FR_AXA_HOME": "FR_AXA_HOME",
  "FR_AXA_VEHICLE": "FR_AXA_VEHICLE",
  "FR_AXA_GENERAL": "FR_AXA_GENERAL",
  "FR_BANQUE_POPULAIRE_HOME": "FR_BANQUE_POPULAIRE_HOME",
  "FR_BULLE_BLEUE_HOME": "FR_BULLE_BLEUE_HOME",
  "FR_CAISSE_DEPARGNE_HOME": "FR_CAISSE_DEPARGNE_HOME",
  "FR_CARDIF_HOME": "FR_CARDIF_HOME",
  "FR_CREDIT_AGRICOLE_HOME": "FR_CREDIT_AGRICOLE_HOME",
  "FR_CREDIT_AGRICOLE_VEHICLE": "FR_CREDIT_AGRICOLE_VEHICLE",
  "FR_CREDIT_MUTUEL_HOME": "FR_CREDIT_MUTUEL_HOME",
  "FR_CREDIT_MUTUEL_VEHICLE": "FR_CREDIT_MUTUEL_VEHICLE",
  "FR_DEMO_HOME": "FR_DEMO_HOME",
  "FR_DEMO_VEHICLE": "FR_DEMO_VEHICLE",
  "FR_DIRECT_ASSURANCE_HOME": "FR_DIRECT_ASSURANCE_HOME",
  "FR_DIRECT_ASSURANCE_VEHICLE": "FR_DIRECT_ASSURANCE_VEHICLE",
  "FR_ECA_HOME": "FR_ECA_HOME",
  "FR_ECA_ANIMAL": "FR_ECA_ANIMAL",
  "FR_GENERALI_HOME": "FR_GENERALI_HOME",
  "FR_GENERALI_VEHICLE": "FR_GENERALI_VEHICLE",
  "FR_GMF_HOME": "FR_GMF_HOME",
  "FR_GMF_VEHICLE": "FR_GMF_VEHICLE",
  "FR_GROUPAMA_HOME": "FR_GROUPAMA_HOME",
  "FR_GROUPAMA_VEHICLE": "FR_GROUPAMA_VEHICLE",
  "FR_LUKO_HOME": "FR_LUKO_HOME",
  "FR_MAAF_HOME": "FR_MAAF_HOME",
  "FR_MAAF_VEHICLE": "FR_MAAF_VEHICLE",
  "FR_MACIF_HOME": "FR_MACIF_HOME",
  "FR_MACIF_VEHICLE": "FR_MACIF_VEHICLE",
  "FR_MAIF_HOME": "FR_MAIF_HOME",
  "FR_MAIF_VEHICLE": "FR_MAIF_VEHICLE",
  "FR_MATMUT_HOME": "FR_MATMUT_HOME",
  "FR_MMA_HOME": "FR_MMA_HOME",
  "FR_MMA_VEHICLE": "FR_MMA_VEHICLE",
  "FR_SANTEVET_HOME": "FR_SANTEVET_HOME",
  "SE_IF_VEHICLE": "SE_IF_VEHICLE",
  "SE_FOLKSAM_VEHICLE": "SE_FOLKSAM_VEHICLE",
  "SE_LANSFORSAKRINGAR_HOME": "SE_LANSFORSAKRINGAR_HOME",
  "SE_PAYDRIVE_VEHICLE": "SE_PAYDRIVE_VEHICLE",
  "SE_SVEDEA_VEHICLE": "SE_SVEDEA_VEHICLE",
  "SE_VOLVIA_VEHICLE": "SE_VOLVIA_VEHICLE",
  "SE_BLIWA_ACCIDENT": "SE_BLIWA_ACCIDENT",
  "UK_AXA_HOME": "UK_AXA_HOME",
  "UK_AXA_VEHICLE": "UK_AXA_VEHICLE",
  "UK_HASTINGS_DIRECT_HOME": "UK_HASTINGS_DIRECT_HOME",
  "UK_HASTINGS_DIRECT_VEHICLE": "UK_HASTINGS_DIRECT_VEHICLE",
  "UK_POLICYEXPERT_HOME": "UK_POLICYEXPERT_HOME",
  "UK_POLICYEXPERT_VEHICLE": "UK_POLICYEXPERT_VEHICLE",
  "UK_POST_OFFICE_HOME": "UK_POST_OFFICE_HOME",
  "UK_THE_AA_HOME": "UK_THE_AA_HOME",
  "UK_THE_AA_VEHICLE": "UK_THE_AA_VEHICLE",
  "UK_URBAN_JUNGLE_HOME": "UK_URBAN_JUNGLE_HOME",
  "FR_AXA_PERSON": "FR_AXA_PERSON",
  "FR_ACHEEL_HOME": "FR_ACHEEL_HOME"
};

// src/types/pension-api/pension-v2/types/CompanyLoginConfig.ts
var companyLoginConfigUsernameLabel3 = {
  "EMAIL": "EMAIL",
  "USERNAME": "USERNAME"
};
var companyLoginConfigUsernameFieldPlaceholder3 = {
  "EMAIL": "EMAIL",
  "IDENTIFICATION_NUMBER_11": "IDENTIFICATION_NUMBER_11",
  "IDENTIFICATION_CHARACTERS_8": "IDENTIFICATION_CHARACTERS_8",
  "EMAIL_MOBILE_MUTUAL_MEMBER": "EMAIL_MOBILE_MUTUAL_MEMBER",
  "EMAIL_MOBILE_CLIENT": "EMAIL_MOBILE_CLIENT",
  "EMAIL_MUTUAL_OR_REGULAR_MEMBER": "EMAIL_MUTUAL_OR_REGULAR_MEMBER",
  "EMAIL_MOBILE_CONTRACT": "EMAIL_MOBILE_CONTRACT",
  "EMAIL_OR_MEMBER": "EMAIL_OR_MEMBER"
};
var companyLoginConfigPasswordLabel3 = {
  "PASSWORD": "PASSWORD",
  "CONFIDENTIAL_CODE": "CONFIDENTIAL_CODE",
  "PERSONAL_CODE": "PERSONAL_CODE"
};
var companyLoginConfigPasswordFieldPlaceholder3 = {
  "PASSWORD": "PASSWORD",
  "CONFIDENTIAL_CODE": "CONFIDENTIAL_CODE",
  "PERSONAL_CODE": "PERSONAL_CODE"
};

// src/types/pension-api/pension-v2/types/ConsentRequestInput.ts
var consentRequestInputType3 = {
  "TRADE_UNION_MEMBERSHIP": "TRADE_UNION_MEMBERSHIP"
};

// src/types/pension-api/pension-v2/types/ConsentRequirement.ts
var consentRequirementType3 = {
  "TRADE_UNION_MEMBERSHIP": "TRADE_UNION_MEMBERSHIP"
};
var consentRequirementMethod3 = {
  "NONE": "NONE",
  "NOTICE": "NOTICE",
  "ACTIVE": "ACTIVE"
};

// src/types/pension-api/pension-v2/types/PensionData.ts
var pensionDataPensionType = {
  "IPS_PENSION": "IPS_PENSION",
  "PRIVATE_PENSION": "PRIVATE_PENSION",
  "OCCUPATIONAL_PENSION": "OCCUPATIONAL_PENSION",
  "COLLECTIVE_OCCUPATIONAL_PENSION": "COLLECTIVE_OCCUPATIONAL_PENSION",
  "CAPITAL_INSURANCE": "CAPITAL_INSURANCE",
  "UNKNOWN_PENSION_TYPE": "UNKNOWN_PENSION_TYPE"
};

// src/types/pension-api/pension-v3/index.ts
var pension_v3_exports = {};
__export(pension_v3_exports, {
  agePeriodType: () => agePeriodType,
  collection1CollectInfoHeaderParamsInsurelyVersion: () => collection1CollectInfoHeaderParamsInsurelyVersion3,
  collection2StatusHeaderParamsInsurelyVersion: () => collection2StatusHeaderParamsInsurelyVersion3,
  collection3GetDataHeaderParamsInsurelyVersion: () => collection3GetDataHeaderParamsInsurelyVersion3,
  collection3SupplementInformationHeaderParamsInsurelyVersion: () => collection3SupplementInformationHeaderParamsInsurelyVersion3,
  collection4AddContactFormInputHeaderParamsInsurelyVersion: () => collection4AddContactFormInputHeaderParamsInsurelyVersion,
  collectionItemStatus: () => collectionItemStatus2,
  collectionRequestFilterRuleField: () => collectionRequestFilterRuleField4,
  collectionRequestV2LoginMethod: () => collectionRequestV2LoginMethod4,
  collectionStatusInformationMapRequiredInputTypes: () => collectionStatusInformationMapRequiredInputTypes2,
  companyAvailabilityCompanyAndLineOfBusinesses: () => companyAvailabilityCompanyAndLineOfBusinesses4,
  companyAvailabilityLoginMethods: () => companyAvailabilityLoginMethods4,
  companyAvailabilityNonFunctionalLoginMethods: () => companyAvailabilityNonFunctionalLoginMethods4,
  companyAvailabilityReason: () => companyAvailabilityReason4,
  companyAvailabilityStatus: () => companyAvailabilityStatus4,
  companyLoginConfigPasswordFieldPlaceholder: () => companyLoginConfigPasswordFieldPlaceholder4,
  companyLoginConfigPasswordLabel: () => companyLoginConfigPasswordLabel4,
  companyLoginConfigUsernameFieldPlaceholder: () => companyLoginConfigUsernameFieldPlaceholder4,
  companyLoginConfigUsernameLabel: () => companyLoginConfigUsernameLabel4,
  consentRequestInputType: () => consentRequestInputType4,
  consentRequirementMethod: () => consentRequirementMethod4,
  consentRequirementType: () => consentRequirementType4,
  contactFormInputInputType: () => contactFormInputInputType,
  datePeriodType: () => datePeriodType,
  getCompaniesStatusHeaderParamsInsurelyVersion: () => getCompaniesStatusHeaderParamsInsurelyVersion3,
  monetaryAmountCurrencyCode: () => monetaryAmountCurrencyCode3,
  movabilityResultResult: () => movabilityResultResult,
  movabilityRuleResultResult: () => movabilityRuleResultResult,
  movabilityRuleResultRule: () => movabilityRuleResultRule,
  payoutPeriodType: () => payoutPeriodType,
  pensionDataPensionClassification: () => pensionDataPensionClassification,
  pensionDataPensionType: () => pensionDataPensionType2,
  responseObjectType: () => responseObjectType2,
  supplementInformationType: () => supplementInformationType2,
  twoFactorAuthenticationInstructionResponseType: () => twoFactorAuthenticationInstructionResponseType2,
  twoFactorCodeType: () => twoFactorCodeType2
});

// src/types/pension-api/pension-v3/types/AgePeriod.ts
var agePeriodType = {
  "AGE_RANGE": "AGE_RANGE"
};

// src/types/pension-api/pension-v3/types/Collection1CollectInfo.ts
var collection1CollectInfoHeaderParamsInsurelyVersion3 = {
  "2022-09-26": "2022-09-26"
};

// src/types/pension-api/pension-v3/types/Collection2Status.ts
var collection2StatusHeaderParamsInsurelyVersion3 = {
  "2022-09-26": "2022-09-26"
};

// src/types/pension-api/pension-v3/types/Collection3GetData.ts
var collection3GetDataHeaderParamsInsurelyVersion3 = {
  "2022-09-26": "2022-09-26"
};

// src/types/pension-api/pension-v3/types/Collection3SupplementInformation.ts
var collection3SupplementInformationHeaderParamsInsurelyVersion3 = {
  "2022-09-26": "2022-09-26"
};

// src/types/pension-api/pension-v3/types/Collection4AddContactFormInput.ts
var collection4AddContactFormInputHeaderParamsInsurelyVersion = {
  "2022-09-26": "2022-09-26"
};

// src/types/pension-api/pension-v3/types/CollectionItem.ts
var collectionItemStatus2 = {
  "NOT_STARTED": "NOT_STARTED",
  "COMPLETED": "COMPLETED",
  "COLLECTING": "COLLECTING",
  "FAILED": "FAILED",
  "NOT_COLLECTED": "NOT_COLLECTED"
};

// src/types/pension-api/pension-v3/types/CollectionRequestFilterRule.ts
var collectionRequestFilterRuleField4 = {
  "registrationNo": "registrationNo"
};

// src/types/pension-api/pension-v3/types/CollectionRequestV2.ts
var collectionRequestV2LoginMethod4 = {
  "DANISH_NEMID": "DANISH_NEMID",
  "DANISH_MITID": "DANISH_MITID",
  "DANISH_MITID_SAME_DEVICE": "DANISH_MITID_SAME_DEVICE",
  "ESTONIAN_MOBILE_ID": "ESTONIAN_MOBILE_ID",
  "ESTONIAN_SMART_ID": "ESTONIAN_SMART_ID",
  "ESTONIAN_MOBILE_ID_USERNAME": "ESTONIAN_MOBILE_ID_USERNAME",
  "ESTONIAN_SMART_ID_USERNAME": "ESTONIAN_SMART_ID_USERNAME",
  "LATVIAN_MOBILE_EPARAKSTS": "LATVIAN_MOBILE_EPARAKSTS",
  "LATVIAN_SMART_ID": "LATVIAN_SMART_ID",
  "LATVIAN_MOBILE_EPARAKSTS_USERNAME": "LATVIAN_MOBILE_EPARAKSTS_USERNAME",
  "LATVIAN_SMART_ID_USERNAME": "LATVIAN_SMART_ID_USERNAME",
  "LITHUANIAN_SMART_ID": "LITHUANIAN_SMART_ID",
  "LITHUANIAN_MOBILE_ID": "LITHUANIAN_MOBILE_ID",
  "NORWEGIAN_BANKID_ON_MOBILE": "NORWEGIAN_BANKID_ON_MOBILE",
  "NORWEGIAN_BANKID_ON_MOBILE_FULL_PERSONAL_NUMBER": "NORWEGIAN_BANKID_ON_MOBILE_FULL_PERSONAL_NUMBER",
  "SWEDISH_MOBILE_BANKID_ANY_DEVICE": "SWEDISH_MOBILE_BANKID_ANY_DEVICE",
  "SWEDISH_MOBILE_BANKID_OTHER_DEVICE": "SWEDISH_MOBILE_BANKID_OTHER_DEVICE",
  "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_MOCK": "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_MOCK",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE": "SWEDISH_MOBILE_BANKID_SAME_DEVICE",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION": "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION_MOCK": "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION_MOCK",
  "SWEDISH_MOBILE_BANKID_ANY_DEVICE_TEST": "SWEDISH_MOBILE_BANKID_ANY_DEVICE_TEST",
  "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_TEST": "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_TEST",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE_TEST": "SWEDISH_MOBILE_BANKID_SAME_DEVICE_TEST",
  "SWEDISH_SECURITY_TOKEN": "SWEDISH_SECURITY_TOKEN",
  "UK_DOB_USERNAME_PASSWORD": "UK_DOB_USERNAME_PASSWORD",
  "UK_LASTNAME_MEMBERSHIP_NUMBER": "UK_LASTNAME_MEMBERSHIP_NUMBER",
  "UK_USERNAME_POSTCODE": "UK_USERNAME_POSTCODE",
  "USERNAME_AND_PASSWORD": "USERNAME_AND_PASSWORD",
  "EMAIL": "EMAIL",
  "PDF_UPLOAD": "PDF_UPLOAD"
};

// src/types/pension-api/pension-v3/types/CollectionStatusInformationMap.ts
var collectionStatusInformationMapRequiredInputTypes2 = {
  "EMAIL": "EMAIL",
  "MOBILE_PHONE_NUMBER": "MOBILE_PHONE_NUMBER"
};

// src/types/pension-api/pension-v3/types/CompanyAvailability.ts
var companyAvailabilityStatus4 = {
  "OK": "OK",
  "BETA": "BETA",
  "NOT_IMPLEMENTED": "NOT_IMPLEMENTED"
};
var companyAvailabilityReason4 = {
  "THIRD_PARTY_ERROR": "THIRD_PARTY_ERROR",
  "THIRD_PARTY_UPDATE": "THIRD_PARTY_UPDATE",
  "INSURELY_ERROR": "INSURELY_ERROR",
  "INSURELY_UPDATE": "INSURELY_UPDATE",
  "RECONSTRUCTION": "RECONSTRUCTION"
};
var companyAvailabilityLoginMethods4 = {
  "DANISH_NEMID": "DANISH_NEMID",
  "DANISH_MITID": "DANISH_MITID",
  "DANISH_MITID_SAME_DEVICE": "DANISH_MITID_SAME_DEVICE",
  "ESTONIAN_MOBILE_ID": "ESTONIAN_MOBILE_ID",
  "ESTONIAN_SMART_ID": "ESTONIAN_SMART_ID",
  "ESTONIAN_MOBILE_ID_USERNAME": "ESTONIAN_MOBILE_ID_USERNAME",
  "ESTONIAN_SMART_ID_USERNAME": "ESTONIAN_SMART_ID_USERNAME",
  "LATVIAN_MOBILE_EPARAKSTS": "LATVIAN_MOBILE_EPARAKSTS",
  "LATVIAN_SMART_ID": "LATVIAN_SMART_ID",
  "LATVIAN_MOBILE_EPARAKSTS_USERNAME": "LATVIAN_MOBILE_EPARAKSTS_USERNAME",
  "LATVIAN_SMART_ID_USERNAME": "LATVIAN_SMART_ID_USERNAME",
  "LITHUANIAN_SMART_ID": "LITHUANIAN_SMART_ID",
  "LITHUANIAN_MOBILE_ID": "LITHUANIAN_MOBILE_ID",
  "NORWEGIAN_BANKID_ON_MOBILE": "NORWEGIAN_BANKID_ON_MOBILE",
  "NORWEGIAN_BANKID_ON_MOBILE_FULL_PERSONAL_NUMBER": "NORWEGIAN_BANKID_ON_MOBILE_FULL_PERSONAL_NUMBER",
  "SWEDISH_MOBILE_BANKID_ANY_DEVICE": "SWEDISH_MOBILE_BANKID_ANY_DEVICE",
  "SWEDISH_MOBILE_BANKID_OTHER_DEVICE": "SWEDISH_MOBILE_BANKID_OTHER_DEVICE",
  "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_MOCK": "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_MOCK",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE": "SWEDISH_MOBILE_BANKID_SAME_DEVICE",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION": "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION_MOCK": "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION_MOCK",
  "SWEDISH_MOBILE_BANKID_ANY_DEVICE_TEST": "SWEDISH_MOBILE_BANKID_ANY_DEVICE_TEST",
  "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_TEST": "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_TEST",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE_TEST": "SWEDISH_MOBILE_BANKID_SAME_DEVICE_TEST",
  "SWEDISH_SECURITY_TOKEN": "SWEDISH_SECURITY_TOKEN",
  "UK_DOB_USERNAME_PASSWORD": "UK_DOB_USERNAME_PASSWORD",
  "UK_LASTNAME_MEMBERSHIP_NUMBER": "UK_LASTNAME_MEMBERSHIP_NUMBER",
  "UK_USERNAME_POSTCODE": "UK_USERNAME_POSTCODE",
  "USERNAME_AND_PASSWORD": "USERNAME_AND_PASSWORD",
  "EMAIL": "EMAIL",
  "PDF_UPLOAD": "PDF_UPLOAD"
};
var companyAvailabilityNonFunctionalLoginMethods4 = {
  "DANISH_NEMID": "DANISH_NEMID",
  "DANISH_MITID": "DANISH_MITID",
  "DANISH_MITID_SAME_DEVICE": "DANISH_MITID_SAME_DEVICE",
  "ESTONIAN_MOBILE_ID": "ESTONIAN_MOBILE_ID",
  "ESTONIAN_SMART_ID": "ESTONIAN_SMART_ID",
  "ESTONIAN_MOBILE_ID_USERNAME": "ESTONIAN_MOBILE_ID_USERNAME",
  "ESTONIAN_SMART_ID_USERNAME": "ESTONIAN_SMART_ID_USERNAME",
  "LATVIAN_MOBILE_EPARAKSTS": "LATVIAN_MOBILE_EPARAKSTS",
  "LATVIAN_SMART_ID": "LATVIAN_SMART_ID",
  "LATVIAN_MOBILE_EPARAKSTS_USERNAME": "LATVIAN_MOBILE_EPARAKSTS_USERNAME",
  "LATVIAN_SMART_ID_USERNAME": "LATVIAN_SMART_ID_USERNAME",
  "LITHUANIAN_SMART_ID": "LITHUANIAN_SMART_ID",
  "LITHUANIAN_MOBILE_ID": "LITHUANIAN_MOBILE_ID",
  "NORWEGIAN_BANKID_ON_MOBILE": "NORWEGIAN_BANKID_ON_MOBILE",
  "NORWEGIAN_BANKID_ON_MOBILE_FULL_PERSONAL_NUMBER": "NORWEGIAN_BANKID_ON_MOBILE_FULL_PERSONAL_NUMBER",
  "SWEDISH_MOBILE_BANKID_ANY_DEVICE": "SWEDISH_MOBILE_BANKID_ANY_DEVICE",
  "SWEDISH_MOBILE_BANKID_OTHER_DEVICE": "SWEDISH_MOBILE_BANKID_OTHER_DEVICE",
  "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_MOCK": "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_MOCK",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE": "SWEDISH_MOBILE_BANKID_SAME_DEVICE",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION": "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION_MOCK": "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION_MOCK",
  "SWEDISH_MOBILE_BANKID_ANY_DEVICE_TEST": "SWEDISH_MOBILE_BANKID_ANY_DEVICE_TEST",
  "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_TEST": "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_TEST",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE_TEST": "SWEDISH_MOBILE_BANKID_SAME_DEVICE_TEST",
  "SWEDISH_SECURITY_TOKEN": "SWEDISH_SECURITY_TOKEN",
  "UK_DOB_USERNAME_PASSWORD": "UK_DOB_USERNAME_PASSWORD",
  "UK_LASTNAME_MEMBERSHIP_NUMBER": "UK_LASTNAME_MEMBERSHIP_NUMBER",
  "UK_USERNAME_POSTCODE": "UK_USERNAME_POSTCODE",
  "USERNAME_AND_PASSWORD": "USERNAME_AND_PASSWORD",
  "EMAIL": "EMAIL",
  "PDF_UPLOAD": "PDF_UPLOAD"
};
var companyAvailabilityCompanyAndLineOfBusinesses4 = {
  "EE_SWEDBANK": "EE_SWEDBANK",
  "FR_ALLIANZ_HOME": "FR_ALLIANZ_HOME",
  "FR_ALLIANZ_VEHICLE": "FR_ALLIANZ_VEHICLE",
  "FR_ANIMAUXSANTE_HOME": "FR_ANIMAUXSANTE_HOME",
  "FR_ASSUR_OPOIL_ANIMAL": "FR_ASSUR_OPOIL_ANIMAL",
  "FR_AXA_HOME": "FR_AXA_HOME",
  "FR_AXA_VEHICLE": "FR_AXA_VEHICLE",
  "FR_AXA_GENERAL": "FR_AXA_GENERAL",
  "FR_BANQUE_POPULAIRE_HOME": "FR_BANQUE_POPULAIRE_HOME",
  "FR_BULLE_BLEUE_HOME": "FR_BULLE_BLEUE_HOME",
  "FR_CAISSE_DEPARGNE_HOME": "FR_CAISSE_DEPARGNE_HOME",
  "FR_CARDIF_HOME": "FR_CARDIF_HOME",
  "FR_CREDIT_AGRICOLE_HOME": "FR_CREDIT_AGRICOLE_HOME",
  "FR_CREDIT_AGRICOLE_VEHICLE": "FR_CREDIT_AGRICOLE_VEHICLE",
  "FR_CREDIT_MUTUEL_HOME": "FR_CREDIT_MUTUEL_HOME",
  "FR_CREDIT_MUTUEL_VEHICLE": "FR_CREDIT_MUTUEL_VEHICLE",
  "FR_DEMO_HOME": "FR_DEMO_HOME",
  "FR_DEMO_VEHICLE": "FR_DEMO_VEHICLE",
  "FR_DIRECT_ASSURANCE_HOME": "FR_DIRECT_ASSURANCE_HOME",
  "FR_DIRECT_ASSURANCE_VEHICLE": "FR_DIRECT_ASSURANCE_VEHICLE",
  "FR_ECA_HOME": "FR_ECA_HOME",
  "FR_ECA_ANIMAL": "FR_ECA_ANIMAL",
  "FR_GENERALI_HOME": "FR_GENERALI_HOME",
  "FR_GENERALI_VEHICLE": "FR_GENERALI_VEHICLE",
  "FR_GMF_HOME": "FR_GMF_HOME",
  "FR_GMF_VEHICLE": "FR_GMF_VEHICLE",
  "FR_GROUPAMA_HOME": "FR_GROUPAMA_HOME",
  "FR_GROUPAMA_VEHICLE": "FR_GROUPAMA_VEHICLE",
  "FR_LUKO_HOME": "FR_LUKO_HOME",
  "FR_MAAF_HOME": "FR_MAAF_HOME",
  "FR_MAAF_VEHICLE": "FR_MAAF_VEHICLE",
  "FR_MACIF_HOME": "FR_MACIF_HOME",
  "FR_MACIF_VEHICLE": "FR_MACIF_VEHICLE",
  "FR_MAIF_HOME": "FR_MAIF_HOME",
  "FR_MAIF_VEHICLE": "FR_MAIF_VEHICLE",
  "FR_MATMUT_HOME": "FR_MATMUT_HOME",
  "FR_MMA_HOME": "FR_MMA_HOME",
  "FR_MMA_VEHICLE": "FR_MMA_VEHICLE",
  "FR_SANTEVET_HOME": "FR_SANTEVET_HOME",
  "SE_IF_VEHICLE": "SE_IF_VEHICLE",
  "SE_FOLKSAM_VEHICLE": "SE_FOLKSAM_VEHICLE",
  "SE_LANSFORSAKRINGAR_HOME": "SE_LANSFORSAKRINGAR_HOME",
  "SE_PAYDRIVE_VEHICLE": "SE_PAYDRIVE_VEHICLE",
  "SE_SVEDEA_VEHICLE": "SE_SVEDEA_VEHICLE",
  "SE_VOLVIA_VEHICLE": "SE_VOLVIA_VEHICLE",
  "SE_BLIWA_ACCIDENT": "SE_BLIWA_ACCIDENT",
  "UK_AXA_HOME": "UK_AXA_HOME",
  "UK_AXA_VEHICLE": "UK_AXA_VEHICLE",
  "UK_HASTINGS_DIRECT_HOME": "UK_HASTINGS_DIRECT_HOME",
  "UK_HASTINGS_DIRECT_VEHICLE": "UK_HASTINGS_DIRECT_VEHICLE",
  "UK_POLICYEXPERT_HOME": "UK_POLICYEXPERT_HOME",
  "UK_POLICYEXPERT_VEHICLE": "UK_POLICYEXPERT_VEHICLE",
  "UK_POST_OFFICE_HOME": "UK_POST_OFFICE_HOME",
  "UK_THE_AA_HOME": "UK_THE_AA_HOME",
  "UK_THE_AA_VEHICLE": "UK_THE_AA_VEHICLE",
  "UK_URBAN_JUNGLE_HOME": "UK_URBAN_JUNGLE_HOME",
  "FR_AXA_PERSON": "FR_AXA_PERSON",
  "FR_ACHEEL_HOME": "FR_ACHEEL_HOME"
};

// src/types/pension-api/pension-v3/types/CompanyLoginConfig.ts
var companyLoginConfigUsernameLabel4 = {
  "EMAIL": "EMAIL",
  "USERNAME": "USERNAME"
};
var companyLoginConfigUsernameFieldPlaceholder4 = {
  "EMAIL": "EMAIL",
  "IDENTIFICATION_NUMBER_11": "IDENTIFICATION_NUMBER_11",
  "IDENTIFICATION_CHARACTERS_8": "IDENTIFICATION_CHARACTERS_8",
  "EMAIL_MOBILE_MUTUAL_MEMBER": "EMAIL_MOBILE_MUTUAL_MEMBER",
  "EMAIL_MOBILE_CLIENT": "EMAIL_MOBILE_CLIENT",
  "EMAIL_MUTUAL_OR_REGULAR_MEMBER": "EMAIL_MUTUAL_OR_REGULAR_MEMBER",
  "EMAIL_MOBILE_CONTRACT": "EMAIL_MOBILE_CONTRACT",
  "EMAIL_OR_MEMBER": "EMAIL_OR_MEMBER"
};
var companyLoginConfigPasswordLabel4 = {
  "PASSWORD": "PASSWORD",
  "CONFIDENTIAL_CODE": "CONFIDENTIAL_CODE",
  "PERSONAL_CODE": "PERSONAL_CODE"
};
var companyLoginConfigPasswordFieldPlaceholder4 = {
  "PASSWORD": "PASSWORD",
  "CONFIDENTIAL_CODE": "CONFIDENTIAL_CODE",
  "PERSONAL_CODE": "PERSONAL_CODE"
};

// src/types/pension-api/pension-v3/types/ConsentRequestInput.ts
var consentRequestInputType4 = {
  "TRADE_UNION_MEMBERSHIP": "TRADE_UNION_MEMBERSHIP"
};

// src/types/pension-api/pension-v3/types/ConsentRequirement.ts
var consentRequirementType4 = {
  "TRADE_UNION_MEMBERSHIP": "TRADE_UNION_MEMBERSHIP"
};
var consentRequirementMethod4 = {
  "NONE": "NONE",
  "NOTICE": "NOTICE",
  "ACTIVE": "ACTIVE"
};

// src/types/pension-api/pension-v3/types/ContactFormInput.ts
var contactFormInputInputType = {
  "EMAIL": "EMAIL",
  "MOBILE_PHONE_NUMBER": "MOBILE_PHONE_NUMBER"
};

// src/types/pension-api/pension-v3/types/DatePeriod.ts
var datePeriodType = {
  "DATE_RANGE": "DATE_RANGE"
};

// src/types/pension-api/pension-v3/types/GetCompaniesStatus.ts
var getCompaniesStatusHeaderParamsInsurelyVersion3 = {
  "2022-09-26": "2022-09-26"
};

// src/types/pension-api/pension-v3/types/MonetaryAmount.ts
var monetaryAmountCurrencyCode3 = {
  "DKK": "DKK",
  "EUR": "EUR",
  "GBP": "GBP",
  "NOK": "NOK",
  "SEK": "SEK"
};

// src/types/pension-api/pension-v3/types/MovabilityResult.ts
var movabilityResultResult = {
  "NOT_MOVABLE": "NOT_MOVABLE",
  "MOVABLE": "MOVABLE",
  "UNKNOWN": "UNKNOWN"
};

// src/types/pension-api/pension-v3/types/MovabilityRuleResult.ts
var movabilityRuleResultRule = {
  "ACTIVE_PAYMENT": "ACTIVE_PAYMENT",
  "ACTIVE_PAYOUT": "ACTIVE_PAYOUT",
  "COMPATIBLE_PENSION_TYPE": "COMPATIBLE_PENSION_TYPE",
  "DEFAULT_RULE_NAME": "DEFAULT_RULE_NAME",
  "OLD_PENSION": "OLD_PENSION",
  "OLD_TRAD_PENSION": "OLD_TRAD_PENSION",
  "TRAD_PENSION": "TRAD_PENSION"
};
var movabilityRuleResultResult = {
  "NOT_MOVABLE": "NOT_MOVABLE",
  "MOVABLE": "MOVABLE",
  "UNKNOWN": "UNKNOWN"
};

// src/types/pension-api/pension-v3/types/PayoutPeriod.ts
var payoutPeriodType = {
  "AGE_RANGE": "AGE_RANGE",
  "DATE_RANGE": "DATE_RANGE"
};

// src/types/pension-api/pension-v3/types/PensionData.ts
var pensionDataPensionType2 = {
  "IPS_PENSION": "IPS_PENSION",
  "PRIVATE_PENSION": "PRIVATE_PENSION",
  "OCCUPATIONAL_PENSION": "OCCUPATIONAL_PENSION",
  "COLLECTIVE_OCCUPATIONAL_PENSION": "COLLECTIVE_OCCUPATIONAL_PENSION",
  "CAPITAL_INSURANCE": "CAPITAL_INSURANCE",
  "UNKNOWN_PENSION_TYPE": "UNKNOWN_PENSION_TYPE"
};
var pensionDataPensionClassification = {
  "ITP": "ITP",
  "FTP": "FTP",
  "KAP-KL": "KAP-KL",
  "SAF-LO": "SAF-LO",
  "PA16": "PA16",
  "PA-KFS": "PA-KFS",
  "GTP": "GTP",
  "BTP": "BTP",
  "PPA07": "PPA07",
  "PPA13": "PPA13",
  "UNKNOWN_PENSION_CLASSIFICATION": "UNKNOWN_PENSION_CLASSIFICATION"
};

// src/types/pension-api/pension-v3/types/ResponseObject.ts
var responseObjectType2 = {
  "RESPONSE_OBJECT": "RESPONSE_OBJECT"
};

// src/types/pension-api/pension-v3/types/SupplementInformation.ts
var supplementInformationType2 = {
  "TWO_FACTOR_CODE": "TWO_FACTOR_CODE",
  "RESPONSE_OBJECT": "RESPONSE_OBJECT"
};

// src/types/pension-api/pension-v3/types/TwoFactorAuthenticationInstruction.ts
var twoFactorAuthenticationInstructionResponseType2 = {
  "NUMBER_CODE": "NUMBER_CODE",
  "NO_RESPONSE": "NO_RESPONSE"
};

// src/types/pension-api/pension-v3/types/TwoFactorCode.ts
var twoFactorCodeType2 = {
  "TWO_FACTOR_CODE": "TWO_FACTOR_CODE"
};

// src/types/session-api/session-v2024-06-01/index.ts
var session_v2024_06_01_exports = {};

// src/types/wealth-api/wealth/index.ts
var wealth_exports = {};
__export(wealth_exports, {
  agePeriodType: () => agePeriodType2,
  collectionRequestFilterRuleField: () => collectionRequestFilterRuleField5,
  collectionRequestV5LoginMethod: () => collectionRequestV5LoginMethod,
  collectionStatusInformationMapRequiredInputTypes: () => collectionStatusInformationMapRequiredInputTypes3,
  collectionStatusV5Status: () => collectionStatusV5Status,
  companyAvailabilityCompanyAndLineOfBusinesses: () => companyAvailabilityCompanyAndLineOfBusinesses5,
  companyAvailabilityLoginMethods: () => companyAvailabilityLoginMethods5,
  companyAvailabilityNonFunctionalLoginMethods: () => companyAvailabilityNonFunctionalLoginMethods5,
  companyAvailabilityReason: () => companyAvailabilityReason5,
  companyAvailabilityStatus: () => companyAvailabilityStatus5,
  companyLoginConfigPasswordFieldPlaceholder: () => companyLoginConfigPasswordFieldPlaceholder5,
  companyLoginConfigPasswordLabel: () => companyLoginConfigPasswordLabel5,
  companyLoginConfigUsernameFieldPlaceholder: () => companyLoginConfigUsernameFieldPlaceholder5,
  companyLoginConfigUsernameLabel: () => companyLoginConfigUsernameLabel5,
  consentRequestInputType: () => consentRequestInputType5,
  consentRequirementMethod: () => consentRequirementMethod5,
  consentRequirementType: () => consentRequirementType5,
  contactFormInputInputType: () => contactFormInputInputType2,
  custodyAccountType: () => custodyAccountType,
  datePeriodType: () => datePeriodType2,
  financialProductType: () => financialProductType,
  getCompaniesStatusHeaderParamsInsurelyVersion: () => getCompaniesStatusHeaderParamsInsurelyVersion4,
  investmentUnknownType: () => investmentUnknownType,
  iskType: () => iskType,
  kfType: () => kfType,
  payoutPeriodType: () => payoutPeriodType2,
  pensionCollectiveOccupationalClassification: () => pensionCollectiveOccupationalClassification,
  pensionCollectiveOccupationalType: () => pensionCollectiveOccupationalType,
  pensionIpsClassification: () => pensionIpsClassification,
  pensionIpsType: () => pensionIpsType,
  pensionOccupationalClassification: () => pensionOccupationalClassification,
  pensionOccupationalType: () => pensionOccupationalType,
  pensionPrivateClassification: () => pensionPrivateClassification,
  pensionPrivateType: () => pensionPrivateType,
  pensionUnknownClassification: () => pensionUnknownClassification,
  pensionUnknownType: () => pensionUnknownType,
  responseObjectType: () => responseObjectType3,
  supplementInformationType: () => supplementInformationType3,
  twoFactorAuthenticationInstructionResponseType: () => twoFactorAuthenticationInstructionResponseType3,
  twoFactorCodeType: () => twoFactorCodeType3,
  wealthAddContactFormInputHeaderParamsInsurelyVersion: () => wealthAddContactFormInputHeaderParamsInsurelyVersion,
  wealthDataHeaderParamsInsurelyVersion: () => wealthDataHeaderParamsInsurelyVersion,
  wealthHoldingType: () => wealthHoldingType,
  wealthStartCollectionHeaderParamsInsurelyVersion: () => wealthStartCollectionHeaderParamsInsurelyVersion,
  wealthStatusHeaderParamsInsurelyVersion: () => wealthStatusHeaderParamsInsurelyVersion,
  wealthSupplementInformationHeaderParamsInsurelyVersion: () => wealthSupplementInformationHeaderParamsInsurelyVersion
});

// src/types/wealth-api/wealth/types/AgePeriod.ts
var agePeriodType2 = {
  "AGE_RANGE": "AGE_RANGE"
};

// src/types/wealth-api/wealth/types/CollectionRequestFilterRule.ts
var collectionRequestFilterRuleField5 = {
  "registrationNo": "registrationNo"
};

// src/types/wealth-api/wealth/types/CollectionRequestV5.ts
var collectionRequestV5LoginMethod = {
  "DANISH_NEMID": "DANISH_NEMID",
  "DANISH_MITID": "DANISH_MITID",
  "DANISH_MITID_SAME_DEVICE": "DANISH_MITID_SAME_DEVICE",
  "ESTONIAN_MOBILE_ID": "ESTONIAN_MOBILE_ID",
  "ESTONIAN_SMART_ID": "ESTONIAN_SMART_ID",
  "ESTONIAN_MOBILE_ID_USERNAME": "ESTONIAN_MOBILE_ID_USERNAME",
  "ESTONIAN_SMART_ID_USERNAME": "ESTONIAN_SMART_ID_USERNAME",
  "LATVIAN_MOBILE_EPARAKSTS": "LATVIAN_MOBILE_EPARAKSTS",
  "LATVIAN_SMART_ID": "LATVIAN_SMART_ID",
  "LATVIAN_MOBILE_EPARAKSTS_USERNAME": "LATVIAN_MOBILE_EPARAKSTS_USERNAME",
  "LATVIAN_SMART_ID_USERNAME": "LATVIAN_SMART_ID_USERNAME",
  "LITHUANIAN_SMART_ID": "LITHUANIAN_SMART_ID",
  "LITHUANIAN_MOBILE_ID": "LITHUANIAN_MOBILE_ID",
  "NORWEGIAN_BANKID_ON_MOBILE": "NORWEGIAN_BANKID_ON_MOBILE",
  "NORWEGIAN_BANKID_ON_MOBILE_FULL_PERSONAL_NUMBER": "NORWEGIAN_BANKID_ON_MOBILE_FULL_PERSONAL_NUMBER",
  "SWEDISH_MOBILE_BANKID_ANY_DEVICE": "SWEDISH_MOBILE_BANKID_ANY_DEVICE",
  "SWEDISH_MOBILE_BANKID_OTHER_DEVICE": "SWEDISH_MOBILE_BANKID_OTHER_DEVICE",
  "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_MOCK": "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_MOCK",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE": "SWEDISH_MOBILE_BANKID_SAME_DEVICE",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION": "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION_MOCK": "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION_MOCK",
  "SWEDISH_MOBILE_BANKID_ANY_DEVICE_TEST": "SWEDISH_MOBILE_BANKID_ANY_DEVICE_TEST",
  "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_TEST": "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_TEST",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE_TEST": "SWEDISH_MOBILE_BANKID_SAME_DEVICE_TEST",
  "SWEDISH_SECURITY_TOKEN": "SWEDISH_SECURITY_TOKEN",
  "UK_DOB_USERNAME_PASSWORD": "UK_DOB_USERNAME_PASSWORD",
  "UK_LASTNAME_MEMBERSHIP_NUMBER": "UK_LASTNAME_MEMBERSHIP_NUMBER",
  "UK_USERNAME_POSTCODE": "UK_USERNAME_POSTCODE",
  "USERNAME_AND_PASSWORD": "USERNAME_AND_PASSWORD",
  "EMAIL": "EMAIL",
  "PDF_UPLOAD": "PDF_UPLOAD"
};

// src/types/wealth-api/wealth/types/CollectionStatusInformationMap.ts
var collectionStatusInformationMapRequiredInputTypes3 = {
  "EMAIL": "EMAIL",
  "MOBILE_PHONE_NUMBER": "MOBILE_PHONE_NUMBER"
};

// src/types/wealth-api/wealth/types/CollectionStatusV5.ts
var collectionStatusV5Status = {
  "RUNNING": "RUNNING",
  "LOGIN": "LOGIN",
  "TWO_FACTOR_PENDING": "TWO_FACTOR_PENDING",
  "CONTACT_FORM_PENDING": "CONTACT_FORM_PENDING",
  "COLLECTING": "COLLECTING",
  "COMPLETED": "COMPLETED",
  "COMPLETED_PARTIAL": "COMPLETED_PARTIAL",
  "COMPLETED_EMPTY": "COMPLETED_EMPTY",
  "FAILED": "FAILED",
  "FAILED_PDF_PARSE": "FAILED_PDF_PARSE",
  "FAILED_PDF_USER_INPUT": "FAILED_PDF_USER_INPUT",
  "AUTHENTICATION_TIMEOUT": "AUTHENTICATION_TIMEOUT",
  "WAITING_FOR_USER_ACTION": "WAITING_FOR_USER_ACTION",
  "INCORRECT_CREDENTIALS": "INCORRECT_CREDENTIALS",
  "AUTHENTICATION_CANCELLED": "AUTHENTICATION_CANCELLED",
  "AUTHENTICATION_CONFLICT": "AUTHENTICATION_CONFLICT",
  "AUTHENTICATION_MISMATCH": "AUTHENTICATION_MISMATCH",
  "KYC_FORM": "KYC_FORM",
  "CONTACT_FORM": "CONTACT_FORM",
  "CUSTOMER_ENROLLMENT_REQUIRED": "CUSTOMER_ENROLLMENT_REQUIRED",
  "THIRD_PARTY_ERROR": "THIRD_PARTY_ERROR"
};

// src/types/wealth-api/wealth/types/CompanyAvailability.ts
var companyAvailabilityStatus5 = {
  "OK": "OK",
  "BETA": "BETA",
  "NOT_IMPLEMENTED": "NOT_IMPLEMENTED"
};
var companyAvailabilityReason5 = {
  "THIRD_PARTY_ERROR": "THIRD_PARTY_ERROR",
  "THIRD_PARTY_UPDATE": "THIRD_PARTY_UPDATE",
  "INSURELY_ERROR": "INSURELY_ERROR",
  "INSURELY_UPDATE": "INSURELY_UPDATE",
  "RECONSTRUCTION": "RECONSTRUCTION"
};
var companyAvailabilityLoginMethods5 = {
  "DANISH_NEMID": "DANISH_NEMID",
  "DANISH_MITID": "DANISH_MITID",
  "DANISH_MITID_SAME_DEVICE": "DANISH_MITID_SAME_DEVICE",
  "ESTONIAN_MOBILE_ID": "ESTONIAN_MOBILE_ID",
  "ESTONIAN_SMART_ID": "ESTONIAN_SMART_ID",
  "ESTONIAN_MOBILE_ID_USERNAME": "ESTONIAN_MOBILE_ID_USERNAME",
  "ESTONIAN_SMART_ID_USERNAME": "ESTONIAN_SMART_ID_USERNAME",
  "LATVIAN_MOBILE_EPARAKSTS": "LATVIAN_MOBILE_EPARAKSTS",
  "LATVIAN_SMART_ID": "LATVIAN_SMART_ID",
  "LATVIAN_MOBILE_EPARAKSTS_USERNAME": "LATVIAN_MOBILE_EPARAKSTS_USERNAME",
  "LATVIAN_SMART_ID_USERNAME": "LATVIAN_SMART_ID_USERNAME",
  "LITHUANIAN_SMART_ID": "LITHUANIAN_SMART_ID",
  "LITHUANIAN_MOBILE_ID": "LITHUANIAN_MOBILE_ID",
  "NORWEGIAN_BANKID_ON_MOBILE": "NORWEGIAN_BANKID_ON_MOBILE",
  "NORWEGIAN_BANKID_ON_MOBILE_FULL_PERSONAL_NUMBER": "NORWEGIAN_BANKID_ON_MOBILE_FULL_PERSONAL_NUMBER",
  "SWEDISH_MOBILE_BANKID_ANY_DEVICE": "SWEDISH_MOBILE_BANKID_ANY_DEVICE",
  "SWEDISH_MOBILE_BANKID_OTHER_DEVICE": "SWEDISH_MOBILE_BANKID_OTHER_DEVICE",
  "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_MOCK": "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_MOCK",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE": "SWEDISH_MOBILE_BANKID_SAME_DEVICE",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION": "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION_MOCK": "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION_MOCK",
  "SWEDISH_MOBILE_BANKID_ANY_DEVICE_TEST": "SWEDISH_MOBILE_BANKID_ANY_DEVICE_TEST",
  "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_TEST": "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_TEST",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE_TEST": "SWEDISH_MOBILE_BANKID_SAME_DEVICE_TEST",
  "SWEDISH_SECURITY_TOKEN": "SWEDISH_SECURITY_TOKEN",
  "UK_DOB_USERNAME_PASSWORD": "UK_DOB_USERNAME_PASSWORD",
  "UK_LASTNAME_MEMBERSHIP_NUMBER": "UK_LASTNAME_MEMBERSHIP_NUMBER",
  "UK_USERNAME_POSTCODE": "UK_USERNAME_POSTCODE",
  "USERNAME_AND_PASSWORD": "USERNAME_AND_PASSWORD",
  "EMAIL": "EMAIL",
  "PDF_UPLOAD": "PDF_UPLOAD"
};
var companyAvailabilityNonFunctionalLoginMethods5 = {
  "DANISH_NEMID": "DANISH_NEMID",
  "DANISH_MITID": "DANISH_MITID",
  "DANISH_MITID_SAME_DEVICE": "DANISH_MITID_SAME_DEVICE",
  "ESTONIAN_MOBILE_ID": "ESTONIAN_MOBILE_ID",
  "ESTONIAN_SMART_ID": "ESTONIAN_SMART_ID",
  "ESTONIAN_MOBILE_ID_USERNAME": "ESTONIAN_MOBILE_ID_USERNAME",
  "ESTONIAN_SMART_ID_USERNAME": "ESTONIAN_SMART_ID_USERNAME",
  "LATVIAN_MOBILE_EPARAKSTS": "LATVIAN_MOBILE_EPARAKSTS",
  "LATVIAN_SMART_ID": "LATVIAN_SMART_ID",
  "LATVIAN_MOBILE_EPARAKSTS_USERNAME": "LATVIAN_MOBILE_EPARAKSTS_USERNAME",
  "LATVIAN_SMART_ID_USERNAME": "LATVIAN_SMART_ID_USERNAME",
  "LITHUANIAN_SMART_ID": "LITHUANIAN_SMART_ID",
  "LITHUANIAN_MOBILE_ID": "LITHUANIAN_MOBILE_ID",
  "NORWEGIAN_BANKID_ON_MOBILE": "NORWEGIAN_BANKID_ON_MOBILE",
  "NORWEGIAN_BANKID_ON_MOBILE_FULL_PERSONAL_NUMBER": "NORWEGIAN_BANKID_ON_MOBILE_FULL_PERSONAL_NUMBER",
  "SWEDISH_MOBILE_BANKID_ANY_DEVICE": "SWEDISH_MOBILE_BANKID_ANY_DEVICE",
  "SWEDISH_MOBILE_BANKID_OTHER_DEVICE": "SWEDISH_MOBILE_BANKID_OTHER_DEVICE",
  "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_MOCK": "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_MOCK",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE": "SWEDISH_MOBILE_BANKID_SAME_DEVICE",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION": "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION_MOCK": "SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION_MOCK",
  "SWEDISH_MOBILE_BANKID_ANY_DEVICE_TEST": "SWEDISH_MOBILE_BANKID_ANY_DEVICE_TEST",
  "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_TEST": "SWEDISH_MOBILE_BANKID_OTHER_DEVICE_TEST",
  "SWEDISH_MOBILE_BANKID_SAME_DEVICE_TEST": "SWEDISH_MOBILE_BANKID_SAME_DEVICE_TEST",
  "SWEDISH_SECURITY_TOKEN": "SWEDISH_SECURITY_TOKEN",
  "UK_DOB_USERNAME_PASSWORD": "UK_DOB_USERNAME_PASSWORD",
  "UK_LASTNAME_MEMBERSHIP_NUMBER": "UK_LASTNAME_MEMBERSHIP_NUMBER",
  "UK_USERNAME_POSTCODE": "UK_USERNAME_POSTCODE",
  "USERNAME_AND_PASSWORD": "USERNAME_AND_PASSWORD",
  "EMAIL": "EMAIL",
  "PDF_UPLOAD": "PDF_UPLOAD"
};
var companyAvailabilityCompanyAndLineOfBusinesses5 = {
  "EE_SWEDBANK": "EE_SWEDBANK",
  "FR_ALLIANZ_HOME": "FR_ALLIANZ_HOME",
  "FR_ALLIANZ_VEHICLE": "FR_ALLIANZ_VEHICLE",
  "FR_ANIMAUXSANTE_HOME": "FR_ANIMAUXSANTE_HOME",
  "FR_ASSUR_OPOIL_ANIMAL": "FR_ASSUR_OPOIL_ANIMAL",
  "FR_AXA_HOME": "FR_AXA_HOME",
  "FR_AXA_VEHICLE": "FR_AXA_VEHICLE",
  "FR_AXA_GENERAL": "FR_AXA_GENERAL",
  "FR_BANQUE_POPULAIRE_HOME": "FR_BANQUE_POPULAIRE_HOME",
  "FR_BULLE_BLEUE_HOME": "FR_BULLE_BLEUE_HOME",
  "FR_CAISSE_DEPARGNE_HOME": "FR_CAISSE_DEPARGNE_HOME",
  "FR_CARDIF_HOME": "FR_CARDIF_HOME",
  "FR_CREDIT_AGRICOLE_HOME": "FR_CREDIT_AGRICOLE_HOME",
  "FR_CREDIT_AGRICOLE_VEHICLE": "FR_CREDIT_AGRICOLE_VEHICLE",
  "FR_CREDIT_MUTUEL_HOME": "FR_CREDIT_MUTUEL_HOME",
  "FR_CREDIT_MUTUEL_VEHICLE": "FR_CREDIT_MUTUEL_VEHICLE",
  "FR_DEMO_HOME": "FR_DEMO_HOME",
  "FR_DEMO_VEHICLE": "FR_DEMO_VEHICLE",
  "FR_DIRECT_ASSURANCE_HOME": "FR_DIRECT_ASSURANCE_HOME",
  "FR_DIRECT_ASSURANCE_VEHICLE": "FR_DIRECT_ASSURANCE_VEHICLE",
  "FR_ECA_HOME": "FR_ECA_HOME",
  "FR_ECA_ANIMAL": "FR_ECA_ANIMAL",
  "FR_GENERALI_HOME": "FR_GENERALI_HOME",
  "FR_GENERALI_VEHICLE": "FR_GENERALI_VEHICLE",
  "FR_GMF_HOME": "FR_GMF_HOME",
  "FR_GMF_VEHICLE": "FR_GMF_VEHICLE",
  "FR_GROUPAMA_HOME": "FR_GROUPAMA_HOME",
  "FR_GROUPAMA_VEHICLE": "FR_GROUPAMA_VEHICLE",
  "FR_LUKO_HOME": "FR_LUKO_HOME",
  "FR_MAAF_HOME": "FR_MAAF_HOME",
  "FR_MAAF_VEHICLE": "FR_MAAF_VEHICLE",
  "FR_MACIF_HOME": "FR_MACIF_HOME",
  "FR_MACIF_VEHICLE": "FR_MACIF_VEHICLE",
  "FR_MAIF_HOME": "FR_MAIF_HOME",
  "FR_MAIF_VEHICLE": "FR_MAIF_VEHICLE",
  "FR_MATMUT_HOME": "FR_MATMUT_HOME",
  "FR_MMA_HOME": "FR_MMA_HOME",
  "FR_MMA_VEHICLE": "FR_MMA_VEHICLE",
  "FR_SANTEVET_HOME": "FR_SANTEVET_HOME",
  "SE_IF_VEHICLE": "SE_IF_VEHICLE",
  "SE_FOLKSAM_VEHICLE": "SE_FOLKSAM_VEHICLE",
  "SE_LANSFORSAKRINGAR_HOME": "SE_LANSFORSAKRINGAR_HOME",
  "SE_PAYDRIVE_VEHICLE": "SE_PAYDRIVE_VEHICLE",
  "SE_SVEDEA_VEHICLE": "SE_SVEDEA_VEHICLE",
  "SE_VOLVIA_VEHICLE": "SE_VOLVIA_VEHICLE",
  "SE_BLIWA_ACCIDENT": "SE_BLIWA_ACCIDENT",
  "UK_AXA_HOME": "UK_AXA_HOME",
  "UK_AXA_VEHICLE": "UK_AXA_VEHICLE",
  "UK_HASTINGS_DIRECT_HOME": "UK_HASTINGS_DIRECT_HOME",
  "UK_HASTINGS_DIRECT_VEHICLE": "UK_HASTINGS_DIRECT_VEHICLE",
  "UK_POLICYEXPERT_HOME": "UK_POLICYEXPERT_HOME",
  "UK_POLICYEXPERT_VEHICLE": "UK_POLICYEXPERT_VEHICLE",
  "UK_POST_OFFICE_HOME": "UK_POST_OFFICE_HOME",
  "UK_THE_AA_HOME": "UK_THE_AA_HOME",
  "UK_THE_AA_VEHICLE": "UK_THE_AA_VEHICLE",
  "UK_URBAN_JUNGLE_HOME": "UK_URBAN_JUNGLE_HOME",
  "FR_AXA_PERSON": "FR_AXA_PERSON",
  "FR_ACHEEL_HOME": "FR_ACHEEL_HOME"
};

// src/types/wealth-api/wealth/types/CompanyLoginConfig.ts
var companyLoginConfigUsernameLabel5 = {
  "EMAIL": "EMAIL",
  "USERNAME": "USERNAME"
};
var companyLoginConfigUsernameFieldPlaceholder5 = {
  "EMAIL": "EMAIL",
  "IDENTIFICATION_NUMBER_11": "IDENTIFICATION_NUMBER_11",
  "IDENTIFICATION_CHARACTERS_8": "IDENTIFICATION_CHARACTERS_8",
  "EMAIL_MOBILE_MUTUAL_MEMBER": "EMAIL_MOBILE_MUTUAL_MEMBER",
  "EMAIL_MOBILE_CLIENT": "EMAIL_MOBILE_CLIENT",
  "EMAIL_MUTUAL_OR_REGULAR_MEMBER": "EMAIL_MUTUAL_OR_REGULAR_MEMBER",
  "EMAIL_MOBILE_CONTRACT": "EMAIL_MOBILE_CONTRACT",
  "EMAIL_OR_MEMBER": "EMAIL_OR_MEMBER"
};
var companyLoginConfigPasswordLabel5 = {
  "PASSWORD": "PASSWORD",
  "CONFIDENTIAL_CODE": "CONFIDENTIAL_CODE",
  "PERSONAL_CODE": "PERSONAL_CODE"
};
var companyLoginConfigPasswordFieldPlaceholder5 = {
  "PASSWORD": "PASSWORD",
  "CONFIDENTIAL_CODE": "CONFIDENTIAL_CODE",
  "PERSONAL_CODE": "PERSONAL_CODE"
};

// src/types/wealth-api/wealth/types/ConsentRequestInput.ts
var consentRequestInputType5 = {
  "TRADE_UNION_MEMBERSHIP": "TRADE_UNION_MEMBERSHIP"
};

// src/types/wealth-api/wealth/types/ConsentRequirement.ts
var consentRequirementType5 = {
  "TRADE_UNION_MEMBERSHIP": "TRADE_UNION_MEMBERSHIP"
};
var consentRequirementMethod5 = {
  "NONE": "NONE",
  "NOTICE": "NOTICE",
  "ACTIVE": "ACTIVE"
};

// src/types/wealth-api/wealth/types/ContactFormInput.ts
var contactFormInputInputType2 = {
  "EMAIL": "EMAIL",
  "MOBILE_PHONE_NUMBER": "MOBILE_PHONE_NUMBER"
};

// src/types/wealth-api/wealth/types/CustodyAccount.ts
var custodyAccountType = {
  "KF": "KF",
  "ISK": "ISK",
  "CUSTODY_ACCOUNT": "CUSTODY_ACCOUNT",
  "UNKNOWN_INVESTMENT_TYPE": "UNKNOWN_INVESTMENT_TYPE",
  "IPS_PENSION": "IPS_PENSION",
  "PRIVATE_PENSION": "PRIVATE_PENSION",
  "OCCUPATIONAL_PENSION": "OCCUPATIONAL_PENSION",
  "COLLECTIVE_OCCUPATIONAL_PENSION": "COLLECTIVE_OCCUPATIONAL_PENSION",
  "UNKNOWN_PENSION_TYPE": "UNKNOWN_PENSION_TYPE"
};

// src/types/wealth-api/wealth/types/DatePeriod.ts
var datePeriodType2 = {
  "DATE_RANGE": "DATE_RANGE"
};

// src/types/wealth-api/wealth/types/FinancialProduct.ts
var financialProductType = {
  "KF": "KF",
  "ISK": "ISK",
  "CUSTODY_ACCOUNT": "CUSTODY_ACCOUNT",
  "UNKNOWN_INVESTMENT_TYPE": "UNKNOWN_INVESTMENT_TYPE",
  "IPS_PENSION": "IPS_PENSION",
  "PRIVATE_PENSION": "PRIVATE_PENSION",
  "OCCUPATIONAL_PENSION": "OCCUPATIONAL_PENSION",
  "COLLECTIVE_OCCUPATIONAL_PENSION": "COLLECTIVE_OCCUPATIONAL_PENSION",
  "UNKNOWN_PENSION_TYPE": "UNKNOWN_PENSION_TYPE"
};

// src/types/wealth-api/wealth/types/GetCompaniesStatus.ts
var getCompaniesStatusHeaderParamsInsurelyVersion4 = {
  "2024-06-01": "2024-06-01"
};

// src/types/wealth-api/wealth/types/InvestmentUnknown.ts
var investmentUnknownType = {
  "KF": "KF",
  "ISK": "ISK",
  "CUSTODY_ACCOUNT": "CUSTODY_ACCOUNT",
  "UNKNOWN_INVESTMENT_TYPE": "UNKNOWN_INVESTMENT_TYPE",
  "IPS_PENSION": "IPS_PENSION",
  "PRIVATE_PENSION": "PRIVATE_PENSION",
  "OCCUPATIONAL_PENSION": "OCCUPATIONAL_PENSION",
  "COLLECTIVE_OCCUPATIONAL_PENSION": "COLLECTIVE_OCCUPATIONAL_PENSION",
  "UNKNOWN_PENSION_TYPE": "UNKNOWN_PENSION_TYPE"
};

// src/types/wealth-api/wealth/types/Isk.ts
var iskType = {
  "KF": "KF",
  "ISK": "ISK",
  "CUSTODY_ACCOUNT": "CUSTODY_ACCOUNT",
  "UNKNOWN_INVESTMENT_TYPE": "UNKNOWN_INVESTMENT_TYPE",
  "IPS_PENSION": "IPS_PENSION",
  "PRIVATE_PENSION": "PRIVATE_PENSION",
  "OCCUPATIONAL_PENSION": "OCCUPATIONAL_PENSION",
  "COLLECTIVE_OCCUPATIONAL_PENSION": "COLLECTIVE_OCCUPATIONAL_PENSION",
  "UNKNOWN_PENSION_TYPE": "UNKNOWN_PENSION_TYPE"
};

// src/types/wealth-api/wealth/types/Kf.ts
var kfType = {
  "KF": "KF",
  "ISK": "ISK",
  "CUSTODY_ACCOUNT": "CUSTODY_ACCOUNT",
  "UNKNOWN_INVESTMENT_TYPE": "UNKNOWN_INVESTMENT_TYPE",
  "IPS_PENSION": "IPS_PENSION",
  "PRIVATE_PENSION": "PRIVATE_PENSION",
  "OCCUPATIONAL_PENSION": "OCCUPATIONAL_PENSION",
  "COLLECTIVE_OCCUPATIONAL_PENSION": "COLLECTIVE_OCCUPATIONAL_PENSION",
  "UNKNOWN_PENSION_TYPE": "UNKNOWN_PENSION_TYPE"
};

// src/types/wealth-api/wealth/types/PayoutPeriod.ts
var payoutPeriodType2 = {
  "AGE_RANGE": "AGE_RANGE",
  "DATE_RANGE": "DATE_RANGE"
};

// src/types/wealth-api/wealth/types/PensionCollectiveOccupational.ts
var pensionCollectiveOccupationalClassification = {
  "ITP": "ITP",
  "FTP": "FTP",
  "KAP-KL": "KAP-KL",
  "SAF-LO": "SAF-LO",
  "PA16": "PA16",
  "PA-KFS": "PA-KFS",
  "GTP": "GTP",
  "BTP": "BTP",
  "PPA07": "PPA07",
  "PPA13": "PPA13",
  "UNKNOWN_PENSION_CLASSIFICATION": "UNKNOWN_PENSION_CLASSIFICATION"
};
var pensionCollectiveOccupationalType = {
  "KF": "KF",
  "ISK": "ISK",
  "CUSTODY_ACCOUNT": "CUSTODY_ACCOUNT",
  "UNKNOWN_INVESTMENT_TYPE": "UNKNOWN_INVESTMENT_TYPE",
  "IPS_PENSION": "IPS_PENSION",
  "PRIVATE_PENSION": "PRIVATE_PENSION",
  "OCCUPATIONAL_PENSION": "OCCUPATIONAL_PENSION",
  "COLLECTIVE_OCCUPATIONAL_PENSION": "COLLECTIVE_OCCUPATIONAL_PENSION",
  "UNKNOWN_PENSION_TYPE": "UNKNOWN_PENSION_TYPE"
};

// src/types/wealth-api/wealth/types/PensionIps.ts
var pensionIpsClassification = {
  "ITP": "ITP",
  "FTP": "FTP",
  "KAP-KL": "KAP-KL",
  "SAF-LO": "SAF-LO",
  "PA16": "PA16",
  "PA-KFS": "PA-KFS",
  "GTP": "GTP",
  "BTP": "BTP",
  "PPA07": "PPA07",
  "PPA13": "PPA13",
  "UNKNOWN_PENSION_CLASSIFICATION": "UNKNOWN_PENSION_CLASSIFICATION"
};
var pensionIpsType = {
  "KF": "KF",
  "ISK": "ISK",
  "CUSTODY_ACCOUNT": "CUSTODY_ACCOUNT",
  "UNKNOWN_INVESTMENT_TYPE": "UNKNOWN_INVESTMENT_TYPE",
  "IPS_PENSION": "IPS_PENSION",
  "PRIVATE_PENSION": "PRIVATE_PENSION",
  "OCCUPATIONAL_PENSION": "OCCUPATIONAL_PENSION",
  "COLLECTIVE_OCCUPATIONAL_PENSION": "COLLECTIVE_OCCUPATIONAL_PENSION",
  "UNKNOWN_PENSION_TYPE": "UNKNOWN_PENSION_TYPE"
};

// src/types/wealth-api/wealth/types/PensionOccupational.ts
var pensionOccupationalClassification = {
  "ITP": "ITP",
  "FTP": "FTP",
  "KAP-KL": "KAP-KL",
  "SAF-LO": "SAF-LO",
  "PA16": "PA16",
  "PA-KFS": "PA-KFS",
  "GTP": "GTP",
  "BTP": "BTP",
  "PPA07": "PPA07",
  "PPA13": "PPA13",
  "UNKNOWN_PENSION_CLASSIFICATION": "UNKNOWN_PENSION_CLASSIFICATION"
};
var pensionOccupationalType = {
  "KF": "KF",
  "ISK": "ISK",
  "CUSTODY_ACCOUNT": "CUSTODY_ACCOUNT",
  "UNKNOWN_INVESTMENT_TYPE": "UNKNOWN_INVESTMENT_TYPE",
  "IPS_PENSION": "IPS_PENSION",
  "PRIVATE_PENSION": "PRIVATE_PENSION",
  "OCCUPATIONAL_PENSION": "OCCUPATIONAL_PENSION",
  "COLLECTIVE_OCCUPATIONAL_PENSION": "COLLECTIVE_OCCUPATIONAL_PENSION",
  "UNKNOWN_PENSION_TYPE": "UNKNOWN_PENSION_TYPE"
};

// src/types/wealth-api/wealth/types/PensionPrivate.ts
var pensionPrivateClassification = {
  "ITP": "ITP",
  "FTP": "FTP",
  "KAP-KL": "KAP-KL",
  "SAF-LO": "SAF-LO",
  "PA16": "PA16",
  "PA-KFS": "PA-KFS",
  "GTP": "GTP",
  "BTP": "BTP",
  "PPA07": "PPA07",
  "PPA13": "PPA13",
  "UNKNOWN_PENSION_CLASSIFICATION": "UNKNOWN_PENSION_CLASSIFICATION"
};
var pensionPrivateType = {
  "KF": "KF",
  "ISK": "ISK",
  "CUSTODY_ACCOUNT": "CUSTODY_ACCOUNT",
  "UNKNOWN_INVESTMENT_TYPE": "UNKNOWN_INVESTMENT_TYPE",
  "IPS_PENSION": "IPS_PENSION",
  "PRIVATE_PENSION": "PRIVATE_PENSION",
  "OCCUPATIONAL_PENSION": "OCCUPATIONAL_PENSION",
  "COLLECTIVE_OCCUPATIONAL_PENSION": "COLLECTIVE_OCCUPATIONAL_PENSION",
  "UNKNOWN_PENSION_TYPE": "UNKNOWN_PENSION_TYPE"
};

// src/types/wealth-api/wealth/types/PensionUnknown.ts
var pensionUnknownClassification = {
  "ITP": "ITP",
  "FTP": "FTP",
  "KAP-KL": "KAP-KL",
  "SAF-LO": "SAF-LO",
  "PA16": "PA16",
  "PA-KFS": "PA-KFS",
  "GTP": "GTP",
  "BTP": "BTP",
  "PPA07": "PPA07",
  "PPA13": "PPA13",
  "UNKNOWN_PENSION_CLASSIFICATION": "UNKNOWN_PENSION_CLASSIFICATION"
};
var pensionUnknownType = {
  "KF": "KF",
  "ISK": "ISK",
  "CUSTODY_ACCOUNT": "CUSTODY_ACCOUNT",
  "UNKNOWN_INVESTMENT_TYPE": "UNKNOWN_INVESTMENT_TYPE",
  "IPS_PENSION": "IPS_PENSION",
  "PRIVATE_PENSION": "PRIVATE_PENSION",
  "OCCUPATIONAL_PENSION": "OCCUPATIONAL_PENSION",
  "COLLECTIVE_OCCUPATIONAL_PENSION": "COLLECTIVE_OCCUPATIONAL_PENSION",
  "UNKNOWN_PENSION_TYPE": "UNKNOWN_PENSION_TYPE"
};

// src/types/wealth-api/wealth/types/ResponseObject.ts
var responseObjectType3 = {
  "RESPONSE_OBJECT": "RESPONSE_OBJECT"
};

// src/types/wealth-api/wealth/types/SupplementInformation.ts
var supplementInformationType3 = {
  "TWO_FACTOR_CODE": "TWO_FACTOR_CODE",
  "RESPONSE_OBJECT": "RESPONSE_OBJECT"
};

// src/types/wealth-api/wealth/types/TwoFactorAuthenticationInstruction.ts
var twoFactorAuthenticationInstructionResponseType3 = {
  "NUMBER_CODE": "NUMBER_CODE",
  "NO_RESPONSE": "NO_RESPONSE"
};

// src/types/wealth-api/wealth/types/TwoFactorCode.ts
var twoFactorCodeType3 = {
  "TWO_FACTOR_CODE": "TWO_FACTOR_CODE"
};

// src/types/wealth-api/wealth/types/WealthAddContactFormInput.ts
var wealthAddContactFormInputHeaderParamsInsurelyVersion = {
  "2024-06-01": "2024-06-01"
};

// src/types/wealth-api/wealth/types/WealthData.ts
var wealthDataHeaderParamsInsurelyVersion = {
  "2024-06-01": "2024-06-01"
};

// src/types/wealth-api/wealth/types/WealthStartCollection.ts
var wealthStartCollectionHeaderParamsInsurelyVersion = {
  "2024-06-01": "2024-06-01"
};

// src/types/wealth-api/wealth/types/WealthStatus.ts
var wealthStatusHeaderParamsInsurelyVersion = {
  "2024-06-01": "2024-06-01"
};

// src/types/wealth-api/wealth/types/WealthSupplementInformation.ts
var wealthSupplementInformationHeaderParamsInsurelyVersion = {
  "2024-06-01": "2024-06-01"
};

// src/types/wealth-api/wealth/types/wealth/Holding.ts
var wealthHoldingType = {
  "EQUITY": "EQUITY",
  "FUND": "FUND"
};
export {
  cancellations_exports as Cancellations,
  export_v2023_06_05_exports as ExportV20230605,
  export_v2024_06_01_exports as ExportV20240601,
  v3_exports as InsuranceApiV3,
  v4_exports as InsuranceApiV4,
  pension_v2_exports as PensionApiV2,
  pension_v3_exports as PensionApiV3,
  session_v2024_06_01_exports as SessionApiV20240601,
  wealth_exports as Wealth
};
//# sourceMappingURL=index.mjs.map